(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireca7d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireca7d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ccFxc", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8e26d2edf298385d$export$ffb0004e005737fa; }, function (v) { return $8e26d2edf298385d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8e26d2edf298385d$export$34b9dba7ce09269b; }, function (v) { return $8e26d2edf298385d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8e26d2edf298385d$export$25062201e9e25d76; }, function (v) { return $8e26d2edf298385d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e26d2edf298385d$export$ffb0004e005737fa;
var $8e26d2edf298385d$export$34b9dba7ce09269b;
var $8e26d2edf298385d$export$25062201e9e25d76;
"use strict";
var $8e26d2edf298385d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8e26d2edf298385d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $8e26d2edf298385d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $8e26d2edf298385d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$8e26d2edf298385d$export$ffb0004e005737fa = $8e26d2edf298385d$var$REACT_FRAGMENT_TYPE;
$8e26d2edf298385d$export$34b9dba7ce09269b = $8e26d2edf298385d$var$jsxProd;
$8e26d2edf298385d$export$25062201e9e25d76 = $8e26d2edf298385d$var$jsxProd;

});

parcelRegister("1aGg9", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $0da7817f7132e823$export$9c16c1426311996d; }, function (v) { return $0da7817f7132e823$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $0da7817f7132e823$export$dca3b0875bd9a954; }, function (v) { return $0da7817f7132e823$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0da7817f7132e823$export$16fa2f45be04daa8; }, function (v) { return $0da7817f7132e823$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0da7817f7132e823$export$ffb0004e005737fa; }, function (v) { return $0da7817f7132e823$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0da7817f7132e823$export$e2c29f18771995cb; }, function (v) { return $0da7817f7132e823$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0da7817f7132e823$export$221d75b3f55bb0bd; }, function (v) { return $0da7817f7132e823$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0da7817f7132e823$export$5f8d39834fd61797; }, function (v) { return $0da7817f7132e823$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0da7817f7132e823$export$74bf444e3cd11ea5; }, function (v) { return $0da7817f7132e823$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $0da7817f7132e823$export$1ced07cd6b1985ce; }, function (v) { return $0da7817f7132e823$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $0da7817f7132e823$export$abd8e32b826d7ea7; }, function (v) { return $0da7817f7132e823$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $0da7817f7132e823$export$69a3209f1a06c04d; }, function (v) { return $0da7817f7132e823$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $0da7817f7132e823$export$8c538325882c7eec; }, function (v) { return $0da7817f7132e823$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0da7817f7132e823$export$e530037191fcd5d7; }, function (v) { return $0da7817f7132e823$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0da7817f7132e823$export$fd42f52fd3ae1109; }, function (v) { return $0da7817f7132e823$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0da7817f7132e823$export$c8a8987d4410bf2d; }, function (v) { return $0da7817f7132e823$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $0da7817f7132e823$export$7d1e3a5e95ceca43; }, function (v) { return $0da7817f7132e823$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0da7817f7132e823$export$257a8862b851cb5b; }, function (v) { return $0da7817f7132e823$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0da7817f7132e823$export$a8257692ac88316c; }, function (v) { return $0da7817f7132e823$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0da7817f7132e823$export$488013bae63b21da; }, function (v) { return $0da7817f7132e823$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0da7817f7132e823$export$7c73462e0d25e514; }, function (v) { return $0da7817f7132e823$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0da7817f7132e823$export$7568632d0d33d16d; }, function (v) { return $0da7817f7132e823$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $0da7817f7132e823$export$f93f40ac0ca7e3a8; }, function (v) { return $0da7817f7132e823$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $0da7817f7132e823$export$1f96ae73734a86cc; }, function (v) { return $0da7817f7132e823$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $0da7817f7132e823$export$9a47ced3238df325; }, function (v) { return $0da7817f7132e823$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0da7817f7132e823$export$35808ee640e87ca7; }, function (v) { return $0da7817f7132e823$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0da7817f7132e823$export$fae74005e78b1a27; }, function (v) { return $0da7817f7132e823$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0da7817f7132e823$export$dc8fbce3eb94dc1e; }, function (v) { return $0da7817f7132e823$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0da7817f7132e823$export$6a7bc4e911dc01cf; }, function (v) { return $0da7817f7132e823$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0da7817f7132e823$export$6d9c69b0de29b591; }, function (v) { return $0da7817f7132e823$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $0da7817f7132e823$export$7f54fc3180508a52; }, function (v) { return $0da7817f7132e823$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $0da7817f7132e823$export$f680877a34711e37; }, function (v) { return $0da7817f7132e823$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0da7817f7132e823$export$d5a552a76deda3c2; }, function (v) { return $0da7817f7132e823$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0da7817f7132e823$export$aaabe4eda9ed9969; }, function (v) { return $0da7817f7132e823$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0da7817f7132e823$export$e5c5a5f917a5871c; }, function (v) { return $0da7817f7132e823$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0da7817f7132e823$export$1538c33de8887b59; }, function (v) { return $0da7817f7132e823$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $0da7817f7132e823$export$fca7f784ae7a249a; }, function (v) { return $0da7817f7132e823$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $0da7817f7132e823$export$13e3392192263954; }, function (v) { return $0da7817f7132e823$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0da7817f7132e823$export$b8f5890fc79d6aca; }, function (v) { return $0da7817f7132e823$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0da7817f7132e823$export$60241385465d0a34; }, function (v) { return $0da7817f7132e823$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0da7817f7132e823$export$306c0aa65ff9ec16; }, function (v) { return $0da7817f7132e823$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0da7817f7132e823$export$7b286972b8d8ccbf; }, function (v) { return $0da7817f7132e823$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0da7817f7132e823$export$83d89fbfd8236492; }, function (v) { return $0da7817f7132e823$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0da7817f7132e823$export$9c16c1426311996d;
var $0da7817f7132e823$export$dca3b0875bd9a954;
var $0da7817f7132e823$export$16fa2f45be04daa8;
var $0da7817f7132e823$export$ffb0004e005737fa;
var $0da7817f7132e823$export$e2c29f18771995cb;
var $0da7817f7132e823$export$221d75b3f55bb0bd;
var $0da7817f7132e823$export$5f8d39834fd61797;
var $0da7817f7132e823$export$74bf444e3cd11ea5;
var $0da7817f7132e823$export$1ced07cd6b1985ce;
var $0da7817f7132e823$export$abd8e32b826d7ea7;
var $0da7817f7132e823$export$69a3209f1a06c04d;
var $0da7817f7132e823$export$8c538325882c7eec;
var $0da7817f7132e823$export$e530037191fcd5d7;
var $0da7817f7132e823$export$fd42f52fd3ae1109;
var $0da7817f7132e823$export$c8a8987d4410bf2d;
var $0da7817f7132e823$export$7d1e3a5e95ceca43;
var $0da7817f7132e823$export$257a8862b851cb5b;
var $0da7817f7132e823$export$a8257692ac88316c;
var $0da7817f7132e823$export$488013bae63b21da;
var $0da7817f7132e823$export$7c73462e0d25e514;
var $0da7817f7132e823$export$7568632d0d33d16d;
var $0da7817f7132e823$export$f93f40ac0ca7e3a8;
var $0da7817f7132e823$export$1f96ae73734a86cc;
var $0da7817f7132e823$export$9a47ced3238df325;
var $0da7817f7132e823$export$35808ee640e87ca7;
var $0da7817f7132e823$export$fae74005e78b1a27;
var $0da7817f7132e823$export$dc8fbce3eb94dc1e;
var $0da7817f7132e823$export$6a7bc4e911dc01cf;
var $0da7817f7132e823$export$6d9c69b0de29b591;
var $0da7817f7132e823$export$7f54fc3180508a52;
var $0da7817f7132e823$export$f680877a34711e37;
var $0da7817f7132e823$export$d5a552a76deda3c2;
var $0da7817f7132e823$export$aaabe4eda9ed9969;
var $0da7817f7132e823$export$e5c5a5f917a5871c;
var $0da7817f7132e823$export$1538c33de8887b59;
var $0da7817f7132e823$export$fca7f784ae7a249a;
var $0da7817f7132e823$export$13e3392192263954;
var $0da7817f7132e823$export$b8f5890fc79d6aca;
var $0da7817f7132e823$export$60241385465d0a34;
var $0da7817f7132e823$export$306c0aa65ff9ec16;
var $0da7817f7132e823$export$7b286972b8d8ccbf;
var $0da7817f7132e823$export$83d89fbfd8236492;
"use strict";
var $0da7817f7132e823$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0da7817f7132e823$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0da7817f7132e823$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0da7817f7132e823$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0da7817f7132e823$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0da7817f7132e823$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0da7817f7132e823$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0da7817f7132e823$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0da7817f7132e823$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0da7817f7132e823$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0da7817f7132e823$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $0da7817f7132e823$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $0da7817f7132e823$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $0da7817f7132e823$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $0da7817f7132e823$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$0da7817f7132e823$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $0da7817f7132e823$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0da7817f7132e823$var$assign = Object.assign, $0da7817f7132e823$var$emptyObject = {};
function $0da7817f7132e823$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0da7817f7132e823$var$emptyObject;
    this.updater = updater || $0da7817f7132e823$var$ReactNoopUpdateQueue;
}
$0da7817f7132e823$var$Component.prototype.isReactComponent = {};
$0da7817f7132e823$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$0da7817f7132e823$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $0da7817f7132e823$var$ComponentDummy() {}
$0da7817f7132e823$var$ComponentDummy.prototype = $0da7817f7132e823$var$Component.prototype;
function $0da7817f7132e823$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0da7817f7132e823$var$emptyObject;
    this.updater = updater || $0da7817f7132e823$var$ReactNoopUpdateQueue;
}
var $0da7817f7132e823$var$pureComponentPrototype = $0da7817f7132e823$var$PureComponent.prototype = new $0da7817f7132e823$var$ComponentDummy();
$0da7817f7132e823$var$pureComponentPrototype.constructor = $0da7817f7132e823$var$PureComponent;
$0da7817f7132e823$var$assign($0da7817f7132e823$var$pureComponentPrototype, $0da7817f7132e823$var$Component.prototype);
$0da7817f7132e823$var$pureComponentPrototype.isPureReactComponent = !0;
var $0da7817f7132e823$var$isArrayImpl = Array.isArray;
function $0da7817f7132e823$var$noop() {}
var $0da7817f7132e823$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $0da7817f7132e823$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0da7817f7132e823$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $0da7817f7132e823$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $0da7817f7132e823$var$cloneAndReplaceKey(oldElement, newKey) {
    return $0da7817f7132e823$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $0da7817f7132e823$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $0da7817f7132e823$var$REACT_ELEMENT_TYPE;
}
function $0da7817f7132e823$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $0da7817f7132e823$var$userProvidedKeyEscapeRegex = /\/+/g;
function $0da7817f7132e823$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $0da7817f7132e823$var$escape("" + element.key) : index.toString(36);
}
function $0da7817f7132e823$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($0da7817f7132e823$var$noop, $0da7817f7132e823$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $0da7817f7132e823$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $0da7817f7132e823$var$REACT_ELEMENT_TYPE:
                case $0da7817f7132e823$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $0da7817f7132e823$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $0da7817f7132e823$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $0da7817f7132e823$var$getElementKey(children, 0) : nameSoFar, $0da7817f7132e823$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($0da7817f7132e823$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $0da7817f7132e823$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($0da7817f7132e823$var$isValidElement(callback) && (callback = $0da7817f7132e823$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($0da7817f7132e823$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($0da7817f7132e823$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $0da7817f7132e823$var$getElementKey(nameSoFar, i), invokeCallback += $0da7817f7132e823$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $0da7817f7132e823$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $0da7817f7132e823$var$getElementKey(nameSoFar, i++), invokeCallback += $0da7817f7132e823$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $0da7817f7132e823$var$mapIntoArray($0da7817f7132e823$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $0da7817f7132e823$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $0da7817f7132e823$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $0da7817f7132e823$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $0da7817f7132e823$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $0da7817f7132e823$var$Children = {
    map: $0da7817f7132e823$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $0da7817f7132e823$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $0da7817f7132e823$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $0da7817f7132e823$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$0da7817f7132e823$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$0da7817f7132e823$export$9c16c1426311996d = $0da7817f7132e823$var$REACT_ACTIVITY_TYPE;
$0da7817f7132e823$export$dca3b0875bd9a954 = $0da7817f7132e823$var$Children;
$0da7817f7132e823$export$16fa2f45be04daa8 = $0da7817f7132e823$var$Component;
$0da7817f7132e823$export$ffb0004e005737fa = $0da7817f7132e823$var$REACT_FRAGMENT_TYPE;
$0da7817f7132e823$export$e2c29f18771995cb = $0da7817f7132e823$var$REACT_PROFILER_TYPE;
$0da7817f7132e823$export$221d75b3f55bb0bd = $0da7817f7132e823$var$PureComponent;
$0da7817f7132e823$export$5f8d39834fd61797 = $0da7817f7132e823$var$REACT_STRICT_MODE_TYPE;
$0da7817f7132e823$export$74bf444e3cd11ea5 = $0da7817f7132e823$var$REACT_SUSPENSE_TYPE;
$0da7817f7132e823$export$1ced07cd6b1985ce = $0da7817f7132e823$var$ReactSharedInternals;
$0da7817f7132e823$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $0da7817f7132e823$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$0da7817f7132e823$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$0da7817f7132e823$export$8c538325882c7eec = function() {
    return null;
};
$0da7817f7132e823$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $0da7817f7132e823$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$0da7817f7132e823$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $0da7817f7132e823$var$ReactElement(element.type, key, props);
};
$0da7817f7132e823$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $0da7817f7132e823$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $0da7817f7132e823$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$0da7817f7132e823$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$0da7817f7132e823$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $0da7817f7132e823$var$ReactElement(type, key, props);
};
$0da7817f7132e823$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0da7817f7132e823$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $0da7817f7132e823$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$0da7817f7132e823$export$a8257692ac88316c = $0da7817f7132e823$var$isValidElement;
$0da7817f7132e823$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $0da7817f7132e823$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $0da7817f7132e823$var$lazyInitializer
    };
};
$0da7817f7132e823$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $0da7817f7132e823$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$0da7817f7132e823$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $0da7817f7132e823$var$ReactSharedInternals.T, currentTransition = {};
    $0da7817f7132e823$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $0da7817f7132e823$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($0da7817f7132e823$var$noop, $0da7817f7132e823$var$reportGlobalError);
    } catch (error) {
        $0da7817f7132e823$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $0da7817f7132e823$var$ReactSharedInternals.T = prevTransition;
    }
};
$0da7817f7132e823$export$f93f40ac0ca7e3a8 = function() {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useCacheRefresh();
};
$0da7817f7132e823$export$1f96ae73734a86cc = function(usable) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.use(usable);
};
$0da7817f7132e823$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$0da7817f7132e823$export$35808ee640e87ca7 = function(callback, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$0da7817f7132e823$export$fae74005e78b1a27 = function(Context) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useContext(Context);
};
$0da7817f7132e823$export$dc8fbce3eb94dc1e = function() {};
$0da7817f7132e823$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$0da7817f7132e823$export$6d9c69b0de29b591 = function(create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useEffect(create, deps);
};
$0da7817f7132e823$export$7f54fc3180508a52 = function(callback) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$0da7817f7132e823$export$f680877a34711e37 = function() {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useId();
};
$0da7817f7132e823$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$0da7817f7132e823$export$aaabe4eda9ed9969 = function(create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$0da7817f7132e823$export$e5c5a5f917a5871c = function(create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$0da7817f7132e823$export$1538c33de8887b59 = function(create, deps) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useMemo(create, deps);
};
$0da7817f7132e823$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$0da7817f7132e823$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$0da7817f7132e823$export$b8f5890fc79d6aca = function(initialValue) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useRef(initialValue);
};
$0da7817f7132e823$export$60241385465d0a34 = function(initialState) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useState(initialState);
};
$0da7817f7132e823$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$0da7817f7132e823$export$7b286972b8d8ccbf = function() {
    return $0da7817f7132e823$var$ReactSharedInternals.H.useTransition();
};
$0da7817f7132e823$export$83d89fbfd8236492 = "19.2.8";

});

parcelRegister("fxpQW", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $b4fdfdeec9399ede$export$882461b6382ed46c; }, function (v) { return $b4fdfdeec9399ede$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b4fdfdeec9399ede$export$757ceba2d55c277e; }, function (v) { return $b4fdfdeec9399ede$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $b4fdfdeec9399ede$export$83d89fbfd8236492; }, function (v) { return $b4fdfdeec9399ede$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b4fdfdeec9399ede$export$882461b6382ed46c;
var $b4fdfdeec9399ede$export$757ceba2d55c277e;
var $b4fdfdeec9399ede$export$83d89fbfd8236492;
"use strict";

var $1c9zD = parcelRequire("1c9zD");

var $6cds3 = parcelRequire("6cds3");

var $9nHRL = parcelRequire("9nHRL");
function $b4fdfdeec9399ede$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b4fdfdeec9399ede$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $b4fdfdeec9399ede$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $b4fdfdeec9399ede$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $b4fdfdeec9399ede$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $b4fdfdeec9399ede$var$assertIsMounted(fiber) {
    if ($b4fdfdeec9399ede$var$getNearestMountedFiber(fiber) !== fiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
}
function $b4fdfdeec9399ede$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $b4fdfdeec9399ede$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $b4fdfdeec9399ede$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $b4fdfdeec9399ede$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $b4fdfdeec9399ede$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $b4fdfdeec9399ede$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $b4fdfdeec9399ede$var$assign = Object.assign, $b4fdfdeec9399ede$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b4fdfdeec9399ede$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b4fdfdeec9399ede$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b4fdfdeec9399ede$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b4fdfdeec9399ede$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b4fdfdeec9399ede$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b4fdfdeec9399ede$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b4fdfdeec9399ede$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b4fdfdeec9399ede$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $b4fdfdeec9399ede$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $b4fdfdeec9399ede$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $b4fdfdeec9399ede$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b4fdfdeec9399ede$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b4fdfdeec9399ede$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b4fdfdeec9399ede$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b4fdfdeec9399ede$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b4fdfdeec9399ede$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $b4fdfdeec9399ede$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $b4fdfdeec9399ede$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $b4fdfdeec9399ede$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $b4fdfdeec9399ede$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $b4fdfdeec9399ede$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $b4fdfdeec9399ede$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $b4fdfdeec9399ede$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $b4fdfdeec9399ede$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $b4fdfdeec9399ede$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $b4fdfdeec9399ede$var$getComponentNameFromType(type.type) || "Memo";
        case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $b4fdfdeec9399ede$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $b4fdfdeec9399ede$var$isArrayImpl = Array.isArray, $b4fdfdeec9399ede$var$ReactSharedInternals = $6cds3.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b4fdfdeec9399ede$var$ReactDOMSharedInternals = $9nHRL.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b4fdfdeec9399ede$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $b4fdfdeec9399ede$var$valueStack = [], $b4fdfdeec9399ede$var$index = -1;
function $b4fdfdeec9399ede$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $b4fdfdeec9399ede$var$pop(cursor) {
    0 > $b4fdfdeec9399ede$var$index || (cursor.current = $b4fdfdeec9399ede$var$valueStack[$b4fdfdeec9399ede$var$index], $b4fdfdeec9399ede$var$valueStack[$b4fdfdeec9399ede$var$index] = null, $b4fdfdeec9399ede$var$index--);
}
function $b4fdfdeec9399ede$var$push(cursor, value) {
    $b4fdfdeec9399ede$var$index++;
    $b4fdfdeec9399ede$var$valueStack[$b4fdfdeec9399ede$var$index] = cursor.current;
    cursor.current = value;
}
var $b4fdfdeec9399ede$var$contextStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$contextFiberStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$rootInstanceStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$hostTransitionProviderCursor = $b4fdfdeec9399ede$var$createCursor(null);
function $b4fdfdeec9399ede$var$pushHostContainer(fiber, nextRootInstance) {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$rootInstanceStackCursor, nextRootInstance);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextFiberStackCursor, fiber);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $b4fdfdeec9399ede$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $b4fdfdeec9399ede$var$getOwnHostContext(nextRootInstance), fiber = $b4fdfdeec9399ede$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextStackCursor);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextStackCursor, fiber);
}
function $b4fdfdeec9399ede$var$popHostContainer() {
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextStackCursor);
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextFiberStackCursor);
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$rootInstanceStackCursor);
}
function $b4fdfdeec9399ede$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$hostTransitionProviderCursor, fiber);
    var context = $b4fdfdeec9399ede$var$contextStackCursor.current;
    var JSCompiler_inline_result = $b4fdfdeec9399ede$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextFiberStackCursor, fiber), $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$contextStackCursor, JSCompiler_inline_result));
}
function $b4fdfdeec9399ede$var$popHostContext(fiber) {
    $b4fdfdeec9399ede$var$contextFiberStackCursor.current === fiber && ($b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextStackCursor), $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$contextFiberStackCursor));
    $b4fdfdeec9399ede$var$hostTransitionProviderCursor.current === fiber && ($b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$hostTransitionProviderCursor), $b4fdfdeec9399ede$var$HostTransitionContext._currentValue = $b4fdfdeec9399ede$var$sharedNotPendingObject);
}
var $b4fdfdeec9399ede$var$prefix, $b4fdfdeec9399ede$var$suffix;
function $b4fdfdeec9399ede$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $b4fdfdeec9399ede$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $b4fdfdeec9399ede$var$prefix = match && match[1] || "";
        $b4fdfdeec9399ede$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $b4fdfdeec9399ede$var$prefix + name + $b4fdfdeec9399ede$var$suffix;
}
var $b4fdfdeec9399ede$var$reentry = !1;
function $b4fdfdeec9399ede$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $b4fdfdeec9399ede$var$reentry) return "";
    $b4fdfdeec9399ede$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $b4fdfdeec9399ede$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $b4fdfdeec9399ede$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $b4fdfdeec9399ede$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("Suspense Fallback") : $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $b4fdfdeec9399ede$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $b4fdfdeec9399ede$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $b4fdfdeec9399ede$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $b4fdfdeec9399ede$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $b4fdfdeec9399ede$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $b4fdfdeec9399ede$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $b4fdfdeec9399ede$var$hasOwnProperty = Object.prototype.hasOwnProperty, $b4fdfdeec9399ede$var$scheduleCallback$3 = $1c9zD.unstable_scheduleCallback, $b4fdfdeec9399ede$var$cancelCallback$1 = $1c9zD.unstable_cancelCallback, $b4fdfdeec9399ede$var$shouldYield = $1c9zD.unstable_shouldYield, $b4fdfdeec9399ede$var$requestPaint = $1c9zD.unstable_requestPaint, $b4fdfdeec9399ede$var$now = $1c9zD.unstable_now, $b4fdfdeec9399ede$var$getCurrentPriorityLevel = $1c9zD.unstable_getCurrentPriorityLevel, $b4fdfdeec9399ede$var$ImmediatePriority = $1c9zD.unstable_ImmediatePriority, $b4fdfdeec9399ede$var$UserBlockingPriority = $1c9zD.unstable_UserBlockingPriority, $b4fdfdeec9399ede$var$NormalPriority$1 = $1c9zD.unstable_NormalPriority, $b4fdfdeec9399ede$var$LowPriority = $1c9zD.unstable_LowPriority, $b4fdfdeec9399ede$var$IdlePriority = $1c9zD.unstable_IdlePriority, $b4fdfdeec9399ede$var$log$1 = $1c9zD.log, $b4fdfdeec9399ede$var$unstable_setDisableYieldValue = $1c9zD.unstable_setDisableYieldValue, $b4fdfdeec9399ede$var$rendererID = null, $b4fdfdeec9399ede$var$injectedHook = null;
function $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $b4fdfdeec9399ede$var$log$1 && $b4fdfdeec9399ede$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($b4fdfdeec9399ede$var$injectedHook && "function" === typeof $b4fdfdeec9399ede$var$injectedHook.setStrictMode) try {
        $b4fdfdeec9399ede$var$injectedHook.setStrictMode($b4fdfdeec9399ede$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $b4fdfdeec9399ede$var$clz32 = Math.clz32 ? Math.clz32 : $b4fdfdeec9399ede$var$clz32Fallback, $b4fdfdeec9399ede$var$log = Math.log, $b4fdfdeec9399ede$var$LN2 = Math.LN2;
function $b4fdfdeec9399ede$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($b4fdfdeec9399ede$var$log(x) / $b4fdfdeec9399ede$var$LN2 | 0) | 0;
}
var $b4fdfdeec9399ede$var$nextTransitionUpdateLane = 256, $b4fdfdeec9399ede$var$nextTransitionDeferredLane = 262144, $b4fdfdeec9399ede$var$nextRetryLane = 4194304;
function $b4fdfdeec9399ede$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $b4fdfdeec9399ede$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $b4fdfdeec9399ede$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b4fdfdeec9399ede$var$claimNextRetryLane() {
    var lane = $b4fdfdeec9399ede$var$nextRetryLane;
    $b4fdfdeec9399ede$var$nextRetryLane <<= 1;
    0 === ($b4fdfdeec9399ede$var$nextRetryLane & 62914560) && ($b4fdfdeec9399ede$var$nextRetryLane = 4194304);
    return lane;
}
function $b4fdfdeec9399ede$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $b4fdfdeec9399ede$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $b4fdfdeec9399ede$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $b4fdfdeec9399ede$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $b4fdfdeec9399ede$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $b4fdfdeec9399ede$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $b4fdfdeec9399ede$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $b4fdfdeec9399ede$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $b4fdfdeec9399ede$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $b4fdfdeec9399ede$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $b4fdfdeec9399ede$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $b4fdfdeec9399ede$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $b4fdfdeec9399ede$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $b4fdfdeec9399ede$var$resolveUpdatePriority() {
    var updatePriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $b4fdfdeec9399ede$var$getEventPriority(updatePriority.type);
}
function $b4fdfdeec9399ede$var$runWithPriority(priority, fn) {
    var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    try {
        return $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $b4fdfdeec9399ede$var$randomKey = Math.random().toString(36).slice(2), $b4fdfdeec9399ede$var$internalInstanceKey = "__reactFiber$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalPropsKey = "__reactProps$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalContainerInstanceKey = "__reactContainer$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalEventHandlersKey = "__reactEvents$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalEventHandlerListenersKey = "__reactListeners$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalEventHandlesSetKey = "__reactHandles$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalRootNodeResourcesKey = "__reactResources$" + $b4fdfdeec9399ede$var$randomKey, $b4fdfdeec9399ede$var$internalHoistableMarker = "__reactMarker$" + $b4fdfdeec9399ede$var$randomKey;
function $b4fdfdeec9399ede$var$detachDeletedInstance(node) {
    delete node[$b4fdfdeec9399ede$var$internalInstanceKey];
    delete node[$b4fdfdeec9399ede$var$internalPropsKey];
    delete node[$b4fdfdeec9399ede$var$internalEventHandlersKey];
    delete node[$b4fdfdeec9399ede$var$internalEventHandlerListenersKey];
    delete node[$b4fdfdeec9399ede$var$internalEventHandlesSetKey];
}
function $b4fdfdeec9399ede$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$b4fdfdeec9399ede$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$b4fdfdeec9399ede$var$internalContainerInstanceKey] || parentNode[$b4fdfdeec9399ede$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $b4fdfdeec9399ede$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$b4fdfdeec9399ede$var$internalInstanceKey]) return parentNode;
                targetNode = $b4fdfdeec9399ede$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $b4fdfdeec9399ede$var$getInstanceFromNode(node) {
    if (node = node[$b4fdfdeec9399ede$var$internalInstanceKey] || node[$b4fdfdeec9399ede$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $b4fdfdeec9399ede$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(33));
}
function $b4fdfdeec9399ede$var$getResourcesFromRoot(root) {
    var resources = root[$b4fdfdeec9399ede$var$internalRootNodeResourcesKey];
    resources || (resources = root[$b4fdfdeec9399ede$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $b4fdfdeec9399ede$var$markNodeAsHoistable(node) {
    node[$b4fdfdeec9399ede$var$internalHoistableMarker] = !0;
}
var $b4fdfdeec9399ede$var$allNativeEvents = new Set(), $b4fdfdeec9399ede$var$registrationNameDependencies = {};
function $b4fdfdeec9399ede$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $b4fdfdeec9399ede$var$registerDirectEvent(registrationName, dependencies);
    $b4fdfdeec9399ede$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $b4fdfdeec9399ede$var$registerDirectEvent(registrationName, dependencies) {
    $b4fdfdeec9399ede$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$b4fdfdeec9399ede$var$allNativeEvents.add(dependencies[registrationName]);
}
var $b4fdfdeec9399ede$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $b4fdfdeec9399ede$var$illegalAttributeNameCache = {}, $b4fdfdeec9399ede$var$validatedAttributeNameCache = {};
function $b4fdfdeec9399ede$var$isAttributeNameSafe(attributeName) {
    if ($b4fdfdeec9399ede$var$hasOwnProperty.call($b4fdfdeec9399ede$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($b4fdfdeec9399ede$var$hasOwnProperty.call($b4fdfdeec9399ede$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($b4fdfdeec9399ede$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $b4fdfdeec9399ede$var$validatedAttributeNameCache[attributeName] = !0;
    $b4fdfdeec9399ede$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $b4fdfdeec9399ede$var$setValueForAttribute(node, name, value) {
    if ($b4fdfdeec9399ede$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $b4fdfdeec9399ede$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $b4fdfdeec9399ede$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $b4fdfdeec9399ede$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $b4fdfdeec9399ede$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $b4fdfdeec9399ede$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $b4fdfdeec9399ede$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $b4fdfdeec9399ede$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $b4fdfdeec9399ede$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $b4fdfdeec9399ede$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $b4fdfdeec9399ede$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $b4fdfdeec9399ede$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $b4fdfdeec9399ede$var$getToStringValue(value);
        } else element.value !== "" + $b4fdfdeec9399ede$var$getToStringValue(value) && (element.value = "" + $b4fdfdeec9399ede$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $b4fdfdeec9399ede$var$setDefaultValue(element, type, $b4fdfdeec9399ede$var$getToStringValue(value)) : null != defaultValue ? $b4fdfdeec9399ede$var$setDefaultValue(element, type, $b4fdfdeec9399ede$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $b4fdfdeec9399ede$var$getToStringValue(name) : element.removeAttribute("name");
}
function $b4fdfdeec9399ede$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $b4fdfdeec9399ede$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $b4fdfdeec9399ede$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $b4fdfdeec9399ede$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $b4fdfdeec9399ede$var$track(element);
}
function $b4fdfdeec9399ede$var$setDefaultValue(node, type, value) {
    "number" === type && $b4fdfdeec9399ede$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $b4fdfdeec9399ede$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $b4fdfdeec9399ede$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $b4fdfdeec9399ede$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $b4fdfdeec9399ede$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $b4fdfdeec9399ede$var$getToStringValue(defaultValue) : "";
}
function $b4fdfdeec9399ede$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(92));
            if ($b4fdfdeec9399ede$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $b4fdfdeec9399ede$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $b4fdfdeec9399ede$var$track(element);
}
function $b4fdfdeec9399ede$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $b4fdfdeec9399ede$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $b4fdfdeec9399ede$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $b4fdfdeec9399ede$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $b4fdfdeec9399ede$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $b4fdfdeec9399ede$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $b4fdfdeec9399ede$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $b4fdfdeec9399ede$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b4fdfdeec9399ede$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $b4fdfdeec9399ede$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $b4fdfdeec9399ede$var$sanitizeURL(url) {
    return $b4fdfdeec9399ede$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $b4fdfdeec9399ede$var$noop$1() {}
var $b4fdfdeec9399ede$var$currentReplayingEvent = null;
function $b4fdfdeec9399ede$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $b4fdfdeec9399ede$var$restoreTarget = null, $b4fdfdeec9399ede$var$restoreQueue = null;
function $b4fdfdeec9399ede$var$restoreStateOfTarget(target) {
    var internalInstance = $b4fdfdeec9399ede$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$b4fdfdeec9399ede$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $b4fdfdeec9399ede$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$b4fdfdeec9399ede$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(90));
                            $b4fdfdeec9399ede$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $b4fdfdeec9399ede$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $b4fdfdeec9399ede$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $b4fdfdeec9399ede$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $b4fdfdeec9399ede$var$isInsideEventHandler = !1;
function $b4fdfdeec9399ede$var$batchedUpdates$1(fn, a, b) {
    if ($b4fdfdeec9399ede$var$isInsideEventHandler) return fn(a, b);
    $b4fdfdeec9399ede$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($b4fdfdeec9399ede$var$isInsideEventHandler = !1, null !== $b4fdfdeec9399ede$var$restoreTarget || null !== $b4fdfdeec9399ede$var$restoreQueue) {
            if ($b4fdfdeec9399ede$var$flushSyncWork$1(), $b4fdfdeec9399ede$var$restoreTarget && (a = $b4fdfdeec9399ede$var$restoreTarget, fn = $b4fdfdeec9399ede$var$restoreQueue, $b4fdfdeec9399ede$var$restoreQueue = $b4fdfdeec9399ede$var$restoreTarget = null, $b4fdfdeec9399ede$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$b4fdfdeec9399ede$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $b4fdfdeec9399ede$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$b4fdfdeec9399ede$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $b4fdfdeec9399ede$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b4fdfdeec9399ede$var$passiveBrowserEventsSupported = !1;
if ($b4fdfdeec9399ede$var$canUseDOM) try {
    var $b4fdfdeec9399ede$var$options = {};
    Object.defineProperty($b4fdfdeec9399ede$var$options, "passive", {
        get: function() {
            $b4fdfdeec9399ede$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $b4fdfdeec9399ede$var$options, $b4fdfdeec9399ede$var$options);
    window.removeEventListener("test", $b4fdfdeec9399ede$var$options, $b4fdfdeec9399ede$var$options);
} catch (e) {
    $b4fdfdeec9399ede$var$passiveBrowserEventsSupported = !1;
}
var $b4fdfdeec9399ede$var$root = null, $b4fdfdeec9399ede$var$startText = null, $b4fdfdeec9399ede$var$fallbackText = null;
function $b4fdfdeec9399ede$var$getData() {
    if ($b4fdfdeec9399ede$var$fallbackText) return $b4fdfdeec9399ede$var$fallbackText;
    var start, startValue = $b4fdfdeec9399ede$var$startText, startLength = startValue.length, end, endValue = "value" in $b4fdfdeec9399ede$var$root ? $b4fdfdeec9399ede$var$root.value : $b4fdfdeec9399ede$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $b4fdfdeec9399ede$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $b4fdfdeec9399ede$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $b4fdfdeec9399ede$var$functionThatReturnsTrue() {
    return !0;
}
function $b4fdfdeec9399ede$var$functionThatReturnsFalse() {
    return !1;
}
function $b4fdfdeec9399ede$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $b4fdfdeec9399ede$var$functionThatReturnsTrue : $b4fdfdeec9399ede$var$functionThatReturnsFalse;
        this.isPropagationStopped = $b4fdfdeec9399ede$var$functionThatReturnsFalse;
        return this;
    }
    $b4fdfdeec9399ede$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $b4fdfdeec9399ede$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $b4fdfdeec9399ede$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $b4fdfdeec9399ede$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $b4fdfdeec9399ede$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b4fdfdeec9399ede$var$SyntheticEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$EventInterface), $b4fdfdeec9399ede$var$UIEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    view: 0,
    detail: 0
}), $b4fdfdeec9399ede$var$SyntheticUIEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$UIEventInterface), $b4fdfdeec9399ede$var$lastMovementX, $b4fdfdeec9399ede$var$lastMovementY, $b4fdfdeec9399ede$var$lastMouseEvent, $b4fdfdeec9399ede$var$MouseEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b4fdfdeec9399ede$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $b4fdfdeec9399ede$var$lastMouseEvent && ($b4fdfdeec9399ede$var$lastMouseEvent && "mousemove" === event.type ? ($b4fdfdeec9399ede$var$lastMovementX = event.screenX - $b4fdfdeec9399ede$var$lastMouseEvent.screenX, $b4fdfdeec9399ede$var$lastMovementY = event.screenY - $b4fdfdeec9399ede$var$lastMouseEvent.screenY) : $b4fdfdeec9399ede$var$lastMovementY = $b4fdfdeec9399ede$var$lastMovementX = 0, $b4fdfdeec9399ede$var$lastMouseEvent = event);
        return $b4fdfdeec9399ede$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $b4fdfdeec9399ede$var$lastMovementY;
    }
}), $b4fdfdeec9399ede$var$SyntheticMouseEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$MouseEventInterface), $b4fdfdeec9399ede$var$DragEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$MouseEventInterface, {
    dataTransfer: 0
}), $b4fdfdeec9399ede$var$SyntheticDragEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$DragEventInterface), $b4fdfdeec9399ede$var$FocusEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$UIEventInterface, {
    relatedTarget: 0
}), $b4fdfdeec9399ede$var$SyntheticFocusEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$FocusEventInterface), $b4fdfdeec9399ede$var$AnimationEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b4fdfdeec9399ede$var$SyntheticAnimationEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$AnimationEventInterface), $b4fdfdeec9399ede$var$ClipboardEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $b4fdfdeec9399ede$var$SyntheticClipboardEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$ClipboardEventInterface), $b4fdfdeec9399ede$var$CompositionEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    data: 0
}), $b4fdfdeec9399ede$var$SyntheticCompositionEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$CompositionEventInterface), $b4fdfdeec9399ede$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b4fdfdeec9399ede$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b4fdfdeec9399ede$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b4fdfdeec9399ede$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $b4fdfdeec9399ede$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $b4fdfdeec9399ede$var$getEventModifierState() {
    return $b4fdfdeec9399ede$var$modifierStateGetter;
}
var $b4fdfdeec9399ede$var$KeyboardEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $b4fdfdeec9399ede$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $b4fdfdeec9399ede$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $b4fdfdeec9399ede$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b4fdfdeec9399ede$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $b4fdfdeec9399ede$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $b4fdfdeec9399ede$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $b4fdfdeec9399ede$var$SyntheticKeyboardEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$KeyboardEventInterface), $b4fdfdeec9399ede$var$PointerEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b4fdfdeec9399ede$var$SyntheticPointerEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$PointerEventInterface), $b4fdfdeec9399ede$var$TouchEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b4fdfdeec9399ede$var$getEventModifierState
}), $b4fdfdeec9399ede$var$SyntheticTouchEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$TouchEventInterface), $b4fdfdeec9399ede$var$TransitionEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b4fdfdeec9399ede$var$SyntheticTransitionEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$TransitionEventInterface), $b4fdfdeec9399ede$var$WheelEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b4fdfdeec9399ede$var$SyntheticWheelEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$WheelEventInterface), $b4fdfdeec9399ede$var$ToggleEventInterface = $b4fdfdeec9399ede$var$assign({}, $b4fdfdeec9399ede$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $b4fdfdeec9399ede$var$SyntheticToggleEvent = $b4fdfdeec9399ede$var$createSyntheticEvent($b4fdfdeec9399ede$var$ToggleEventInterface), $b4fdfdeec9399ede$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $b4fdfdeec9399ede$var$canUseCompositionEvent = $b4fdfdeec9399ede$var$canUseDOM && "CompositionEvent" in window, $b4fdfdeec9399ede$var$documentMode = null;
$b4fdfdeec9399ede$var$canUseDOM && "documentMode" in document && ($b4fdfdeec9399ede$var$documentMode = document.documentMode);
var $b4fdfdeec9399ede$var$canUseTextInputEvent = $b4fdfdeec9399ede$var$canUseDOM && "TextEvent" in window && !$b4fdfdeec9399ede$var$documentMode, $b4fdfdeec9399ede$var$useFallbackCompositionData = $b4fdfdeec9399ede$var$canUseDOM && (!$b4fdfdeec9399ede$var$canUseCompositionEvent || $b4fdfdeec9399ede$var$documentMode && 8 < $b4fdfdeec9399ede$var$documentMode && 11 >= $b4fdfdeec9399ede$var$documentMode), $b4fdfdeec9399ede$var$SPACEBAR_CHAR = String.fromCharCode(32), $b4fdfdeec9399ede$var$hasSpaceKeypress = !1;
function $b4fdfdeec9399ede$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $b4fdfdeec9399ede$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b4fdfdeec9399ede$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $b4fdfdeec9399ede$var$isComposing = !1;
function $b4fdfdeec9399ede$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $b4fdfdeec9399ede$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $b4fdfdeec9399ede$var$hasSpaceKeypress = !0;
            return $b4fdfdeec9399ede$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $b4fdfdeec9399ede$var$SPACEBAR_CHAR && $b4fdfdeec9399ede$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $b4fdfdeec9399ede$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($b4fdfdeec9399ede$var$isComposing) return "compositionend" === domEventName || !$b4fdfdeec9399ede$var$canUseCompositionEvent && $b4fdfdeec9399ede$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $b4fdfdeec9399ede$var$getData(), $b4fdfdeec9399ede$var$fallbackText = $b4fdfdeec9399ede$var$startText = $b4fdfdeec9399ede$var$root = null, $b4fdfdeec9399ede$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $b4fdfdeec9399ede$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $b4fdfdeec9399ede$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b4fdfdeec9399ede$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$b4fdfdeec9399ede$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $b4fdfdeec9399ede$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $b4fdfdeec9399ede$var$restoreTarget ? $b4fdfdeec9399ede$var$restoreQueue ? $b4fdfdeec9399ede$var$restoreQueue.push(target) : $b4fdfdeec9399ede$var$restoreQueue = [
        target
    ] : $b4fdfdeec9399ede$var$restoreTarget = target;
    inst = $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $b4fdfdeec9399ede$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $b4fdfdeec9399ede$var$activeElement$1 = null, $b4fdfdeec9399ede$var$activeElementInst$1 = null;
function $b4fdfdeec9399ede$var$runEventInBatch(dispatchQueue) {
    $b4fdfdeec9399ede$var$processDispatchQueue(dispatchQueue, 0);
}
function $b4fdfdeec9399ede$var$getInstIfValueChanged(targetInst) {
    var targetNode = $b4fdfdeec9399ede$var$getNodeFromInstance(targetInst);
    if ($b4fdfdeec9399ede$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $b4fdfdeec9399ede$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $b4fdfdeec9399ede$var$isInputEventSupported = !1;
if ($b4fdfdeec9399ede$var$canUseDOM) {
    var $b4fdfdeec9399ede$var$JSCompiler_inline_result$jscomp$286;
    if ($b4fdfdeec9399ede$var$canUseDOM) {
        var $b4fdfdeec9399ede$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$b4fdfdeec9399ede$var$isSupported$jscomp$inline_427) {
            var $b4fdfdeec9399ede$var$element$jscomp$inline_428 = document.createElement("div");
            $b4fdfdeec9399ede$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $b4fdfdeec9399ede$var$isSupported$jscomp$inline_427 = "function" === typeof $b4fdfdeec9399ede$var$element$jscomp$inline_428.oninput;
        }
        $b4fdfdeec9399ede$var$JSCompiler_inline_result$jscomp$286 = $b4fdfdeec9399ede$var$isSupported$jscomp$inline_427;
    } else $b4fdfdeec9399ede$var$JSCompiler_inline_result$jscomp$286 = !1;
    $b4fdfdeec9399ede$var$isInputEventSupported = $b4fdfdeec9399ede$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $b4fdfdeec9399ede$var$stopWatchingForValueChange() {
    $b4fdfdeec9399ede$var$activeElement$1 && ($b4fdfdeec9399ede$var$activeElement$1.detachEvent("onpropertychange", $b4fdfdeec9399ede$var$handlePropertyChange), $b4fdfdeec9399ede$var$activeElementInst$1 = $b4fdfdeec9399ede$var$activeElement$1 = null);
}
function $b4fdfdeec9399ede$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $b4fdfdeec9399ede$var$getInstIfValueChanged($b4fdfdeec9399ede$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $b4fdfdeec9399ede$var$createAndAccumulateChangeEvent(dispatchQueue, $b4fdfdeec9399ede$var$activeElementInst$1, nativeEvent, $b4fdfdeec9399ede$var$getEventTarget(nativeEvent));
        $b4fdfdeec9399ede$var$batchedUpdates$1($b4fdfdeec9399ede$var$runEventInBatch, dispatchQueue);
    }
}
function $b4fdfdeec9399ede$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($b4fdfdeec9399ede$var$stopWatchingForValueChange(), $b4fdfdeec9399ede$var$activeElement$1 = target, $b4fdfdeec9399ede$var$activeElementInst$1 = targetInst, $b4fdfdeec9399ede$var$activeElement$1.attachEvent("onpropertychange", $b4fdfdeec9399ede$var$handlePropertyChange)) : "focusout" === domEventName && $b4fdfdeec9399ede$var$stopWatchingForValueChange();
}
function $b4fdfdeec9399ede$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $b4fdfdeec9399ede$var$getInstIfValueChanged($b4fdfdeec9399ede$var$activeElementInst$1);
}
function $b4fdfdeec9399ede$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $b4fdfdeec9399ede$var$getInstIfValueChanged(targetInst);
}
function $b4fdfdeec9399ede$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $b4fdfdeec9399ede$var$getInstIfValueChanged(targetInst);
}
function $b4fdfdeec9399ede$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b4fdfdeec9399ede$var$objectIs = "function" === typeof Object.is ? Object.is : $b4fdfdeec9399ede$var$is;
function $b4fdfdeec9399ede$var$shallowEqual(objA, objB) {
    if ($b4fdfdeec9399ede$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$b4fdfdeec9399ede$var$hasOwnProperty.call(objB, currentKey) || !$b4fdfdeec9399ede$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $b4fdfdeec9399ede$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $b4fdfdeec9399ede$var$getNodeForCharacterOffset(root, offset) {
    var node = $b4fdfdeec9399ede$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $b4fdfdeec9399ede$var$getLeafNode(node);
    }
}
function $b4fdfdeec9399ede$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $b4fdfdeec9399ede$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $b4fdfdeec9399ede$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $b4fdfdeec9399ede$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $b4fdfdeec9399ede$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $b4fdfdeec9399ede$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $b4fdfdeec9399ede$var$skipSelectionChangeEvent = $b4fdfdeec9399ede$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $b4fdfdeec9399ede$var$activeElement = null, $b4fdfdeec9399ede$var$activeElementInst = null, $b4fdfdeec9399ede$var$lastSelection = null, $b4fdfdeec9399ede$var$mouseDown = !1;
function $b4fdfdeec9399ede$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $b4fdfdeec9399ede$var$mouseDown || null == $b4fdfdeec9399ede$var$activeElement || $b4fdfdeec9399ede$var$activeElement !== $b4fdfdeec9399ede$var$getActiveElement(doc) || (doc = $b4fdfdeec9399ede$var$activeElement, "selectionStart" in doc && $b4fdfdeec9399ede$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $b4fdfdeec9399ede$var$lastSelection && $b4fdfdeec9399ede$var$shallowEqual($b4fdfdeec9399ede$var$lastSelection, doc) || ($b4fdfdeec9399ede$var$lastSelection = doc, doc = $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners($b4fdfdeec9399ede$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $b4fdfdeec9399ede$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $b4fdfdeec9399ede$var$activeElement)));
}
function $b4fdfdeec9399ede$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $b4fdfdeec9399ede$var$vendorPrefixes = {
    animationend: $b4fdfdeec9399ede$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $b4fdfdeec9399ede$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $b4fdfdeec9399ede$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $b4fdfdeec9399ede$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $b4fdfdeec9399ede$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $b4fdfdeec9399ede$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $b4fdfdeec9399ede$var$makePrefixMap("Transition", "TransitionEnd")
}, $b4fdfdeec9399ede$var$prefixedEventNames = {}, $b4fdfdeec9399ede$var$style = {};
$b4fdfdeec9399ede$var$canUseDOM && ($b4fdfdeec9399ede$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $b4fdfdeec9399ede$var$vendorPrefixes.animationend.animation, delete $b4fdfdeec9399ede$var$vendorPrefixes.animationiteration.animation, delete $b4fdfdeec9399ede$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $b4fdfdeec9399ede$var$vendorPrefixes.transitionend.transition);
function $b4fdfdeec9399ede$var$getVendorPrefixedEventName(eventName) {
    if ($b4fdfdeec9399ede$var$prefixedEventNames[eventName]) return $b4fdfdeec9399ede$var$prefixedEventNames[eventName];
    if (!$b4fdfdeec9399ede$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $b4fdfdeec9399ede$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $b4fdfdeec9399ede$var$style) return $b4fdfdeec9399ede$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $b4fdfdeec9399ede$var$ANIMATION_END = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("animationend"), $b4fdfdeec9399ede$var$ANIMATION_ITERATION = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("animationiteration"), $b4fdfdeec9399ede$var$ANIMATION_START = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("animationstart"), $b4fdfdeec9399ede$var$TRANSITION_RUN = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("transitionrun"), $b4fdfdeec9399ede$var$TRANSITION_START = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("transitionstart"), $b4fdfdeec9399ede$var$TRANSITION_CANCEL = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("transitioncancel"), $b4fdfdeec9399ede$var$TRANSITION_END = $b4fdfdeec9399ede$var$getVendorPrefixedEventName("transitionend"), $b4fdfdeec9399ede$var$topLevelEventsToReactNames = new Map(), $b4fdfdeec9399ede$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$b4fdfdeec9399ede$var$simpleEventPluginEvents.push("scrollEnd");
function $b4fdfdeec9399ede$var$registerSimpleEvent(domEventName, reactName) {
    $b4fdfdeec9399ede$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $b4fdfdeec9399ede$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $b4fdfdeec9399ede$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $b4fdfdeec9399ede$var$concurrentQueues = [], $b4fdfdeec9399ede$var$concurrentQueuesIndex = 0, $b4fdfdeec9399ede$var$concurrentlyUpdatedLanes = 0;
function $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $b4fdfdeec9399ede$var$concurrentQueuesIndex, i = $b4fdfdeec9399ede$var$concurrentlyUpdatedLanes = $b4fdfdeec9399ede$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $b4fdfdeec9399ede$var$concurrentQueues[i];
        $b4fdfdeec9399ede$var$concurrentQueues[i++] = null;
        var queue = $b4fdfdeec9399ede$var$concurrentQueues[i];
        $b4fdfdeec9399ede$var$concurrentQueues[i++] = null;
        var update = $b4fdfdeec9399ede$var$concurrentQueues[i];
        $b4fdfdeec9399ede$var$concurrentQueues[i++] = null;
        var lane = $b4fdfdeec9399ede$var$concurrentQueues[i];
        $b4fdfdeec9399ede$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $b4fdfdeec9399ede$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $b4fdfdeec9399ede$var$concurrentQueues[$b4fdfdeec9399ede$var$concurrentQueuesIndex++] = fiber;
    $b4fdfdeec9399ede$var$concurrentQueues[$b4fdfdeec9399ede$var$concurrentQueuesIndex++] = queue;
    $b4fdfdeec9399ede$var$concurrentQueues[$b4fdfdeec9399ede$var$concurrentQueuesIndex++] = update;
    $b4fdfdeec9399ede$var$concurrentQueues[$b4fdfdeec9399ede$var$concurrentQueuesIndex++] = lane;
    $b4fdfdeec9399ede$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $b4fdfdeec9399ede$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $b4fdfdeec9399ede$var$getRootForUpdatedFiber(fiber);
}
function $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, null, null, lane);
    return $b4fdfdeec9399ede$var$getRootForUpdatedFiber(fiber);
}
function $b4fdfdeec9399ede$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $b4fdfdeec9399ede$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $b4fdfdeec9399ede$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $b4fdfdeec9399ede$var$nestedUpdateCount) throw $b4fdfdeec9399ede$var$nestedUpdateCount = 0, $b4fdfdeec9399ede$var$rootWithNestedUpdates = null, Error($b4fdfdeec9399ede$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $b4fdfdeec9399ede$var$emptyContextObject = {};
function $b4fdfdeec9399ede$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b4fdfdeec9399ede$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $b4fdfdeec9399ede$var$FiberNode(tag, pendingProps, key, mode);
}
function $b4fdfdeec9399ede$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $b4fdfdeec9399ede$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $b4fdfdeec9399ede$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $b4fdfdeec9399ede$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $b4fdfdeec9399ede$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $b4fdfdeec9399ede$var$isHostHoistableType(type, pendingProps, $b4fdfdeec9399ede$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $b4fdfdeec9399ede$var$REACT_ACTIVITY_TYPE:
            return type = $b4fdfdeec9399ede$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $b4fdfdeec9399ede$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE:
            return $b4fdfdeec9399ede$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $b4fdfdeec9399ede$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $b4fdfdeec9399ede$var$REACT_PROFILER_TYPE:
            return type = $b4fdfdeec9399ede$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $b4fdfdeec9399ede$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $b4fdfdeec9399ede$var$REACT_SUSPENSE_TYPE:
            return type = $b4fdfdeec9399ede$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $b4fdfdeec9399ede$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $b4fdfdeec9399ede$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $b4fdfdeec9399ede$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $b4fdfdeec9399ede$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $b4fdfdeec9399ede$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $b4fdfdeec9399ede$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $b4fdfdeec9399ede$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $b4fdfdeec9399ede$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $b4fdfdeec9399ede$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $b4fdfdeec9399ede$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $b4fdfdeec9399ede$var$createFiberFromText(content, mode, lanes) {
    content = $b4fdfdeec9399ede$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $b4fdfdeec9399ede$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $b4fdfdeec9399ede$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $b4fdfdeec9399ede$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $b4fdfdeec9399ede$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $b4fdfdeec9399ede$var$CapturedStacks = new WeakMap();
function $b4fdfdeec9399ede$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $b4fdfdeec9399ede$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $b4fdfdeec9399ede$var$getStackByFiberInDevAndProd(source)
        };
        $b4fdfdeec9399ede$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $b4fdfdeec9399ede$var$getStackByFiberInDevAndProd(source)
    };
}
var $b4fdfdeec9399ede$var$forkStack = [], $b4fdfdeec9399ede$var$forkStackIndex = 0, $b4fdfdeec9399ede$var$treeForkProvider = null, $b4fdfdeec9399ede$var$treeForkCount = 0, $b4fdfdeec9399ede$var$idStack = [], $b4fdfdeec9399ede$var$idStackIndex = 0, $b4fdfdeec9399ede$var$treeContextProvider = null, $b4fdfdeec9399ede$var$treeContextId = 1, $b4fdfdeec9399ede$var$treeContextOverflow = "";
function $b4fdfdeec9399ede$var$pushTreeFork(workInProgress, totalChildren) {
    $b4fdfdeec9399ede$var$forkStack[$b4fdfdeec9399ede$var$forkStackIndex++] = $b4fdfdeec9399ede$var$treeForkCount;
    $b4fdfdeec9399ede$var$forkStack[$b4fdfdeec9399ede$var$forkStackIndex++] = $b4fdfdeec9399ede$var$treeForkProvider;
    $b4fdfdeec9399ede$var$treeForkProvider = workInProgress;
    $b4fdfdeec9399ede$var$treeForkCount = totalChildren;
}
function $b4fdfdeec9399ede$var$pushTreeId(workInProgress, totalChildren, index) {
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextId;
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextOverflow;
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextProvider;
    $b4fdfdeec9399ede$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $b4fdfdeec9399ede$var$treeContextId;
    workInProgress = $b4fdfdeec9399ede$var$treeContextOverflow;
    var baseLength = 32 - $b4fdfdeec9399ede$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $b4fdfdeec9399ede$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $b4fdfdeec9399ede$var$treeContextId = 1 << 32 - $b4fdfdeec9399ede$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $b4fdfdeec9399ede$var$treeContextOverflow = length + workInProgress;
    } else $b4fdfdeec9399ede$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $b4fdfdeec9399ede$var$treeContextOverflow = workInProgress;
}
function $b4fdfdeec9399ede$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($b4fdfdeec9399ede$var$pushTreeFork(workInProgress, 1), $b4fdfdeec9399ede$var$pushTreeId(workInProgress, 1, 0));
}
function $b4fdfdeec9399ede$var$popTreeContext(workInProgress) {
    for(; workInProgress === $b4fdfdeec9399ede$var$treeForkProvider;)$b4fdfdeec9399ede$var$treeForkProvider = $b4fdfdeec9399ede$var$forkStack[--$b4fdfdeec9399ede$var$forkStackIndex], $b4fdfdeec9399ede$var$forkStack[$b4fdfdeec9399ede$var$forkStackIndex] = null, $b4fdfdeec9399ede$var$treeForkCount = $b4fdfdeec9399ede$var$forkStack[--$b4fdfdeec9399ede$var$forkStackIndex], $b4fdfdeec9399ede$var$forkStack[$b4fdfdeec9399ede$var$forkStackIndex] = null;
    for(; workInProgress === $b4fdfdeec9399ede$var$treeContextProvider;)$b4fdfdeec9399ede$var$treeContextProvider = $b4fdfdeec9399ede$var$idStack[--$b4fdfdeec9399ede$var$idStackIndex], $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex] = null, $b4fdfdeec9399ede$var$treeContextOverflow = $b4fdfdeec9399ede$var$idStack[--$b4fdfdeec9399ede$var$idStackIndex], $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex] = null, $b4fdfdeec9399ede$var$treeContextId = $b4fdfdeec9399ede$var$idStack[--$b4fdfdeec9399ede$var$idStackIndex], $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex] = null;
}
function $b4fdfdeec9399ede$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextId;
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextOverflow;
    $b4fdfdeec9399ede$var$idStack[$b4fdfdeec9399ede$var$idStackIndex++] = $b4fdfdeec9399ede$var$treeContextProvider;
    $b4fdfdeec9399ede$var$treeContextId = suspendedContext.id;
    $b4fdfdeec9399ede$var$treeContextOverflow = suspendedContext.overflow;
    $b4fdfdeec9399ede$var$treeContextProvider = workInProgress;
}
var $b4fdfdeec9399ede$var$hydrationParentFiber = null, $b4fdfdeec9399ede$var$nextHydratableInstance = null, $b4fdfdeec9399ede$var$isHydrating = !1, $b4fdfdeec9399ede$var$hydrationErrors = null, $b4fdfdeec9399ede$var$rootOrSingletonContext = !1, $b4fdfdeec9399ede$var$HydrationMismatchException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(519));
function $b4fdfdeec9399ede$var$throwOnHydrationMismatch(fiber) {
    var error = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $b4fdfdeec9399ede$var$queueHydrationError($b4fdfdeec9399ede$var$createCapturedValueAtFiber(error, fiber));
    throw $b4fdfdeec9399ede$var$HydrationMismatchException;
}
function $b4fdfdeec9399ede$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$b4fdfdeec9399ede$var$internalInstanceKey] = fiber;
    instance[$b4fdfdeec9399ede$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("cancel", instance);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $b4fdfdeec9399ede$var$mediaEventTypes.length; type++)$b4fdfdeec9399ede$var$listenToNonDelegatedEvent($b4fdfdeec9399ede$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", instance);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", instance);
            $b4fdfdeec9399ede$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", instance), $b4fdfdeec9399ede$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $b4fdfdeec9399ede$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($b4fdfdeec9399ede$var$listenToNonDelegatedEvent("beforetoggle", instance), $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $b4fdfdeec9399ede$var$noop$1), instance = !0) : instance = !1;
    instance || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(fiber, !0);
}
function $b4fdfdeec9399ede$var$popToNextHostParent(fiber) {
    for($b4fdfdeec9399ede$var$hydrationParentFiber = fiber.return; $b4fdfdeec9399ede$var$hydrationParentFiber;)switch($b4fdfdeec9399ede$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $b4fdfdeec9399ede$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $b4fdfdeec9399ede$var$rootOrSingletonContext = !0;
            return;
        default:
            $b4fdfdeec9399ede$var$hydrationParentFiber = $b4fdfdeec9399ede$var$hydrationParentFiber.return;
    }
}
function $b4fdfdeec9399ede$var$popHydrationState(fiber) {
    if (fiber !== $b4fdfdeec9399ede$var$hydrationParentFiber) return !1;
    if (!$b4fdfdeec9399ede$var$isHydrating) return $b4fdfdeec9399ede$var$popToNextHostParent(fiber), $b4fdfdeec9399ede$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $b4fdfdeec9399ede$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $b4fdfdeec9399ede$var$nextHydratableInstance && $b4fdfdeec9399ede$var$throwOnHydrationMismatch(fiber);
    $b4fdfdeec9399ede$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(317));
        $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(317));
        $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $b4fdfdeec9399ede$var$nextHydratableInstance, $b4fdfdeec9399ede$var$isSingletonScope(fiber.type) ? (fiber = $b4fdfdeec9399ede$var$previousHydratableOnEnteringScopedSingleton, $b4fdfdeec9399ede$var$previousHydratableOnEnteringScopedSingleton = null, $b4fdfdeec9399ede$var$nextHydratableInstance = fiber) : $b4fdfdeec9399ede$var$nextHydratableInstance = tag) : $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$hydrationParentFiber ? $b4fdfdeec9399ede$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $b4fdfdeec9399ede$var$resetHydrationState() {
    $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$hydrationParentFiber = null;
    $b4fdfdeec9399ede$var$isHydrating = !1;
}
function $b4fdfdeec9399ede$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $b4fdfdeec9399ede$var$hydrationErrors;
    null !== queuedErrors && (null === $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors ? $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = queuedErrors : $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors.push.apply($b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors, queuedErrors), $b4fdfdeec9399ede$var$hydrationErrors = null);
    return queuedErrors;
}
function $b4fdfdeec9399ede$var$queueHydrationError(error) {
    null === $b4fdfdeec9399ede$var$hydrationErrors ? $b4fdfdeec9399ede$var$hydrationErrors = [
        error
    ] : $b4fdfdeec9399ede$var$hydrationErrors.push(error);
}
var $b4fdfdeec9399ede$var$valueCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null, $b4fdfdeec9399ede$var$lastContextDependency = null;
function $b4fdfdeec9399ede$var$pushProvider(providerFiber, context, nextValue) {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $b4fdfdeec9399ede$var$popProvider(context) {
    context._currentValue = $b4fdfdeec9399ede$var$valueCursor.current;
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$valueCursor);
}
function $b4fdfdeec9399ede$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $b4fdfdeec9399ede$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $b4fdfdeec9399ede$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $b4fdfdeec9399ede$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $b4fdfdeec9399ede$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $b4fdfdeec9399ede$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($b4fdfdeec9399ede$var$HostTransitionContext) : current = [
                $b4fdfdeec9399ede$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $b4fdfdeec9399ede$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $b4fdfdeec9399ede$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$b4fdfdeec9399ede$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress) {
    $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = workInProgress;
    $b4fdfdeec9399ede$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $b4fdfdeec9399ede$var$readContext(context) {
    return $b4fdfdeec9399ede$var$readContextForConsumer($b4fdfdeec9399ede$var$currentlyRenderingFiber$1, context);
}
function $b4fdfdeec9399ede$var$readContextDuringReconciliation(consumer, context) {
    null === $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 && $b4fdfdeec9399ede$var$prepareToReadContext(consumer);
    return $b4fdfdeec9399ede$var$readContextForConsumer(consumer, context);
}
function $b4fdfdeec9399ede$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $b4fdfdeec9399ede$var$lastContextDependency) {
        if (null === consumer) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(308));
        $b4fdfdeec9399ede$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$lastContextDependency.next = context;
    return value;
}
var $b4fdfdeec9399ede$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $b4fdfdeec9399ede$var$scheduleCallback$2 = $1c9zD.unstable_scheduleCallback, $b4fdfdeec9399ede$var$NormalPriority = $1c9zD.unstable_NormalPriority, $b4fdfdeec9399ede$var$CacheContext = {
    $$typeof: $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $b4fdfdeec9399ede$var$createCache() {
    return {
        controller: new $b4fdfdeec9399ede$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $b4fdfdeec9399ede$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $b4fdfdeec9399ede$var$scheduleCallback$2($b4fdfdeec9399ede$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $b4fdfdeec9399ede$var$currentEntangledListeners = null, $b4fdfdeec9399ede$var$currentEntangledPendingCount = 0, $b4fdfdeec9399ede$var$currentEntangledLane = 0, $b4fdfdeec9399ede$var$currentEntangledActionThenable = null;
function $b4fdfdeec9399ede$var$entangleAsyncAction(transition, thenable) {
    if (null === $b4fdfdeec9399ede$var$currentEntangledListeners) {
        var entangledListeners = $b4fdfdeec9399ede$var$currentEntangledListeners = [];
        $b4fdfdeec9399ede$var$currentEntangledPendingCount = 0;
        $b4fdfdeec9399ede$var$currentEntangledLane = $b4fdfdeec9399ede$var$requestTransitionLane();
        $b4fdfdeec9399ede$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $b4fdfdeec9399ede$var$currentEntangledPendingCount++;
    thenable.then($b4fdfdeec9399ede$var$pingEngtangledActionScope, $b4fdfdeec9399ede$var$pingEngtangledActionScope);
    return thenable;
}
function $b4fdfdeec9399ede$var$pingEngtangledActionScope() {
    if (0 === --$b4fdfdeec9399ede$var$currentEntangledPendingCount && null !== $b4fdfdeec9399ede$var$currentEntangledListeners) {
        null !== $b4fdfdeec9399ede$var$currentEntangledActionThenable && ($b4fdfdeec9399ede$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $b4fdfdeec9399ede$var$currentEntangledListeners;
        $b4fdfdeec9399ede$var$currentEntangledListeners = null;
        $b4fdfdeec9399ede$var$currentEntangledLane = 0;
        $b4fdfdeec9399ede$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $b4fdfdeec9399ede$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $b4fdfdeec9399ede$var$prevOnStartTransitionFinish = $b4fdfdeec9399ede$var$ReactSharedInternals.S;
$b4fdfdeec9399ede$var$ReactSharedInternals.S = function(transition, returnValue) {
    $b4fdfdeec9399ede$var$globalMostRecentTransitionTime = $b4fdfdeec9399ede$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $b4fdfdeec9399ede$var$entangleAsyncAction(transition, returnValue);
    null !== $b4fdfdeec9399ede$var$prevOnStartTransitionFinish && $b4fdfdeec9399ede$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $b4fdfdeec9399ede$var$resumedCache = $b4fdfdeec9399ede$var$createCursor(null);
function $b4fdfdeec9399ede$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $b4fdfdeec9399ede$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $b4fdfdeec9399ede$var$workInProgressRoot.pooledCache;
}
function $b4fdfdeec9399ede$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$resumedCache, $b4fdfdeec9399ede$var$resumedCache.current) : $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$resumedCache, prevCachePool.pool);
}
function $b4fdfdeec9399ede$var$getSuspendedCache() {
    var cacheFromPool = $b4fdfdeec9399ede$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $b4fdfdeec9399ede$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $b4fdfdeec9399ede$var$SuspenseException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(460)), $b4fdfdeec9399ede$var$SuspenseyCommitException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(474)), $b4fdfdeec9399ede$var$SuspenseActionException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(542)), $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $b4fdfdeec9399ede$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $b4fdfdeec9399ede$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($b4fdfdeec9399ede$var$noop$1, $b4fdfdeec9399ede$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $b4fdfdeec9399ede$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($b4fdfdeec9399ede$var$noop$1, $b4fdfdeec9399ede$var$noop$1);
            else {
                thenableState = $b4fdfdeec9399ede$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $b4fdfdeec9399ede$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $b4fdfdeec9399ede$var$suspendedThenable = thenable;
            throw $b4fdfdeec9399ede$var$SuspenseException;
    }
}
function $b4fdfdeec9399ede$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $b4fdfdeec9399ede$var$suspendedThenable = x, $b4fdfdeec9399ede$var$SuspenseException;
        throw x;
    }
}
var $b4fdfdeec9399ede$var$suspendedThenable = null;
function $b4fdfdeec9399ede$var$getSuspendedThenable() {
    if (null === $b4fdfdeec9399ede$var$suspendedThenable) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(459));
    var thenable = $b4fdfdeec9399ede$var$suspendedThenable;
    $b4fdfdeec9399ede$var$suspendedThenable = null;
    return thenable;
}
function $b4fdfdeec9399ede$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $b4fdfdeec9399ede$var$SuspenseException || rejectedReason === $b4fdfdeec9399ede$var$SuspenseActionException) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(483));
}
var $b4fdfdeec9399ede$var$thenableState$1 = null, $b4fdfdeec9399ede$var$thenableIndexCounter$1 = 0;
function $b4fdfdeec9399ede$var$unwrapThenable(thenable) {
    var index = $b4fdfdeec9399ede$var$thenableIndexCounter$1;
    $b4fdfdeec9399ede$var$thenableIndexCounter$1 += 1;
    null === $b4fdfdeec9399ede$var$thenableState$1 && ($b4fdfdeec9399ede$var$thenableState$1 = []);
    return $b4fdfdeec9399ede$var$trackUsedThenable($b4fdfdeec9399ede$var$thenableState$1, thenable, index);
}
function $b4fdfdeec9399ede$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $b4fdfdeec9399ede$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $b4fdfdeec9399ede$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $b4fdfdeec9399ede$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $b4fdfdeec9399ede$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $b4fdfdeec9399ede$var$REACT_LAZY_TYPE && $b4fdfdeec9399ede$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $b4fdfdeec9399ede$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $b4fdfdeec9399ede$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $b4fdfdeec9399ede$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $b4fdfdeec9399ede$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $b4fdfdeec9399ede$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE:
                    return lanes = $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b4fdfdeec9399ede$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
                    return newChild = $b4fdfdeec9399ede$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    return newChild = $b4fdfdeec9399ede$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($b4fdfdeec9399ede$var$isArrayImpl(newChild) || $b4fdfdeec9399ede$var$getIteratorFn(newChild)) return newChild = $b4fdfdeec9399ede$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $b4fdfdeec9399ede$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $b4fdfdeec9399ede$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b4fdfdeec9399ede$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    return newChild = $b4fdfdeec9399ede$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($b4fdfdeec9399ede$var$isArrayImpl(newChild) || $b4fdfdeec9399ede$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $b4fdfdeec9399ede$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $b4fdfdeec9399ede$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b4fdfdeec9399ede$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    return newChild = $b4fdfdeec9399ede$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($b4fdfdeec9399ede$var$isArrayImpl(newChild) || $b4fdfdeec9399ede$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $b4fdfdeec9399ede$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $b4fdfdeec9399ede$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b4fdfdeec9399ede$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b4fdfdeec9399ede$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $b4fdfdeec9399ede$var$REACT_LAZY_TYPE && $b4fdfdeec9399ede$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $b4fdfdeec9399ede$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $b4fdfdeec9399ede$var$REACT_FRAGMENT_TYPE ? (lanes = $b4fdfdeec9399ede$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b4fdfdeec9399ede$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $b4fdfdeec9399ede$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $b4fdfdeec9399ede$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $b4fdfdeec9399ede$var$REACT_LAZY_TYPE:
                    return newChild = $b4fdfdeec9399ede$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($b4fdfdeec9399ede$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($b4fdfdeec9399ede$var$getIteratorFn(newChild)) {
                key = $b4fdfdeec9399ede$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b4fdfdeec9399ede$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b4fdfdeec9399ede$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b4fdfdeec9399ede$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $b4fdfdeec9399ede$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $b4fdfdeec9399ede$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $b4fdfdeec9399ede$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $b4fdfdeec9399ede$var$SuspenseException || x === $b4fdfdeec9399ede$var$SuspenseActionException) throw x;
            var fiber = $b4fdfdeec9399ede$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $b4fdfdeec9399ede$var$reconcileChildFibers = $b4fdfdeec9399ede$var$createChildReconciler(!0), $b4fdfdeec9399ede$var$mountChildFibers = $b4fdfdeec9399ede$var$createChildReconciler(!1), $b4fdfdeec9399ede$var$hasForceUpdate = !1;
function $b4fdfdeec9399ede$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $b4fdfdeec9399ede$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $b4fdfdeec9399ede$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b4fdfdeec9399ede$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($b4fdfdeec9399ede$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $b4fdfdeec9399ede$var$getRootForUpdatedFiber(fiber);
        $b4fdfdeec9399ede$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $b4fdfdeec9399ede$var$getRootForUpdatedFiber(fiber);
}
function $b4fdfdeec9399ede$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $b4fdfdeec9399ede$var$markRootEntangled(root, lane);
    }
}
function $b4fdfdeec9399ede$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $b4fdfdeec9399ede$var$didReadFromEntangledAsyncAction = !1;
function $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($b4fdfdeec9399ede$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $b4fdfdeec9399ede$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $b4fdfdeec9399ede$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $b4fdfdeec9399ede$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $b4fdfdeec9399ede$var$currentEntangledLane && ($b4fdfdeec9399ede$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $b4fdfdeec9399ede$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $b4fdfdeec9399ede$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $b4fdfdeec9399ede$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $b4fdfdeec9399ede$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$b4fdfdeec9399ede$var$callCallback(callbacks[updateQueue], context);
}
var $b4fdfdeec9399ede$var$currentTreeHiddenStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor = $b4fdfdeec9399ede$var$createCursor(0);
function $b4fdfdeec9399ede$var$pushHiddenContext(fiber, context) {
    fiber = $b4fdfdeec9399ede$var$entangledRenderLanes;
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor, fiber);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$currentTreeHiddenStackCursor, context);
    $b4fdfdeec9399ede$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $b4fdfdeec9399ede$var$reuseHiddenContextOnStack() {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor, $b4fdfdeec9399ede$var$entangledRenderLanes);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$currentTreeHiddenStackCursor, $b4fdfdeec9399ede$var$currentTreeHiddenStackCursor.current);
}
function $b4fdfdeec9399ede$var$popHiddenContext() {
    $b4fdfdeec9399ede$var$entangledRenderLanes = $b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor.current;
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$currentTreeHiddenStackCursor);
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$prevEntangledRenderLanesCursor);
}
var $b4fdfdeec9399ede$var$suspenseHandlerStackCursor = $b4fdfdeec9399ede$var$createCursor(null), $b4fdfdeec9399ede$var$shellBoundary = null;
function $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current & 1);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseHandlerStackCursor, handler);
    null === $b4fdfdeec9399ede$var$shellBoundary && (null === current || null !== $b4fdfdeec9399ede$var$currentTreeHiddenStackCursor.current ? $b4fdfdeec9399ede$var$shellBoundary = handler : null !== current.memoizedState && ($b4fdfdeec9399ede$var$shellBoundary = handler));
}
function $b4fdfdeec9399ede$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseHandlerStackCursor, fiber);
    null === $b4fdfdeec9399ede$var$shellBoundary && ($b4fdfdeec9399ede$var$shellBoundary = fiber);
}
function $b4fdfdeec9399ede$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current), $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseHandlerStackCursor, fiber), null === $b4fdfdeec9399ede$var$shellBoundary && ($b4fdfdeec9399ede$var$shellBoundary = fiber)) : $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(fiber);
}
function $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack() {
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current);
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseHandlerStackCursor, $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current);
}
function $b4fdfdeec9399ede$var$popSuspenseHandler(fiber) {
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseHandlerStackCursor);
    $b4fdfdeec9399ede$var$shellBoundary === fiber && ($b4fdfdeec9399ede$var$shellBoundary = null);
    $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseStackCursor);
}
var $b4fdfdeec9399ede$var$suspenseStackCursor = $b4fdfdeec9399ede$var$createCursor(0);
function $b4fdfdeec9399ede$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $b4fdfdeec9399ede$var$isSuspenseInstancePending(state) || $b4fdfdeec9399ede$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $b4fdfdeec9399ede$var$renderLanes = 0, $b4fdfdeec9399ede$var$currentlyRenderingFiber = null, $b4fdfdeec9399ede$var$currentHook = null, $b4fdfdeec9399ede$var$workInProgressHook = null, $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate = !1, $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $b4fdfdeec9399ede$var$localIdCounter = 0, $b4fdfdeec9399ede$var$thenableIndexCounter = 0, $b4fdfdeec9399ede$var$thenableState = null, $b4fdfdeec9399ede$var$globalClientIdCounter = 0;
function $b4fdfdeec9399ede$var$throwInvalidHookError() {
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(321));
}
function $b4fdfdeec9399ede$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$b4fdfdeec9399ede$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $b4fdfdeec9399ede$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $b4fdfdeec9399ede$var$renderLanes = nextRenderLanes;
    $b4fdfdeec9399ede$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $b4fdfdeec9399ede$var$HooksDispatcherOnMount : $b4fdfdeec9399ede$var$HooksDispatcherOnUpdate;
    $b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $b4fdfdeec9399ede$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $b4fdfdeec9399ede$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $b4fdfdeec9399ede$var$finishRenderingHooks(current) {
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = $b4fdfdeec9399ede$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $b4fdfdeec9399ede$var$currentHook && null !== $b4fdfdeec9399ede$var$currentHook.next;
    $b4fdfdeec9399ede$var$renderLanes = 0;
    $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$currentHook = $b4fdfdeec9399ede$var$currentlyRenderingFiber = null;
    $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate = !1;
    $b4fdfdeec9399ede$var$thenableIndexCounter = 0;
    $b4fdfdeec9399ede$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(300));
    null === current || $b4fdfdeec9399ede$var$didReceiveUpdate || (current = current.dependencies, null !== current && $b4fdfdeec9399ede$var$checkIfContextChanged(current) && ($b4fdfdeec9399ede$var$didReceiveUpdate = !0));
}
function $b4fdfdeec9399ede$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $b4fdfdeec9399ede$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass && ($b4fdfdeec9399ede$var$thenableState = null);
        $b4fdfdeec9399ede$var$thenableIndexCounter = 0;
        $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $b4fdfdeec9399ede$var$ReactSharedInternals.H = $b4fdfdeec9399ede$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $b4fdfdeec9399ede$var$TransitionAwareHostComponent() {
    var dispatcher = $b4fdfdeec9399ede$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $b4fdfdeec9399ede$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $b4fdfdeec9399ede$var$currentHook ? $b4fdfdeec9399ede$var$currentHook.memoizedState : null) !== dispatcher && ($b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $b4fdfdeec9399ede$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $b4fdfdeec9399ede$var$localIdCounter;
    $b4fdfdeec9399ede$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $b4fdfdeec9399ede$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $b4fdfdeec9399ede$var$resetHooksOnUnwind(workInProgress) {
    if ($b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate = !1;
    }
    $b4fdfdeec9399ede$var$renderLanes = 0;
    $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$currentHook = $b4fdfdeec9399ede$var$currentlyRenderingFiber = null;
    $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $b4fdfdeec9399ede$var$thenableIndexCounter = $b4fdfdeec9399ede$var$localIdCounter = 0;
    $b4fdfdeec9399ede$var$thenableState = null;
}
function $b4fdfdeec9399ede$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b4fdfdeec9399ede$var$workInProgressHook ? $b4fdfdeec9399ede$var$currentlyRenderingFiber.memoizedState = $b4fdfdeec9399ede$var$workInProgressHook = hook : $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$workInProgressHook.next = hook;
    return $b4fdfdeec9399ede$var$workInProgressHook;
}
function $b4fdfdeec9399ede$var$updateWorkInProgressHook() {
    if (null === $b4fdfdeec9399ede$var$currentHook) {
        var nextCurrentHook = $b4fdfdeec9399ede$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $b4fdfdeec9399ede$var$currentHook.next;
    var nextWorkInProgressHook = null === $b4fdfdeec9399ede$var$workInProgressHook ? $b4fdfdeec9399ede$var$currentlyRenderingFiber.memoizedState : $b4fdfdeec9399ede$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $b4fdfdeec9399ede$var$workInProgressHook = nextWorkInProgressHook, $b4fdfdeec9399ede$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $b4fdfdeec9399ede$var$currentlyRenderingFiber.alternate) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(467));
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(310));
        }
        $b4fdfdeec9399ede$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $b4fdfdeec9399ede$var$currentHook.memoizedState,
            baseState: $b4fdfdeec9399ede$var$currentHook.baseState,
            baseQueue: $b4fdfdeec9399ede$var$currentHook.baseQueue,
            queue: $b4fdfdeec9399ede$var$currentHook.queue,
            next: null
        };
        null === $b4fdfdeec9399ede$var$workInProgressHook ? $b4fdfdeec9399ede$var$currentlyRenderingFiber.memoizedState = $b4fdfdeec9399ede$var$workInProgressHook = nextCurrentHook : $b4fdfdeec9399ede$var$workInProgressHook = $b4fdfdeec9399ede$var$workInProgressHook.next = nextCurrentHook;
    }
    return $b4fdfdeec9399ede$var$workInProgressHook;
}
function $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $b4fdfdeec9399ede$var$useThenable(thenable) {
    var index = $b4fdfdeec9399ede$var$thenableIndexCounter;
    $b4fdfdeec9399ede$var$thenableIndexCounter += 1;
    null === $b4fdfdeec9399ede$var$thenableState && ($b4fdfdeec9399ede$var$thenableState = []);
    thenable = $b4fdfdeec9399ede$var$trackUsedThenable($b4fdfdeec9399ede$var$thenableState, thenable, index);
    index = $b4fdfdeec9399ede$var$currentlyRenderingFiber;
    null === (null === $b4fdfdeec9399ede$var$workInProgressHook ? index.memoizedState : $b4fdfdeec9399ede$var$workInProgressHook.next) && (index = index.alternate, $b4fdfdeec9399ede$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $b4fdfdeec9399ede$var$HooksDispatcherOnMount : $b4fdfdeec9399ede$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $b4fdfdeec9399ede$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $b4fdfdeec9399ede$var$useThenable(usable);
        if (usable.$$typeof === $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE) return $b4fdfdeec9399ede$var$readContext(usable);
    }
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(438, String(usable)));
}
function $b4fdfdeec9399ede$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $b4fdfdeec9399ede$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue(), $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $b4fdfdeec9399ede$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $b4fdfdeec9399ede$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $b4fdfdeec9399ede$var$updateReducer(reducer) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    return $b4fdfdeec9399ede$var$updateReducerImpl(hook, $b4fdfdeec9399ede$var$currentHook, reducer);
}
function $b4fdfdeec9399ede$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($b4fdfdeec9399ede$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $b4fdfdeec9399ede$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($b4fdfdeec9399ede$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $b4fdfdeec9399ede$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $b4fdfdeec9399ede$var$currentlyRenderingFiber.lanes |= revertLane, $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $b4fdfdeec9399ede$var$currentlyRenderingFiber.lanes |= updateLane, $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$b4fdfdeec9399ede$var$objectIs(pendingQueue, hook.memoizedState) && ($b4fdfdeec9399ede$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $b4fdfdeec9399ede$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $b4fdfdeec9399ede$var$rerenderReducer(reducer) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $b4fdfdeec9399ede$var$objectIs(newState, hook.memoizedState) || ($b4fdfdeec9399ede$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $b4fdfdeec9399ede$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $b4fdfdeec9399ede$var$currentlyRenderingFiber, hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $b4fdfdeec9399ede$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$b4fdfdeec9399ede$var$objectIs(($b4fdfdeec9399ede$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $b4fdfdeec9399ede$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $b4fdfdeec9399ede$var$updateEffect($b4fdfdeec9399ede$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $b4fdfdeec9399ede$var$workInProgressHook && $b4fdfdeec9399ede$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $b4fdfdeec9399ede$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b4fdfdeec9399ede$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $b4fdfdeec9399ede$var$workInProgressRoot) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($b4fdfdeec9399ede$var$renderLanes & 127) || $b4fdfdeec9399ede$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $b4fdfdeec9399ede$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue(), $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $b4fdfdeec9399ede$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $b4fdfdeec9399ede$var$checkIfSnapshotChanged(inst) && $b4fdfdeec9399ede$var$forceStoreRerender(fiber);
}
function $b4fdfdeec9399ede$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $b4fdfdeec9399ede$var$checkIfSnapshotChanged(inst) && $b4fdfdeec9399ede$var$forceStoreRerender(fiber);
    });
}
function $b4fdfdeec9399ede$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b4fdfdeec9399ede$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b4fdfdeec9399ede$var$forceStoreRerender(fiber) {
    var root = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $b4fdfdeec9399ede$var$mountStateImpl(initialState) {
    var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b4fdfdeec9399ede$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $b4fdfdeec9399ede$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $b4fdfdeec9399ede$var$updateReducerImpl(hook, $b4fdfdeec9399ede$var$currentHook, "function" === typeof reducer ? reducer : $b4fdfdeec9399ede$var$basicStateReducer);
}
function $b4fdfdeec9399ede$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $b4fdfdeec9399ede$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $b4fdfdeec9399ede$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $b4fdfdeec9399ede$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T, currentTransition = {};
        $b4fdfdeec9399ede$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $b4fdfdeec9399ede$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $b4fdfdeec9399ede$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $b4fdfdeec9399ede$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $b4fdfdeec9399ede$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $b4fdfdeec9399ede$var$onActionError(actionQueue, node, error$66);
    }
}
function $b4fdfdeec9399ede$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $b4fdfdeec9399ede$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $b4fdfdeec9399ede$var$onActionError(actionQueue, node, error);
    }) : $b4fdfdeec9399ede$var$onActionSuccess(actionQueue, node, returnValue);
}
function $b4fdfdeec9399ede$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $b4fdfdeec9399ede$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $b4fdfdeec9399ede$var$runActionStateAction(actionQueue, nextState)));
}
function $b4fdfdeec9399ede$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $b4fdfdeec9399ede$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $b4fdfdeec9399ede$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $b4fdfdeec9399ede$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $b4fdfdeec9399ede$var$mountActionState(action, initialStateProp) {
    if ($b4fdfdeec9399ede$var$isHydrating) {
        var ssrFormState = $b4fdfdeec9399ede$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $b4fdfdeec9399ede$var$currentlyRenderingFiber;
                if ($b4fdfdeec9399ede$var$isHydrating) {
                    if ($b4fdfdeec9399ede$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $b4fdfdeec9399ede$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $b4fdfdeec9399ede$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $b4fdfdeec9399ede$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $b4fdfdeec9399ede$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b4fdfdeec9399ede$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $b4fdfdeec9399ede$var$dispatchSetState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $b4fdfdeec9399ede$var$mountStateImpl(!1);
    inRootOrSingleton = $b4fdfdeec9399ede$var$dispatchOptimisticSetState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $b4fdfdeec9399ede$var$dispatchActionState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $b4fdfdeec9399ede$var$updateActionState(action) {
    var stateHook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    return $b4fdfdeec9399ede$var$updateActionStateImpl(stateHook, $b4fdfdeec9399ede$var$currentHook, action);
}
function $b4fdfdeec9399ede$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $b4fdfdeec9399ede$var$updateReducerImpl(stateHook, currentStateHook, $b4fdfdeec9399ede$var$actionStateReducer)[0];
    stateHook = $b4fdfdeec9399ede$var$updateReducer($b4fdfdeec9399ede$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $b4fdfdeec9399ede$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $b4fdfdeec9399ede$var$SuspenseException) throw $b4fdfdeec9399ede$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= 2048, $b4fdfdeec9399ede$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $b4fdfdeec9399ede$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $b4fdfdeec9399ede$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $b4fdfdeec9399ede$var$rerenderActionState(action) {
    var stateHook = $b4fdfdeec9399ede$var$updateWorkInProgressHook(), currentStateHook = $b4fdfdeec9399ede$var$currentHook;
    if (null !== currentStateHook) return $b4fdfdeec9399ede$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $b4fdfdeec9399ede$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue(), $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $b4fdfdeec9399ede$var$updateRef() {
    return $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
}
function $b4fdfdeec9399ede$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
    $b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $b4fdfdeec9399ede$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $b4fdfdeec9399ede$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $b4fdfdeec9399ede$var$currentHook && null !== deps && $b4fdfdeec9399ede$var$areHookInputsEqual(deps, $b4fdfdeec9399ede$var$currentHook.memoizedState.deps) ? hook.memoizedState = $b4fdfdeec9399ede$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $b4fdfdeec9399ede$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $b4fdfdeec9399ede$var$mountEffect(create, deps) {
    $b4fdfdeec9399ede$var$mountEffectImpl(8390656, 8, create, deps);
}
function $b4fdfdeec9399ede$var$updateEffect(create, deps) {
    $b4fdfdeec9399ede$var$updateEffectImpl(2048, 8, create, deps);
}
function $b4fdfdeec9399ede$var$useEffectEventImpl(payload) {
    $b4fdfdeec9399ede$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $b4fdfdeec9399ede$var$createFunctionComponentUpdateQueue(), $b4fdfdeec9399ede$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $b4fdfdeec9399ede$var$updateEvent(callback) {
    var ref = $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
    $b4fdfdeec9399ede$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($b4fdfdeec9399ede$var$executionContext & 2)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $b4fdfdeec9399ede$var$updateInsertionEffect(create, deps) {
    return $b4fdfdeec9399ede$var$updateEffectImpl(4, 2, create, deps);
}
function $b4fdfdeec9399ede$var$updateLayoutEffect(create, deps) {
    return $b4fdfdeec9399ede$var$updateEffectImpl(4, 4, create, deps);
}
function $b4fdfdeec9399ede$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $b4fdfdeec9399ede$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $b4fdfdeec9399ede$var$updateEffectImpl(4, 4, $b4fdfdeec9399ede$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $b4fdfdeec9399ede$var$mountDebugValue() {}
function $b4fdfdeec9399ede$var$updateCallback(callback, deps) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b4fdfdeec9399ede$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $b4fdfdeec9399ede$var$updateMemo(nextCreate, deps) {
    var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b4fdfdeec9399ede$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $b4fdfdeec9399ede$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($b4fdfdeec9399ede$var$renderLanes & 1073741824) && 0 === ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $b4fdfdeec9399ede$var$requestDeferredLane();
    $b4fdfdeec9399ede$var$currentlyRenderingFiber.lanes |= hook;
    $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $b4fdfdeec9399ede$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($b4fdfdeec9399ede$var$objectIs(value, prevValue)) return value;
    if (null !== $b4fdfdeec9399ede$var$currentTreeHiddenStackCursor.current) return hook = $b4fdfdeec9399ede$var$mountDeferredValueImpl(hook, value, initialValue), $b4fdfdeec9399ede$var$objectIs(hook, prevValue) || ($b4fdfdeec9399ede$var$didReceiveUpdate = !0), hook;
    if (0 === ($b4fdfdeec9399ede$var$renderLanes & 42) || 0 !== ($b4fdfdeec9399ede$var$renderLanes & 1073741824) && 0 === ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 261930)) return $b4fdfdeec9399ede$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $b4fdfdeec9399ede$var$requestDeferredLane();
    $b4fdfdeec9399ede$var$currentlyRenderingFiber.lanes |= hook;
    $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $b4fdfdeec9399ede$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T, currentTransition = {};
    $b4fdfdeec9399ede$var$ReactSharedInternals.T = currentTransition;
    $b4fdfdeec9399ede$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $b4fdfdeec9399ede$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $b4fdfdeec9399ede$var$chainThenableValue(returnValue, finishedState);
            $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $b4fdfdeec9399ede$var$requestUpdateLane(fiber));
        } else $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, finishedState, $b4fdfdeec9399ede$var$requestUpdateLane(fiber));
    } catch (error) {
        $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $b4fdfdeec9399ede$var$requestUpdateLane());
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b4fdfdeec9399ede$var$noop() {}
function $b4fdfdeec9399ede$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(476));
    var queue = $b4fdfdeec9399ede$var$ensureFormComponentIsStateful(formFiber).queue;
    $b4fdfdeec9399ede$var$startTransition(formFiber, queue, pendingState, $b4fdfdeec9399ede$var$sharedNotPendingObject, null === action ? $b4fdfdeec9399ede$var$noop : function() {
        $b4fdfdeec9399ede$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $b4fdfdeec9399ede$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $b4fdfdeec9399ede$var$sharedNotPendingObject,
        baseState: $b4fdfdeec9399ede$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b4fdfdeec9399ede$var$basicStateReducer,
            lastRenderedState: $b4fdfdeec9399ede$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b4fdfdeec9399ede$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $b4fdfdeec9399ede$var$requestFormReset$1(formFiber) {
    var stateHook = $b4fdfdeec9399ede$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $b4fdfdeec9399ede$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $b4fdfdeec9399ede$var$requestUpdateLane());
}
function $b4fdfdeec9399ede$var$useHostTransitionStatus() {
    return $b4fdfdeec9399ede$var$readContext($b4fdfdeec9399ede$var$HostTransitionContext);
}
function $b4fdfdeec9399ede$var$updateId() {
    return $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
}
function $b4fdfdeec9399ede$var$updateRefresh() {
    return $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
}
function $b4fdfdeec9399ede$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $b4fdfdeec9399ede$var$requestUpdateLane();
                fiber = $b4fdfdeec9399ede$var$createUpdate(lane);
                var root$69 = $b4fdfdeec9399ede$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root$69, provider, lane), $b4fdfdeec9399ede$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $b4fdfdeec9399ede$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $b4fdfdeec9399ede$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $b4fdfdeec9399ede$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber) ? $b4fdfdeec9399ede$var$enqueueRenderPhaseUpdate(queue, action) : (action = $b4fdfdeec9399ede$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(action, fiber, lane), $b4fdfdeec9399ede$var$entangleTransitionUpdate(action, queue, lane)));
}
function $b4fdfdeec9399ede$var$dispatchSetState(fiber, queue, action) {
    var lane = $b4fdfdeec9399ede$var$requestUpdateLane();
    $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $b4fdfdeec9399ede$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber)) $b4fdfdeec9399ede$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($b4fdfdeec9399ede$var$objectIs(eagerState, currentState)) return $b4fdfdeec9399ede$var$enqueueUpdate$1(fiber, queue, update, 0), null === $b4fdfdeec9399ede$var$workInProgressRoot && $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $b4fdfdeec9399ede$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(action, fiber, lane), $b4fdfdeec9399ede$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $b4fdfdeec9399ede$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $b4fdfdeec9399ede$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $b4fdfdeec9399ede$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $b4fdfdeec9399ede$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $b4fdfdeec9399ede$var$currentlyRenderingFiber || null !== alternate && alternate === $b4fdfdeec9399ede$var$currentlyRenderingFiber;
}
function $b4fdfdeec9399ede$var$enqueueRenderPhaseUpdate(queue, update) {
    $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdateDuringThisPass = $b4fdfdeec9399ede$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $b4fdfdeec9399ede$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $b4fdfdeec9399ede$var$markRootEntangled(root, lane);
    }
}
var $b4fdfdeec9399ede$var$ContextOnlyDispatcher = {
    readContext: $b4fdfdeec9399ede$var$readContext,
    use: $b4fdfdeec9399ede$var$use,
    useCallback: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useContext: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useEffect: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useImperativeHandle: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useLayoutEffect: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useInsertionEffect: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useMemo: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useReducer: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useRef: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useState: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useDebugValue: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useDeferredValue: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useTransition: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useSyncExternalStore: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useId: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useHostTransitionStatus: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useFormState: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useActionState: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useOptimistic: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useMemoCache: $b4fdfdeec9399ede$var$throwInvalidHookError,
    useCacheRefresh: $b4fdfdeec9399ede$var$throwInvalidHookError
};
$b4fdfdeec9399ede$var$ContextOnlyDispatcher.useEffectEvent = $b4fdfdeec9399ede$var$throwInvalidHookError;
var $b4fdfdeec9399ede$var$HooksDispatcherOnMount = {
    readContext: $b4fdfdeec9399ede$var$readContext,
    use: $b4fdfdeec9399ede$var$use,
    useCallback: function(callback, deps) {
        $b4fdfdeec9399ede$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $b4fdfdeec9399ede$var$readContext,
    useEffect: $b4fdfdeec9399ede$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $b4fdfdeec9399ede$var$mountEffectImpl(4194308, 4, $b4fdfdeec9399ede$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $b4fdfdeec9399ede$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $b4fdfdeec9399ede$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($b4fdfdeec9399ede$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $b4fdfdeec9399ede$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $b4fdfdeec9399ede$var$dispatchReducerAction.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $b4fdfdeec9399ede$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $b4fdfdeec9399ede$var$dispatchSetState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $b4fdfdeec9399ede$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        return $b4fdfdeec9399ede$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $b4fdfdeec9399ede$var$mountStateImpl(!1);
        stateHook = $b4fdfdeec9399ede$var$startTransition.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $b4fdfdeec9399ede$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $b4fdfdeec9399ede$var$currentlyRenderingFiber, hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        if ($b4fdfdeec9399ede$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $b4fdfdeec9399ede$var$workInProgressRoot) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(349));
            0 !== ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 127) || $b4fdfdeec9399ede$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $b4fdfdeec9399ede$var$mountEffect($b4fdfdeec9399ede$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $b4fdfdeec9399ede$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b4fdfdeec9399ede$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook(), identifierPrefix = $b4fdfdeec9399ede$var$workInProgressRoot.identifierPrefix;
        if ($b4fdfdeec9399ede$var$isHydrating) {
            var JSCompiler_inline_result = $b4fdfdeec9399ede$var$treeContextOverflow;
            var idWithLeadingBit = $b4fdfdeec9399ede$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $b4fdfdeec9399ede$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $b4fdfdeec9399ede$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $b4fdfdeec9399ede$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $b4fdfdeec9399ede$var$useHostTransitionStatus,
    useFormState: $b4fdfdeec9399ede$var$mountActionState,
    useActionState: $b4fdfdeec9399ede$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $b4fdfdeec9399ede$var$dispatchOptimisticSetState.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $b4fdfdeec9399ede$var$useMemoCache,
    useCacheRefresh: function() {
        return $b4fdfdeec9399ede$var$mountWorkInProgressHook().memoizedState = $b4fdfdeec9399ede$var$refreshCache.bind(null, $b4fdfdeec9399ede$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $b4fdfdeec9399ede$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($b4fdfdeec9399ede$var$executionContext & 2)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $b4fdfdeec9399ede$var$HooksDispatcherOnUpdate = {
    readContext: $b4fdfdeec9399ede$var$readContext,
    use: $b4fdfdeec9399ede$var$use,
    useCallback: $b4fdfdeec9399ede$var$updateCallback,
    useContext: $b4fdfdeec9399ede$var$readContext,
    useEffect: $b4fdfdeec9399ede$var$updateEffect,
    useImperativeHandle: $b4fdfdeec9399ede$var$updateImperativeHandle,
    useInsertionEffect: $b4fdfdeec9399ede$var$updateInsertionEffect,
    useLayoutEffect: $b4fdfdeec9399ede$var$updateLayoutEffect,
    useMemo: $b4fdfdeec9399ede$var$updateMemo,
    useReducer: $b4fdfdeec9399ede$var$updateReducer,
    useRef: $b4fdfdeec9399ede$var$updateRef,
    useState: function() {
        return $b4fdfdeec9399ede$var$updateReducer($b4fdfdeec9399ede$var$basicStateReducer);
    },
    useDebugValue: $b4fdfdeec9399ede$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
        return $b4fdfdeec9399ede$var$updateDeferredValueImpl(hook, $b4fdfdeec9399ede$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b4fdfdeec9399ede$var$updateReducer($b4fdfdeec9399ede$var$basicStateReducer)[0], start = $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b4fdfdeec9399ede$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b4fdfdeec9399ede$var$updateSyncExternalStore,
    useId: $b4fdfdeec9399ede$var$updateId,
    useHostTransitionStatus: $b4fdfdeec9399ede$var$useHostTransitionStatus,
    useFormState: $b4fdfdeec9399ede$var$updateActionState,
    useActionState: $b4fdfdeec9399ede$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
        return $b4fdfdeec9399ede$var$updateOptimisticImpl(hook, $b4fdfdeec9399ede$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $b4fdfdeec9399ede$var$useMemoCache,
    useCacheRefresh: $b4fdfdeec9399ede$var$updateRefresh
};
$b4fdfdeec9399ede$var$HooksDispatcherOnUpdate.useEffectEvent = $b4fdfdeec9399ede$var$updateEvent;
var $b4fdfdeec9399ede$var$HooksDispatcherOnRerender = {
    readContext: $b4fdfdeec9399ede$var$readContext,
    use: $b4fdfdeec9399ede$var$use,
    useCallback: $b4fdfdeec9399ede$var$updateCallback,
    useContext: $b4fdfdeec9399ede$var$readContext,
    useEffect: $b4fdfdeec9399ede$var$updateEffect,
    useImperativeHandle: $b4fdfdeec9399ede$var$updateImperativeHandle,
    useInsertionEffect: $b4fdfdeec9399ede$var$updateInsertionEffect,
    useLayoutEffect: $b4fdfdeec9399ede$var$updateLayoutEffect,
    useMemo: $b4fdfdeec9399ede$var$updateMemo,
    useReducer: $b4fdfdeec9399ede$var$rerenderReducer,
    useRef: $b4fdfdeec9399ede$var$updateRef,
    useState: function() {
        return $b4fdfdeec9399ede$var$rerenderReducer($b4fdfdeec9399ede$var$basicStateReducer);
    },
    useDebugValue: $b4fdfdeec9399ede$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
        return null === $b4fdfdeec9399ede$var$currentHook ? $b4fdfdeec9399ede$var$mountDeferredValueImpl(hook, value, initialValue) : $b4fdfdeec9399ede$var$updateDeferredValueImpl(hook, $b4fdfdeec9399ede$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b4fdfdeec9399ede$var$rerenderReducer($b4fdfdeec9399ede$var$basicStateReducer)[0], start = $b4fdfdeec9399ede$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b4fdfdeec9399ede$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b4fdfdeec9399ede$var$updateSyncExternalStore,
    useId: $b4fdfdeec9399ede$var$updateId,
    useHostTransitionStatus: $b4fdfdeec9399ede$var$useHostTransitionStatus,
    useFormState: $b4fdfdeec9399ede$var$rerenderActionState,
    useActionState: $b4fdfdeec9399ede$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b4fdfdeec9399ede$var$updateWorkInProgressHook();
        if (null !== $b4fdfdeec9399ede$var$currentHook) return $b4fdfdeec9399ede$var$updateOptimisticImpl(hook, $b4fdfdeec9399ede$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $b4fdfdeec9399ede$var$useMemoCache,
    useCacheRefresh: $b4fdfdeec9399ede$var$updateRefresh
};
$b4fdfdeec9399ede$var$HooksDispatcherOnRerender.useEffectEvent = $b4fdfdeec9399ede$var$updateEvent;
function $b4fdfdeec9399ede$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $b4fdfdeec9399ede$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $b4fdfdeec9399ede$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b4fdfdeec9399ede$var$requestUpdateLane(), update = $b4fdfdeec9399ede$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b4fdfdeec9399ede$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(payload, inst, lane), $b4fdfdeec9399ede$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b4fdfdeec9399ede$var$requestUpdateLane(), update = $b4fdfdeec9399ede$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b4fdfdeec9399ede$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(payload, inst, lane), $b4fdfdeec9399ede$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $b4fdfdeec9399ede$var$requestUpdateLane(), update = $b4fdfdeec9399ede$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $b4fdfdeec9399ede$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(callback, inst, lane), $b4fdfdeec9399ede$var$entangleTransitions(callback, inst, lane));
    }
};
function $b4fdfdeec9399ede$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$b4fdfdeec9399ede$var$shallowEqual(oldProps, newProps) || !$b4fdfdeec9399ede$var$shallowEqual(oldState, newState) : !0;
}
function $b4fdfdeec9399ede$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $b4fdfdeec9399ede$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $b4fdfdeec9399ede$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $b4fdfdeec9399ede$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $b4fdfdeec9399ede$var$defaultOnUncaughtError(error) {
    $b4fdfdeec9399ede$var$reportGlobalError(error);
}
function $b4fdfdeec9399ede$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $b4fdfdeec9399ede$var$defaultOnRecoverableError(error) {
    $b4fdfdeec9399ede$var$reportGlobalError(error);
}
function $b4fdfdeec9399ede$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $b4fdfdeec9399ede$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $b4fdfdeec9399ede$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $b4fdfdeec9399ede$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $b4fdfdeec9399ede$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $b4fdfdeec9399ede$var$createClassErrorUpdate(lane) {
    lane = $b4fdfdeec9399ede$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $b4fdfdeec9399ede$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $b4fdfdeec9399ede$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $b4fdfdeec9399ede$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed ? $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $b4fdfdeec9399ede$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $b4fdfdeec9399ede$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $b4fdfdeec9399ede$var$shellBoundary ? $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $b4fdfdeec9399ede$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $b4fdfdeec9399ede$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $b4fdfdeec9399ede$var$attachPingListener(root, value, rootRenderLanes);
        $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($b4fdfdeec9399ede$var$isHydrating) return returnFiber = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $b4fdfdeec9399ede$var$HydrationMismatchException && (root = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(422), {
        cause: value
    }), $b4fdfdeec9399ede$var$queueHydrationError($b4fdfdeec9399ede$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $b4fdfdeec9399ede$var$HydrationMismatchException && (returnFiber = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(423), {
        cause: value
    }), $b4fdfdeec9399ede$var$queueHydrationError($b4fdfdeec9399ede$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $b4fdfdeec9399ede$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $b4fdfdeec9399ede$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors ? $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $b4fdfdeec9399ede$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $b4fdfdeec9399ede$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed || !$b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $b4fdfdeec9399ede$var$createClassErrorUpdate(rootRenderLanes), $b4fdfdeec9399ede$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $b4fdfdeec9399ede$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $b4fdfdeec9399ede$var$SelectiveHydrationException = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(461)), $b4fdfdeec9399ede$var$didReceiveUpdate = !1;
function $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $b4fdfdeec9399ede$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $b4fdfdeec9399ede$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress);
    nextProps = $b4fdfdeec9399ede$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $b4fdfdeec9399ede$var$checkDidRenderIdHook();
    if (null !== current && !$b4fdfdeec9399ede$var$didReceiveUpdate) return $b4fdfdeec9399ede$var$bailoutHooks(current, workInProgress, renderLanes), $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b4fdfdeec9399ede$var$isHydrating && key && $b4fdfdeec9399ede$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$b4fdfdeec9399ede$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $b4fdfdeec9399ede$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $b4fdfdeec9399ede$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$b4fdfdeec9399ede$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $b4fdfdeec9399ede$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $b4fdfdeec9399ede$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $b4fdfdeec9399ede$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($b4fdfdeec9399ede$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($b4fdfdeec9399ede$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $b4fdfdeec9399ede$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($b4fdfdeec9399ede$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $b4fdfdeec9399ede$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $b4fdfdeec9399ede$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $b4fdfdeec9399ede$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $b4fdfdeec9399ede$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $b4fdfdeec9399ede$var$pushHiddenContext(workInProgress, prevState) : $b4fdfdeec9399ede$var$reuseHiddenContextOnStack(), $b4fdfdeec9399ede$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $b4fdfdeec9399ede$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($b4fdfdeec9399ede$var$pushTransition(workInProgress, prevState.cachePool), $b4fdfdeec9399ede$var$pushHiddenContext(workInProgress, prevState), $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $b4fdfdeec9399ede$var$pushTransition(workInProgress, null), $b4fdfdeec9399ede$var$reuseHiddenContextOnStack(), $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress));
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $b4fdfdeec9399ede$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $b4fdfdeec9399ede$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $b4fdfdeec9399ede$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $b4fdfdeec9399ede$var$pushTransition(workInProgress, null);
    $b4fdfdeec9399ede$var$reuseHiddenContextOnStack();
    $b4fdfdeec9399ede$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $b4fdfdeec9399ede$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $b4fdfdeec9399ede$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b4fdfdeec9399ede$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $b4fdfdeec9399ede$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($b4fdfdeec9399ede$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $b4fdfdeec9399ede$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $b4fdfdeec9399ede$var$bailoutOffscreenComponent(null, current);
            $b4fdfdeec9399ede$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $b4fdfdeec9399ede$var$nextHydratableInstance) ? (current = $b4fdfdeec9399ede$var$canHydrateHydrationBoundary(current, $b4fdfdeec9399ede$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b4fdfdeec9399ede$var$treeContextProvider ? {
                    id: $b4fdfdeec9399ede$var$treeContextId,
                    overflow: $b4fdfdeec9399ede$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b4fdfdeec9399ede$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $b4fdfdeec9399ede$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $b4fdfdeec9399ede$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $b4fdfdeec9399ede$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(558));
        } else if ($b4fdfdeec9399ede$var$didReceiveUpdate || $b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $b4fdfdeec9399ede$var$didReceiveUpdate || didSuspend) {
            nextProps = $b4fdfdeec9399ede$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $b4fdfdeec9399ede$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(current, dehydrated), $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $b4fdfdeec9399ede$var$SelectiveHydrationException;
            $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b4fdfdeec9399ede$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(dehydrated.nextSibling), $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$isHydrating = !0, $b4fdfdeec9399ede$var$hydrationErrors = null, $b4fdfdeec9399ede$var$rootOrSingletonContext = !1, null !== current && $b4fdfdeec9399ede$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b4fdfdeec9399ede$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $b4fdfdeec9399ede$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $b4fdfdeec9399ede$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $b4fdfdeec9399ede$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress);
    Component = $b4fdfdeec9399ede$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $b4fdfdeec9399ede$var$checkDidRenderIdHook();
    if (null !== current && !$b4fdfdeec9399ede$var$didReceiveUpdate) return $b4fdfdeec9399ede$var$bailoutHooks(current, workInProgress, renderLanes), $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b4fdfdeec9399ede$var$isHydrating && nextProps && $b4fdfdeec9399ede$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $b4fdfdeec9399ede$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $b4fdfdeec9399ede$var$finishRenderingHooks(current);
    Component = $b4fdfdeec9399ede$var$checkDidRenderIdHook();
    if (null !== current && !$b4fdfdeec9399ede$var$didReceiveUpdate) return $b4fdfdeec9399ede$var$bailoutHooks(current, workInProgress, renderLanes), $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b4fdfdeec9399ede$var$isHydrating && Component && $b4fdfdeec9399ede$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $b4fdfdeec9399ede$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $b4fdfdeec9399ede$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $b4fdfdeec9399ede$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $b4fdfdeec9399ede$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $b4fdfdeec9399ede$var$readContext(contextType) : $b4fdfdeec9399ede$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($b4fdfdeec9399ede$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $b4fdfdeec9399ede$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $b4fdfdeec9399ede$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $b4fdfdeec9399ede$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $b4fdfdeec9399ede$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $b4fdfdeec9399ede$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $b4fdfdeec9399ede$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $b4fdfdeec9399ede$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($b4fdfdeec9399ede$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $b4fdfdeec9399ede$var$hasForceUpdate || $b4fdfdeec9399ede$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $b4fdfdeec9399ede$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $b4fdfdeec9399ede$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $b4fdfdeec9399ede$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $b4fdfdeec9399ede$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $b4fdfdeec9399ede$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $b4fdfdeec9399ede$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $b4fdfdeec9399ede$var$hasForceUpdate || null !== current && null !== current.dependencies && $b4fdfdeec9399ede$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($b4fdfdeec9399ede$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $b4fdfdeec9399ede$var$hasForceUpdate || $b4fdfdeec9399ede$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $b4fdfdeec9399ede$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $b4fdfdeec9399ede$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $b4fdfdeec9399ede$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $b4fdfdeec9399ede$var$resetHydrationState();
    workInProgress.flags |= 256;
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $b4fdfdeec9399ede$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $b4fdfdeec9399ede$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $b4fdfdeec9399ede$var$getSuspendedCache()
    };
}
function $b4fdfdeec9399ede$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $b4fdfdeec9399ede$var$workInProgressDeferredLane);
    return current;
}
function $b4fdfdeec9399ede$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($b4fdfdeec9399ede$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($b4fdfdeec9399ede$var$isHydrating) {
            showFallback ? $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $b4fdfdeec9399ede$var$nextHydratableInstance) ? (current = $b4fdfdeec9399ede$var$canHydrateHydrationBoundary(current, $b4fdfdeec9399ede$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b4fdfdeec9399ede$var$treeContextProvider ? {
                    id: $b4fdfdeec9399ede$var$treeContextId,
                    overflow: $b4fdfdeec9399ede$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b4fdfdeec9399ede$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress);
            $b4fdfdeec9399ede$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $b4fdfdeec9399ede$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $b4fdfdeec9399ede$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b4fdfdeec9399ede$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b4fdfdeec9399ede$var$SUSPENDED_MARKER, $b4fdfdeec9399ede$var$bailoutOffscreenComponent(null, nextProps);
        $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $b4fdfdeec9399ede$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $b4fdfdeec9399ede$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $b4fdfdeec9399ede$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $b4fdfdeec9399ede$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b4fdfdeec9399ede$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b4fdfdeec9399ede$var$SUSPENDED_MARKER, workInProgress = $b4fdfdeec9399ede$var$bailoutOffscreenComponent(null, nextProps));
        else if ($b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress), $b4fdfdeec9399ede$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($b4fdfdeec9399ede$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $b4fdfdeec9399ede$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $b4fdfdeec9399ede$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($b4fdfdeec9399ede$var$didReceiveUpdate || $b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $b4fdfdeec9399ede$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $b4fdfdeec9399ede$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $b4fdfdeec9399ede$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(current, nextProps), $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $b4fdfdeec9399ede$var$SelectiveHydrationException;
            $b4fdfdeec9399ede$var$isSuspenseInstancePending(nextPrimaryChildren) || $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b4fdfdeec9399ede$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $b4fdfdeec9399ede$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(nextPrimaryChildren.nextSibling), $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$isHydrating = !0, $b4fdfdeec9399ede$var$hydrationErrors = null, $b4fdfdeec9399ede$var$rootOrSingletonContext = !1, null !== current && $b4fdfdeec9399ede$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b4fdfdeec9399ede$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $b4fdfdeec9399ede$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $b4fdfdeec9399ede$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $b4fdfdeec9399ede$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $b4fdfdeec9399ede$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b4fdfdeec9399ede$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $b4fdfdeec9399ede$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $b4fdfdeec9399ede$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $b4fdfdeec9399ede$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $b4fdfdeec9399ede$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b4fdfdeec9399ede$var$SUSPENDED_MARKER, $b4fdfdeec9399ede$var$bailoutOffscreenComponent(current.child, nextProps);
    $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $b4fdfdeec9399ede$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $b4fdfdeec9399ede$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $b4fdfdeec9399ede$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $b4fdfdeec9399ede$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $b4fdfdeec9399ede$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b4fdfdeec9399ede$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $b4fdfdeec9399ede$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $b4fdfdeec9399ede$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $b4fdfdeec9399ede$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $b4fdfdeec9399ede$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $b4fdfdeec9399ede$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, suspenseContext);
    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $b4fdfdeec9399ede$var$isHydrating ? $b4fdfdeec9399ede$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $b4fdfdeec9399ede$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $b4fdfdeec9399ede$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $b4fdfdeec9399ede$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $b4fdfdeec9399ede$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $b4fdfdeec9399ede$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $b4fdfdeec9399ede$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $b4fdfdeec9399ede$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $b4fdfdeec9399ede$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $b4fdfdeec9399ede$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $b4fdfdeec9399ede$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $b4fdfdeec9399ede$var$checkIfContextChanged(current) ? !0 : !1;
}
function $b4fdfdeec9399ede$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $b4fdfdeec9399ede$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, current.memoizedState.cache);
            $b4fdfdeec9399ede$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $b4fdfdeec9399ede$var$pushHostContext(workInProgress);
            break;
        case 4:
            $b4fdfdeec9399ede$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $b4fdfdeec9399ede$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $b4fdfdeec9399ede$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $b4fdfdeec9399ede$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $b4fdfdeec9399ede$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($b4fdfdeec9399ede$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $b4fdfdeec9399ede$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $b4fdfdeec9399ede$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, current.memoizedState.cache);
    }
    return $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $b4fdfdeec9399ede$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $b4fdfdeec9399ede$var$didReceiveUpdate = !0;
        else {
            if (!$b4fdfdeec9399ede$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $b4fdfdeec9399ede$var$didReceiveUpdate = !1, $b4fdfdeec9399ede$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $b4fdfdeec9399ede$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $b4fdfdeec9399ede$var$didReceiveUpdate = !1, $b4fdfdeec9399ede$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $b4fdfdeec9399ede$var$pushTreeId(workInProgress, $b4fdfdeec9399ede$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $b4fdfdeec9399ede$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $b4fdfdeec9399ede$var$shouldConstruct(current) ? (props = $b4fdfdeec9399ede$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $b4fdfdeec9399ede$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $b4fdfdeec9399ede$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $b4fdfdeec9399ede$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $b4fdfdeec9399ede$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $b4fdfdeec9399ede$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $b4fdfdeec9399ede$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $b4fdfdeec9399ede$var$getComponentNameFromType(current) || current;
                    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $b4fdfdeec9399ede$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $b4fdfdeec9399ede$var$resolveClassComponentProps(props, workInProgress.pendingProps), $b4fdfdeec9399ede$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $b4fdfdeec9399ede$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $b4fdfdeec9399ede$var$cloneUpdateQueue(current, workInProgress);
                $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, props);
                props !== prevState.cache && $b4fdfdeec9399ede$var$propagateContextChanges(workInProgress, [
                    $b4fdfdeec9399ede$var$CacheContext
                ], renderLanes, !0);
                $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $b4fdfdeec9399ede$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(Error($b4fdfdeec9399ede$var$formatProdErrorMessage(424)), workInProgress);
                        $b4fdfdeec9399ede$var$queueHydrationError($$typeof);
                        workInProgress = $b4fdfdeec9399ede$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(current.firstChild);
                        $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress;
                        $b4fdfdeec9399ede$var$isHydrating = !0;
                        $b4fdfdeec9399ede$var$hydrationErrors = null;
                        $b4fdfdeec9399ede$var$rootOrSingletonContext = !0;
                        renderLanes = $b4fdfdeec9399ede$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $b4fdfdeec9399ede$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $b4fdfdeec9399ede$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $b4fdfdeec9399ede$var$markRef(current, workInProgress), null === current ? (renderLanes = $b4fdfdeec9399ede$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $b4fdfdeec9399ede$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer($b4fdfdeec9399ede$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress, props[$b4fdfdeec9399ede$var$internalPropsKey] = current, $b4fdfdeec9399ede$var$setInitialProperties(props, renderLanes, current), $b4fdfdeec9399ede$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $b4fdfdeec9399ede$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $b4fdfdeec9399ede$var$pushHostContext(workInProgress), null === current && $b4fdfdeec9399ede$var$isHydrating && (props = workInProgress.stateNode = $b4fdfdeec9399ede$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $b4fdfdeec9399ede$var$rootInstanceStackCursor.current), $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$rootOrSingletonContext = !0, $$typeof = $b4fdfdeec9399ede$var$nextHydratableInstance, $b4fdfdeec9399ede$var$isSingletonScope(workInProgress.type) ? ($b4fdfdeec9399ede$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(props.firstChild)) : $b4fdfdeec9399ede$var$nextHydratableInstance = $$typeof), $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $b4fdfdeec9399ede$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $b4fdfdeec9399ede$var$isHydrating) {
                if ($$typeof = props = $b4fdfdeec9399ede$var$nextHydratableInstance) props = $b4fdfdeec9399ede$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $b4fdfdeec9399ede$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$nextHydratableInstance = $b4fdfdeec9399ede$var$getNextHydratable(props.firstChild), $b4fdfdeec9399ede$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress);
            }
            $b4fdfdeec9399ede$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $b4fdfdeec9399ede$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $b4fdfdeec9399ede$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $b4fdfdeec9399ede$var$renderWithHooks(current, workInProgress, $b4fdfdeec9399ede$var$TransitionAwareHostComponent, null, null, renderLanes), $b4fdfdeec9399ede$var$HostTransitionContext._currentValue = $$typeof);
            $b4fdfdeec9399ede$var$markRef(current, workInProgress);
            $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $b4fdfdeec9399ede$var$isHydrating) {
                if (current = renderLanes = $b4fdfdeec9399ede$var$nextHydratableInstance) renderLanes = $b4fdfdeec9399ede$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $b4fdfdeec9399ede$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $b4fdfdeec9399ede$var$hydrationParentFiber = workInProgress, $b4fdfdeec9399ede$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $b4fdfdeec9399ede$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $b4fdfdeec9399ede$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $b4fdfdeec9399ede$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $b4fdfdeec9399ede$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $b4fdfdeec9399ede$var$pushProvider(workInProgress, workInProgress.type, props.value), $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress), $$typeof = $b4fdfdeec9399ede$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $b4fdfdeec9399ede$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $b4fdfdeec9399ede$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $b4fdfdeec9399ede$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $b4fdfdeec9399ede$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $b4fdfdeec9399ede$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $b4fdfdeec9399ede$var$prepareToReadContext(workInProgress), props = $b4fdfdeec9399ede$var$readContext($b4fdfdeec9399ede$var$CacheContext), null === current ? ($$typeof = $b4fdfdeec9399ede$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $b4fdfdeec9399ede$var$workInProgressRoot, prevState = $b4fdfdeec9399ede$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $b4fdfdeec9399ede$var$initializeUpdateQueue(workInProgress), $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($b4fdfdeec9399ede$var$cloneUpdateQueue(current, workInProgress), $b4fdfdeec9399ede$var$processUpdateQueue(workInProgress, null, null, renderLanes), $b4fdfdeec9399ede$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, props)) : (props = prevState.cache, $b4fdfdeec9399ede$var$pushProvider(workInProgress, $b4fdfdeec9399ede$var$CacheContext, props), props !== $$typeof.cache && $b4fdfdeec9399ede$var$propagateContextChanges(workInProgress, [
                $b4fdfdeec9399ede$var$CacheContext
            ], renderLanes, !0))), $b4fdfdeec9399ede$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b4fdfdeec9399ede$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $b4fdfdeec9399ede$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($b4fdfdeec9399ede$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $b4fdfdeec9399ede$var$suspendedThenable = $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable, $b4fdfdeec9399ede$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $b4fdfdeec9399ede$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$b4fdfdeec9399ede$var$preloadResource(resource)) {
        if ($b4fdfdeec9399ede$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $b4fdfdeec9399ede$var$suspendedThenable = $b4fdfdeec9399ede$var$noopSuspenseyCommitThenable, $b4fdfdeec9399ede$var$SuspenseyCommitException;
    }
}
function $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $b4fdfdeec9399ede$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $b4fdfdeec9399ede$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$b4fdfdeec9399ede$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $b4fdfdeec9399ede$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $b4fdfdeec9399ede$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $b4fdfdeec9399ede$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 1:
            return $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext);
            $b4fdfdeec9399ede$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $b4fdfdeec9399ede$var$popHydrationState(workInProgress) ? $b4fdfdeec9399ede$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $b4fdfdeec9399ede$var$upgradeHydrationErrorsToRecoverable());
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($b4fdfdeec9399ede$var$markUpdate(workInProgress), null !== nextResource ? ($b4fdfdeec9399ede$var$bubbleProperties(workInProgress), $b4fdfdeec9399ede$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b4fdfdeec9399ede$var$bubbleProperties(workInProgress), $b4fdfdeec9399ede$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($b4fdfdeec9399ede$var$markUpdate(workInProgress), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), $b4fdfdeec9399ede$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b4fdfdeec9399ede$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), $b4fdfdeec9399ede$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $b4fdfdeec9399ede$var$popHostContext(workInProgress);
            renderLanes = $b4fdfdeec9399ede$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(166));
                    $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b4fdfdeec9399ede$var$contextStackCursor.current;
                $b4fdfdeec9399ede$var$popHydrationState(workInProgress) ? $b4fdfdeec9399ede$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $b4fdfdeec9399ede$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $b4fdfdeec9399ede$var$markUpdate(workInProgress));
            }
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $b4fdfdeec9399ede$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(166));
                    $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $b4fdfdeec9399ede$var$contextStackCursor.current;
                if ($b4fdfdeec9399ede$var$popHydrationState(workInProgress)) $b4fdfdeec9399ede$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer($b4fdfdeec9399ede$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress;
                    nextResource[$b4fdfdeec9399ede$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($b4fdfdeec9399ede$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress);
                }
            }
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            $b4fdfdeec9399ede$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b4fdfdeec9399ede$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(166));
                current = $b4fdfdeec9399ede$var$rootInstanceStackCursor.current;
                if ($b4fdfdeec9399ede$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $b4fdfdeec9399ede$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $b4fdfdeec9399ede$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $b4fdfdeec9399ede$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $b4fdfdeec9399ede$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(557));
                        current[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress;
                    } else $b4fdfdeec9399ede$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $b4fdfdeec9399ede$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(558));
            }
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $b4fdfdeec9399ede$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(317));
                        type[$b4fdfdeec9399ede$var$internalInstanceKey] = workInProgress;
                    } else $b4fdfdeec9399ede$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $b4fdfdeec9399ede$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $b4fdfdeec9399ede$var$popHostContainer(), null === current && $b4fdfdeec9399ede$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 10:
            return $b4fdfdeec9399ede$var$popProvider(workInProgress.type), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 19:
            $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $b4fdfdeec9399ede$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $b4fdfdeec9399ede$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $b4fdfdeec9399ede$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $b4fdfdeec9399ede$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$b4fdfdeec9399ede$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, $b4fdfdeec9399ede$var$suspenseStackCursor.current & 1 | 2);
                            $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $b4fdfdeec9399ede$var$now() > $b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $b4fdfdeec9399ede$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $b4fdfdeec9399ede$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, current), $b4fdfdeec9399ede$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$b4fdfdeec9399ede$var$isHydrating) return $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
                    } else 2 * $b4fdfdeec9399ede$var$now() - newProps.renderingStartTime > $b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $b4fdfdeec9399ede$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $b4fdfdeec9399ede$var$now(), current.sibling = null, renderLanes = $b4fdfdeec9399ede$var$suspenseStackCursor.current, $b4fdfdeec9399ede$var$push($b4fdfdeec9399ede$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $b4fdfdeec9399ede$var$isHydrating && $b4fdfdeec9399ede$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $b4fdfdeec9399ede$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress), $b4fdfdeec9399ede$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($b4fdfdeec9399ede$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $b4fdfdeec9399ede$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext), $b4fdfdeec9399ede$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b4fdfdeec9399ede$var$unwindWork(current, workInProgress) {
    $b4fdfdeec9399ede$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext), $b4fdfdeec9399ede$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $b4fdfdeec9399ede$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(340));
                $b4fdfdeec9399ede$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(340));
                $b4fdfdeec9399ede$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseStackCursor), null;
        case 4:
            return $b4fdfdeec9399ede$var$popHostContainer(), null;
        case 10:
            return $b4fdfdeec9399ede$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $b4fdfdeec9399ede$var$popSuspenseHandler(workInProgress), $b4fdfdeec9399ede$var$popHiddenContext(), null !== current && $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $b4fdfdeec9399ede$var$unwindInterruptedWork(current, interruptedWork) {
    $b4fdfdeec9399ede$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext);
            $b4fdfdeec9399ede$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $b4fdfdeec9399ede$var$popHostContext(interruptedWork);
            break;
        case 4:
            $b4fdfdeec9399ede$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $b4fdfdeec9399ede$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $b4fdfdeec9399ede$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$suspenseStackCursor);
            break;
        case 10:
            $b4fdfdeec9399ede$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $b4fdfdeec9399ede$var$popSuspenseHandler(interruptedWork);
            $b4fdfdeec9399ede$var$popHiddenContext();
            null !== current && $b4fdfdeec9399ede$var$pop($b4fdfdeec9399ede$var$resumedCache);
            break;
        case 24:
            $b4fdfdeec9399ede$var$popProvider($b4fdfdeec9399ede$var$CacheContext);
    }
}
function $b4fdfdeec9399ede$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $b4fdfdeec9399ede$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $b4fdfdeec9399ede$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b4fdfdeec9399ede$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $b4fdfdeec9399ede$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b4fdfdeec9399ede$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b4fdfdeec9399ede$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $b4fdfdeec9399ede$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $b4fdfdeec9399ede$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$b4fdfdeec9399ede$var$internalPropsKey] = newProps;
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $b4fdfdeec9399ede$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $b4fdfdeec9399ede$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $b4fdfdeec9399ede$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $b4fdfdeec9399ede$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $b4fdfdeec9399ede$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $b4fdfdeec9399ede$var$noop$1));
    else if (4 !== tag && (27 === tag && $b4fdfdeec9399ede$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($b4fdfdeec9399ede$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$b4fdfdeec9399ede$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $b4fdfdeec9399ede$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $b4fdfdeec9399ede$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($b4fdfdeec9399ede$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$b4fdfdeec9399ede$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $b4fdfdeec9399ede$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $b4fdfdeec9399ede$var$setInitialProperties(singleton, type, props);
        singleton[$b4fdfdeec9399ede$var$internalInstanceKey] = finishedWork;
        singleton[$b4fdfdeec9399ede$var$internalPropsKey] = props;
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = !1, $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = !1, $b4fdfdeec9399ede$var$needsFormReset = !1, $b4fdfdeec9399ede$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $b4fdfdeec9399ede$var$nextEffect = null;
function $b4fdfdeec9399ede$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $b4fdfdeec9399ede$var$eventsEnabled = $b4fdfdeec9399ede$var$_enabled;
    root = $b4fdfdeec9399ede$var$getActiveElementDeep(root);
    if ($b4fdfdeec9399ede$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $b4fdfdeec9399ede$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $b4fdfdeec9399ede$var$_enabled = !1;
    for($b4fdfdeec9399ede$var$nextEffect = firstChild; null !== $b4fdfdeec9399ede$var$nextEffect;)if (firstChild = $b4fdfdeec9399ede$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $b4fdfdeec9399ede$var$nextEffect = root;
    else for(; null !== $b4fdfdeec9399ede$var$nextEffect;){
        firstChild = $b4fdfdeec9399ede$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $b4fdfdeec9399ede$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $b4fdfdeec9399ede$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $b4fdfdeec9399ede$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $b4fdfdeec9399ede$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $b4fdfdeec9399ede$var$nextEffect = root;
            break;
        }
        $b4fdfdeec9399ede$var$nextEffect = firstChild.return;
    }
}
function $b4fdfdeec9399ede$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b4fdfdeec9399ede$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $b4fdfdeec9399ede$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $b4fdfdeec9399ede$var$commitClassCallbacks(finishedWork);
            flags & 512 && $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $b4fdfdeec9399ede$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $b4fdfdeec9399ede$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $b4fdfdeec9399ede$var$commitHostMount(finishedWork);
            flags & 512 && $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b4fdfdeec9399ede$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b4fdfdeec9399ede$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $b4fdfdeec9399ede$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $b4fdfdeec9399ede$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden;
                prevProps = $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden;
                $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = flags;
                ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = prevProps;
                $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $b4fdfdeec9399ede$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $b4fdfdeec9399ede$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $b4fdfdeec9399ede$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $b4fdfdeec9399ede$var$hostParent = null, $b4fdfdeec9399ede$var$hostParentIsContainer = !1;
function $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$b4fdfdeec9399ede$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $b4fdfdeec9399ede$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($b4fdfdeec9399ede$var$injectedHook && "function" === typeof $b4fdfdeec9399ede$var$injectedHook.onCommitFiberUnmount) try {
        $b4fdfdeec9399ede$var$injectedHook.onCommitFiberUnmount($b4fdfdeec9399ede$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $b4fdfdeec9399ede$var$hostParent, prevHostParentIsContainer = $b4fdfdeec9399ede$var$hostParentIsContainer;
            $b4fdfdeec9399ede$var$isSingletonScope(deletedFiber.type) && ($b4fdfdeec9399ede$var$hostParent = deletedFiber.stateNode, $b4fdfdeec9399ede$var$hostParentIsContainer = !1);
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b4fdfdeec9399ede$var$releaseSingletonInstance(deletedFiber.stateNode);
            $b4fdfdeec9399ede$var$hostParent = prevHostParent;
            $b4fdfdeec9399ede$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $b4fdfdeec9399ede$var$hostParent;
            prevHostParentIsContainer = $b4fdfdeec9399ede$var$hostParentIsContainer;
            $b4fdfdeec9399ede$var$hostParent = null;
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b4fdfdeec9399ede$var$hostParent = prevHostParent;
            $b4fdfdeec9399ede$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $b4fdfdeec9399ede$var$hostParent) {
                if ($b4fdfdeec9399ede$var$hostParentIsContainer) try {
                    (9 === $b4fdfdeec9399ede$var$hostParent.nodeType ? $b4fdfdeec9399ede$var$hostParent.body : "HTML" === $b4fdfdeec9399ede$var$hostParent.nodeName ? $b4fdfdeec9399ede$var$hostParent.ownerDocument.body : $b4fdfdeec9399ede$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $b4fdfdeec9399ede$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $b4fdfdeec9399ede$var$hostParent && ($b4fdfdeec9399ede$var$hostParentIsContainer ? (finishedRoot = $b4fdfdeec9399ede$var$hostParent, $b4fdfdeec9399ede$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $b4fdfdeec9399ede$var$retryIfBlockedOn(finishedRoot)) : $b4fdfdeec9399ede$var$clearHydrationBoundary($b4fdfdeec9399ede$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $b4fdfdeec9399ede$var$hostParent;
            prevHostParentIsContainer = $b4fdfdeec9399ede$var$hostParentIsContainer;
            $b4fdfdeec9399ede$var$hostParent = deletedFiber.stateNode.containerInfo;
            $b4fdfdeec9399ede$var$hostParentIsContainer = !0;
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b4fdfdeec9399ede$var$hostParent = prevHostParent;
            $b4fdfdeec9399ede$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $b4fdfdeec9399ede$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || ($b4fdfdeec9399ede$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $b4fdfdeec9399ede$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = (prevHostParent = $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $b4fdfdeec9399ede$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $b4fdfdeec9399ede$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b4fdfdeec9399ede$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $b4fdfdeec9399ede$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b4fdfdeec9399ede$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $b4fdfdeec9399ede$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $b4fdfdeec9399ede$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $b4fdfdeec9399ede$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $b4fdfdeec9399ede$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($b4fdfdeec9399ede$var$isSingletonScope(parent.type)) {
                        $b4fdfdeec9399ede$var$hostParent = parent.stateNode;
                        $b4fdfdeec9399ede$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $b4fdfdeec9399ede$var$hostParent = parent.stateNode;
                    $b4fdfdeec9399ede$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $b4fdfdeec9399ede$var$hostParent = parent.stateNode.containerInfo;
                    $b4fdfdeec9399ede$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $b4fdfdeec9399ede$var$hostParent) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(160));
        $b4fdfdeec9399ede$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $b4fdfdeec9399ede$var$hostParent = null;
        $b4fdfdeec9399ede$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $b4fdfdeec9399ede$var$currentHoistableRoot = null;
function $b4fdfdeec9399ede$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($b4fdfdeec9399ede$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $b4fdfdeec9399ede$var$commitHookEffectListMount(3, finishedWork), $b4fdfdeec9399ede$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || null === current || $b4fdfdeec9399ede$var$safelyDetachRef(current, current.return));
            flags & 64 && $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $b4fdfdeec9399ede$var$currentHoistableRoot;
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || null === current || $b4fdfdeec9399ede$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$b4fdfdeec9399ede$var$internalHoistableMarker] || currentResource[$b4fdfdeec9399ede$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $b4fdfdeec9399ede$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$b4fdfdeec9399ede$var$internalInstanceKey] = finishedWork;
                                        $b4fdfdeec9399ede$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $b4fdfdeec9399ede$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b4fdfdeec9399ede$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $b4fdfdeec9399ede$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b4fdfdeec9399ede$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$b4fdfdeec9399ede$var$internalInstanceKey] = finishedWork;
                                $b4fdfdeec9399ede$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $b4fdfdeec9399ede$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $b4fdfdeec9399ede$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $b4fdfdeec9399ede$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $b4fdfdeec9399ede$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $b4fdfdeec9399ede$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || null === current || $b4fdfdeec9399ede$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $b4fdfdeec9399ede$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || null === current || $b4fdfdeec9399ede$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $b4fdfdeec9399ede$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $b4fdfdeec9399ede$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($b4fdfdeec9399ede$var$needsFormReset = !0);
            break;
        case 6:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $b4fdfdeec9399ede$var$tagCaches = null;
            hoistableRoot = $b4fdfdeec9399ede$var$currentHoistableRoot;
            $b4fdfdeec9399ede$var$currentHoistableRoot = $b4fdfdeec9399ede$var$getHoistableRoot(root.containerInfo);
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$currentHoistableRoot = hoistableRoot;
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $b4fdfdeec9399ede$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $b4fdfdeec9399ede$var$needsFormReset && ($b4fdfdeec9399ede$var$needsFormReset = !1, $b4fdfdeec9399ede$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $b4fdfdeec9399ede$var$currentHoistableRoot;
            $b4fdfdeec9399ede$var$currentHoistableRoot = $b4fdfdeec9399ede$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            $b4fdfdeec9399ede$var$currentHoistableRoot = flags;
            break;
        case 12:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($b4fdfdeec9399ede$var$globalMostRecentFallbackTime = $b4fdfdeec9399ede$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden;
            $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $b4fdfdeec9399ede$var$offscreenSubtreeIsHidden || $b4fdfdeec9399ede$var$offscreenSubtreeWasHidden || $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $b4fdfdeec9399ede$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $b4fdfdeec9399ede$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $b4fdfdeec9399ede$var$hideOrUnhideDehydratedBoundary(instance, !0) : $b4fdfdeec9399ede$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $b4fdfdeec9399ede$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b4fdfdeec9399ede$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraverseMutationEffects(root, finishedWork), $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork);
    }
}
function $b4fdfdeec9399ede$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($b4fdfdeec9399ede$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $b4fdfdeec9399ede$var$getHostSibling(finishedWork);
                    $b4fdfdeec9399ede$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($b4fdfdeec9399ede$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $b4fdfdeec9399ede$var$getHostSibling(finishedWork);
                    $b4fdfdeec9399ede$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $b4fdfdeec9399ede$var$getHostSibling(finishedWork);
                    $b4fdfdeec9399ede$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $b4fdfdeec9399ede$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $b4fdfdeec9399ede$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $b4fdfdeec9399ede$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $b4fdfdeec9399ede$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $b4fdfdeec9399ede$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $b4fdfdeec9399ede$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $b4fdfdeec9399ede$var$safelyDetachRef(finishedWork, finishedWork.return);
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b4fdfdeec9399ede$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$b4fdfdeec9399ede$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $b4fdfdeec9399ede$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $b4fdfdeec9399ede$var$commitClassCallbacks(finishedWork);
                $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $b4fdfdeec9399ede$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $b4fdfdeec9399ede$var$commitHostMount(finishedWork);
                $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b4fdfdeec9399ede$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b4fdfdeec9399ede$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b4fdfdeec9399ede$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $b4fdfdeec9399ede$var$releaseCache(previousCache));
}
function $b4fdfdeec9399ede$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $b4fdfdeec9399ede$var$releaseCache(current));
}
function $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $b4fdfdeec9399ede$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b4fdfdeec9399ede$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $b4fdfdeec9399ede$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $b4fdfdeec9399ede$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $b4fdfdeec9399ede$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b4fdfdeec9399ede$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $b4fdfdeec9399ede$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $b4fdfdeec9399ede$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $b4fdfdeec9399ede$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b4fdfdeec9399ede$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b4fdfdeec9399ede$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $b4fdfdeec9399ede$var$suspenseyCommitFlag = 8192;
function $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $b4fdfdeec9399ede$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $b4fdfdeec9399ede$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $b4fdfdeec9399ede$var$suspenseyCommitFlag && null !== fiber.memoizedState && $b4fdfdeec9399ede$var$suspendResource(suspendedState, $b4fdfdeec9399ede$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $b4fdfdeec9399ede$var$currentHoistableRoot;
            $b4fdfdeec9399ede$var$currentHoistableRoot = $b4fdfdeec9399ede$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $b4fdfdeec9399ede$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $b4fdfdeec9399ede$var$suspenseyCommitFlag, $b4fdfdeec9399ede$var$suspenseyCommitFlag = 16777216, $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $b4fdfdeec9399ede$var$suspenseyCommitFlag = previousHoistableRoot) : $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $b4fdfdeec9399ede$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b4fdfdeec9399ede$var$nextEffect = childToDelete;
            $b4fdfdeec9399ede$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b4fdfdeec9399ede$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b4fdfdeec9399ede$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b4fdfdeec9399ede$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $b4fdfdeec9399ede$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $b4fdfdeec9399ede$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b4fdfdeec9399ede$var$nextEffect = childToDelete;
            $b4fdfdeec9399ede$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b4fdfdeec9399ede$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $b4fdfdeec9399ede$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $b4fdfdeec9399ede$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b4fdfdeec9399ede$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $b4fdfdeec9399ede$var$nextEffect;){
        var fiber = $b4fdfdeec9399ede$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $b4fdfdeec9399ede$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $b4fdfdeec9399ede$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $b4fdfdeec9399ede$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $b4fdfdeec9399ede$var$nextEffect;){
            cache = $b4fdfdeec9399ede$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $b4fdfdeec9399ede$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $b4fdfdeec9399ede$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $b4fdfdeec9399ede$var$nextEffect = sibling;
                break a;
            }
            $b4fdfdeec9399ede$var$nextEffect = returnFiber;
        }
    }
}
var $b4fdfdeec9399ede$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $b4fdfdeec9399ede$var$readContext($b4fdfdeec9399ede$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $b4fdfdeec9399ede$var$readContext($b4fdfdeec9399ede$var$CacheContext).controller.signal;
    }
}, $b4fdfdeec9399ede$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $b4fdfdeec9399ede$var$executionContext = 0, $b4fdfdeec9399ede$var$workInProgressRoot = null, $b4fdfdeec9399ede$var$workInProgress = null, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = 0, $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0, $b4fdfdeec9399ede$var$workInProgressThrownValue = null, $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings = !1, $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering = !1, $b4fdfdeec9399ede$var$workInProgressRootDidAttachPingListener = !1, $b4fdfdeec9399ede$var$entangledRenderLanes = 0, $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 0, $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes = 0, $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes = 0, $b4fdfdeec9399ede$var$workInProgressRootPingedLanes = 0, $b4fdfdeec9399ede$var$workInProgressDeferredLane = 0, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes = 0, $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors = null, $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = null, $b4fdfdeec9399ede$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $b4fdfdeec9399ede$var$globalMostRecentFallbackTime = 0, $b4fdfdeec9399ede$var$globalMostRecentTransitionTime = 0, $b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime = Infinity, $b4fdfdeec9399ede$var$workInProgressTransitions = null, $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed = null, $b4fdfdeec9399ede$var$pendingEffectsStatus = 0, $b4fdfdeec9399ede$var$pendingEffectsRoot = null, $b4fdfdeec9399ede$var$pendingFinishedWork = null, $b4fdfdeec9399ede$var$pendingEffectsLanes = 0, $b4fdfdeec9399ede$var$pendingEffectsRemainingLanes = 0, $b4fdfdeec9399ede$var$pendingPassiveTransitions = null, $b4fdfdeec9399ede$var$pendingRecoverableErrors = null, $b4fdfdeec9399ede$var$nestedUpdateCount = 0, $b4fdfdeec9399ede$var$rootWithNestedUpdates = null;
function $b4fdfdeec9399ede$var$requestUpdateLane() {
    return 0 !== ($b4fdfdeec9399ede$var$executionContext & 2) && 0 !== $b4fdfdeec9399ede$var$workInProgressRootRenderLanes ? $b4fdfdeec9399ede$var$workInProgressRootRenderLanes & -$b4fdfdeec9399ede$var$workInProgressRootRenderLanes : null !== $b4fdfdeec9399ede$var$ReactSharedInternals.T ? $b4fdfdeec9399ede$var$requestTransitionLane() : $b4fdfdeec9399ede$var$resolveUpdatePriority();
}
function $b4fdfdeec9399ede$var$requestDeferredLane() {
    if (0 === $b4fdfdeec9399ede$var$workInProgressDeferredLane) {
        if (0 === ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 536870912) || $b4fdfdeec9399ede$var$isHydrating) {
            var lane = $b4fdfdeec9399ede$var$nextTransitionDeferredLane;
            $b4fdfdeec9399ede$var$nextTransitionDeferredLane <<= 1;
            0 === ($b4fdfdeec9399ede$var$nextTransitionDeferredLane & 3932160) && ($b4fdfdeec9399ede$var$nextTransitionDeferredLane = 262144);
            $b4fdfdeec9399ede$var$workInProgressDeferredLane = lane;
        } else $b4fdfdeec9399ede$var$workInProgressDeferredLane = 536870912;
    }
    lane = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $b4fdfdeec9399ede$var$workInProgressDeferredLane;
}
function $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $b4fdfdeec9399ede$var$workInProgressRoot && (2 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason || 9 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $b4fdfdeec9399ede$var$prepareFreshStack(root, 0), $b4fdfdeec9399ede$var$markRootSuspended(root, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !1);
    $b4fdfdeec9399ede$var$markRootUpdated$1(root, lane);
    if (0 === ($b4fdfdeec9399ede$var$executionContext & 2) || root !== $b4fdfdeec9399ede$var$workInProgressRoot) root === $b4fdfdeec9399ede$var$workInProgressRoot && (0 === ($b4fdfdeec9399ede$var$executionContext & 2) && ($b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus && $b4fdfdeec9399ede$var$markRootSuspended(root, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !1)), $b4fdfdeec9399ede$var$ensureRootIsScheduled(root);
}
function $b4fdfdeec9399ede$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($b4fdfdeec9399ede$var$executionContext & 6)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $b4fdfdeec9399ede$var$renderRootConcurrent(root$jscomp$0, lanes) : $b4fdfdeec9399ede$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $b4fdfdeec9399ede$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$b4fdfdeec9399ede$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $b4fdfdeec9399ede$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($b4fdfdeec9399ede$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $b4fdfdeec9399ede$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($b4fdfdeec9399ede$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors;
                            $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors ? $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors.push.apply($b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $b4fdfdeec9399ede$var$prepareFreshStack(root$jscomp$0, 0);
                $b4fdfdeec9399ede$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $b4fdfdeec9399ede$var$markRootSuspended(shouldTimeSlice, lanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !$b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $b4fdfdeec9399ede$var$globalMostRecentFallbackTime + 300 - $b4fdfdeec9399ede$var$now(), 10 < exitStatus)) {
                    $b4fdfdeec9399ede$var$markRootSuspended(shouldTimeSlice, lanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !$b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $b4fdfdeec9399ede$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $b4fdfdeec9399ede$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $b4fdfdeec9399ede$var$scheduleTimeout($b4fdfdeec9399ede$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors, $b4fdfdeec9399ede$var$workInProgressTransitions, $b4fdfdeec9399ede$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes, $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $b4fdfdeec9399ede$var$commitRootWhenReady(shouldTimeSlice, forceSync, $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors, $b4fdfdeec9399ede$var$workInProgressTransitions, $b4fdfdeec9399ede$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes, $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $b4fdfdeec9399ede$var$ensureRootIsScheduled(root$jscomp$0);
}
function $b4fdfdeec9399ede$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $b4fdfdeec9399ede$var$noop$1
        };
        $b4fdfdeec9399ede$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $b4fdfdeec9399ede$var$globalMostRecentFallbackTime - $b4fdfdeec9399ede$var$now() : (lanes & 4194048) === lanes ? $b4fdfdeec9399ede$var$globalMostRecentTransitionTime - $b4fdfdeec9399ede$var$now() : 0;
        timeoutOffset = $b4fdfdeec9399ede$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $b4fdfdeec9399ede$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($b4fdfdeec9399ede$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $b4fdfdeec9399ede$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $b4fdfdeec9399ede$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $b4fdfdeec9399ede$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$b4fdfdeec9399ede$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $b4fdfdeec9399ede$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$b4fdfdeec9399ede$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $b4fdfdeec9399ede$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $b4fdfdeec9399ede$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $b4fdfdeec9399ede$var$flushSyncWork$1() {
    return 0 === ($b4fdfdeec9399ede$var$executionContext & 6) ? ($b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $b4fdfdeec9399ede$var$resetWorkInProgressStack() {
    if (null !== $b4fdfdeec9399ede$var$workInProgress) {
        if (0 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason) var interruptedWork = $b4fdfdeec9399ede$var$workInProgress.return;
        else interruptedWork = $b4fdfdeec9399ede$var$workInProgress, $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null, $b4fdfdeec9399ede$var$resetHooksOnUnwind(interruptedWork), $b4fdfdeec9399ede$var$thenableState$1 = null, $b4fdfdeec9399ede$var$thenableIndexCounter$1 = 0, interruptedWork = $b4fdfdeec9399ede$var$workInProgress;
        for(; null !== interruptedWork;)$b4fdfdeec9399ede$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $b4fdfdeec9399ede$var$workInProgress = null;
    }
}
function $b4fdfdeec9399ede$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $b4fdfdeec9399ede$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $b4fdfdeec9399ede$var$pendingEffectsLanes = 0;
    $b4fdfdeec9399ede$var$resetWorkInProgressStack();
    $b4fdfdeec9399ede$var$workInProgressRoot = root;
    $b4fdfdeec9399ede$var$workInProgress = timeoutHandle = $b4fdfdeec9399ede$var$createWorkInProgress(root.current, null);
    $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = lanes;
    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
    $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering = $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root, lanes);
    $b4fdfdeec9399ede$var$workInProgressRootDidAttachPingListener = !1;
    $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes = $b4fdfdeec9399ede$var$workInProgressDeferredLane = $b4fdfdeec9399ede$var$workInProgressRootPingedLanes = $b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes = $b4fdfdeec9399ede$var$workInProgressRootSkippedLanes = $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 0;
    $b4fdfdeec9399ede$var$workInProgressRootRecoverableErrors = $b4fdfdeec9399ede$var$workInProgressRootConcurrentErrors = null;
    $b4fdfdeec9399ede$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $b4fdfdeec9399ede$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $b4fdfdeec9399ede$var$entangledRenderLanes = lanes;
    $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $b4fdfdeec9399ede$var$handleThrow(root, thrownValue) {
    $b4fdfdeec9399ede$var$currentlyRenderingFiber = null;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = $b4fdfdeec9399ede$var$ContextOnlyDispatcher;
    thrownValue === $b4fdfdeec9399ede$var$SuspenseException || thrownValue === $b4fdfdeec9399ede$var$SuspenseActionException ? (thrownValue = $b4fdfdeec9399ede$var$getSuspendedThenable(), $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 3) : thrownValue === $b4fdfdeec9399ede$var$SuspenseyCommitException ? (thrownValue = $b4fdfdeec9399ede$var$getSuspendedThenable(), $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 4) : $b4fdfdeec9399ede$var$workInProgressSuspendedReason = thrownValue === $b4fdfdeec9399ede$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $b4fdfdeec9399ede$var$workInProgressThrownValue = thrownValue;
    null === $b4fdfdeec9399ede$var$workInProgress && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 1, $b4fdfdeec9399ede$var$logUncaughtError(root, $b4fdfdeec9399ede$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $b4fdfdeec9399ede$var$shouldRemainOnPreviousScreen() {
    var handler = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 4194048) === $b4fdfdeec9399ede$var$workInProgressRootRenderLanes ? null === $b4fdfdeec9399ede$var$shellBoundary ? !0 : !1 : ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 62914560) === $b4fdfdeec9399ede$var$workInProgressRootRenderLanes || 0 !== ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 536870912) ? handler === $b4fdfdeec9399ede$var$shellBoundary : !1;
}
function $b4fdfdeec9399ede$var$pushDispatcher() {
    var prevDispatcher = $b4fdfdeec9399ede$var$ReactSharedInternals.H;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = $b4fdfdeec9399ede$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $b4fdfdeec9399ede$var$ContextOnlyDispatcher : prevDispatcher;
}
function $b4fdfdeec9399ede$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $b4fdfdeec9399ede$var$ReactSharedInternals.A;
    $b4fdfdeec9399ede$var$ReactSharedInternals.A = $b4fdfdeec9399ede$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $b4fdfdeec9399ede$var$renderDidSuspendDelayIfPossible() {
    $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 4;
    $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings || ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 4194048) !== $b4fdfdeec9399ede$var$workInProgressRootRenderLanes && null !== $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current || ($b4fdfdeec9399ede$var$workInProgressRootIsPrerendering = !0);
    0 === ($b4fdfdeec9399ede$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($b4fdfdeec9399ede$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $b4fdfdeec9399ede$var$workInProgressRoot || $b4fdfdeec9399ede$var$markRootSuspended($b4fdfdeec9399ede$var$workInProgressRoot, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes, $b4fdfdeec9399ede$var$workInProgressDeferredLane, !1);
}
function $b4fdfdeec9399ede$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
    $b4fdfdeec9399ede$var$executionContext |= 2;
    var prevDispatcher = $b4fdfdeec9399ede$var$pushDispatcher(), prevAsyncDispatcher = $b4fdfdeec9399ede$var$pushAsyncDispatcher();
    if ($b4fdfdeec9399ede$var$workInProgressRoot !== root || $b4fdfdeec9399ede$var$workInProgressRootRenderLanes !== lanes) $b4fdfdeec9399ede$var$workInProgressTransitions = null, $b4fdfdeec9399ede$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $b4fdfdeec9399ede$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $b4fdfdeec9399ede$var$workInProgressSuspendedReason && null !== $b4fdfdeec9399ede$var$workInProgress) {
            var unitOfWork = $b4fdfdeec9399ede$var$workInProgress, thrownValue = $b4fdfdeec9399ede$var$workInProgressThrownValue;
            switch($b4fdfdeec9399ede$var$workInProgressSuspendedReason){
                case 8:
                    $b4fdfdeec9399ede$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $b4fdfdeec9399ede$var$workInProgressSuspendedReason;
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                    $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $b4fdfdeec9399ede$var$workInProgressSuspendedReason, $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0, $b4fdfdeec9399ede$var$workInProgressThrownValue = null, $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $b4fdfdeec9399ede$var$workLoopSync();
        exitStatus = $b4fdfdeec9399ede$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $b4fdfdeec9399ede$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null;
    $b4fdfdeec9399ede$var$executionContext = prevExecutionContext;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = prevDispatcher;
    $b4fdfdeec9399ede$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $b4fdfdeec9399ede$var$workInProgress && ($b4fdfdeec9399ede$var$workInProgressRoot = null, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = 0, $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $b4fdfdeec9399ede$var$workLoopSync() {
    for(; null !== $b4fdfdeec9399ede$var$workInProgress;)$b4fdfdeec9399ede$var$performUnitOfWork($b4fdfdeec9399ede$var$workInProgress);
}
function $b4fdfdeec9399ede$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
    $b4fdfdeec9399ede$var$executionContext |= 2;
    var prevDispatcher = $b4fdfdeec9399ede$var$pushDispatcher(), prevAsyncDispatcher = $b4fdfdeec9399ede$var$pushAsyncDispatcher();
    $b4fdfdeec9399ede$var$workInProgressRoot !== root || $b4fdfdeec9399ede$var$workInProgressRootRenderLanes !== lanes ? ($b4fdfdeec9399ede$var$workInProgressTransitions = null, $b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime = $b4fdfdeec9399ede$var$now() + 500, $b4fdfdeec9399ede$var$prepareFreshStack(root, lanes)) : $b4fdfdeec9399ede$var$workInProgressRootIsPrerendering = $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $b4fdfdeec9399ede$var$workInProgressSuspendedReason && null !== $b4fdfdeec9399ede$var$workInProgress) {
            lanes = $b4fdfdeec9399ede$var$workInProgress;
            var thrownValue = $b4fdfdeec9399ede$var$workInProgressThrownValue;
            b: switch($b4fdfdeec9399ede$var$workInProgressSuspendedReason){
                case 1:
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                    $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($b4fdfdeec9399ede$var$isThenableResolved(thrownValue)) {
                        $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                        $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                        $b4fdfdeec9399ede$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $b4fdfdeec9399ede$var$workInProgressSuspendedReason && 9 !== $b4fdfdeec9399ede$var$workInProgressSuspendedReason || $b4fdfdeec9399ede$var$workInProgressRoot !== root || ($b4fdfdeec9399ede$var$workInProgressSuspendedReason = 7);
                        $b4fdfdeec9399ede$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $b4fdfdeec9399ede$var$isThenableResolved(thrownValue) ? ($b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0, $b4fdfdeec9399ede$var$workInProgressThrownValue = null, $b4fdfdeec9399ede$var$replaySuspendedUnitOfWork(lanes)) : ($b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0, $b4fdfdeec9399ede$var$workInProgressThrownValue = null, $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($b4fdfdeec9399ede$var$workInProgress.tag){
                        case 26:
                            resource = $b4fdfdeec9399ede$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $b4fdfdeec9399ede$var$workInProgress;
                            if (resource ? $b4fdfdeec9399ede$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                                $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $b4fdfdeec9399ede$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($b4fdfdeec9399ede$var$workInProgress = returnFiber, $b4fdfdeec9399ede$var$completeUnitOfWork(returnFiber)) : $b4fdfdeec9399ede$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                    $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $b4fdfdeec9399ede$var$workInProgressSuspendedReason = 0;
                    $b4fdfdeec9399ede$var$workInProgressThrownValue = null;
                    $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $b4fdfdeec9399ede$var$resetWorkInProgressStack();
                    $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(462));
            }
        }
        $b4fdfdeec9399ede$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $b4fdfdeec9399ede$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null;
    $b4fdfdeec9399ede$var$ReactSharedInternals.H = prevDispatcher;
    $b4fdfdeec9399ede$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $b4fdfdeec9399ede$var$executionContext = prevExecutionContext;
    if (null !== $b4fdfdeec9399ede$var$workInProgress) return 0;
    $b4fdfdeec9399ede$var$workInProgressRoot = null;
    $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = 0;
    $b4fdfdeec9399ede$var$finishQueueingConcurrentUpdates();
    return $b4fdfdeec9399ede$var$workInProgressRootExitStatus;
}
function $b4fdfdeec9399ede$var$workLoopConcurrentByScheduler() {
    for(; null !== $b4fdfdeec9399ede$var$workInProgress && !$b4fdfdeec9399ede$var$shouldYield();)$b4fdfdeec9399ede$var$performUnitOfWork($b4fdfdeec9399ede$var$workInProgress);
}
function $b4fdfdeec9399ede$var$performUnitOfWork(unitOfWork) {
    var next = $b4fdfdeec9399ede$var$beginWork(unitOfWork.alternate, unitOfWork, $b4fdfdeec9399ede$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b4fdfdeec9399ede$var$completeUnitOfWork(unitOfWork) : $b4fdfdeec9399ede$var$workInProgress = next;
}
function $b4fdfdeec9399ede$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $b4fdfdeec9399ede$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $b4fdfdeec9399ede$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $b4fdfdeec9399ede$var$resetHooksOnUnwind(next);
        default:
            $b4fdfdeec9399ede$var$unwindInterruptedWork(current, next), next = $b4fdfdeec9399ede$var$workInProgress = $b4fdfdeec9399ede$var$resetWorkInProgress(next, $b4fdfdeec9399ede$var$entangledRenderLanes), next = $b4fdfdeec9399ede$var$beginWork(current, next, $b4fdfdeec9399ede$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b4fdfdeec9399ede$var$completeUnitOfWork(unitOfWork) : $b4fdfdeec9399ede$var$workInProgress = next;
}
function $b4fdfdeec9399ede$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $b4fdfdeec9399ede$var$lastContextDependency = $b4fdfdeec9399ede$var$currentlyRenderingFiber$1 = null;
    $b4fdfdeec9399ede$var$resetHooksOnUnwind(unitOfWork);
    $b4fdfdeec9399ede$var$thenableState$1 = null;
    $b4fdfdeec9399ede$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($b4fdfdeec9399ede$var$throwException(root, returnFiber, unitOfWork, thrownValue, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes)) {
            $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 1;
            $b4fdfdeec9399ede$var$logUncaughtError(root, $b4fdfdeec9399ede$var$createCapturedValueAtFiber(thrownValue, root.current));
            $b4fdfdeec9399ede$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $b4fdfdeec9399ede$var$workInProgress = returnFiber, error;
        $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 1;
        $b4fdfdeec9399ede$var$logUncaughtError(root, $b4fdfdeec9399ede$var$createCapturedValueAtFiber(thrownValue, root.current));
        $b4fdfdeec9399ede$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($b4fdfdeec9399ede$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($b4fdfdeec9399ede$var$workInProgressRootIsPrerendering || 0 !== ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $b4fdfdeec9399ede$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $b4fdfdeec9399ede$var$unwindUnitOfWork(unitOfWork, root);
    } else $b4fdfdeec9399ede$var$completeUnitOfWork(unitOfWork);
}
function $b4fdfdeec9399ede$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $b4fdfdeec9399ede$var$unwindUnitOfWork(completedWork, $b4fdfdeec9399ede$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $b4fdfdeec9399ede$var$completeWork(completedWork.alternate, completedWork, $b4fdfdeec9399ede$var$entangledRenderLanes);
        if (null !== next) {
            $b4fdfdeec9399ede$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $b4fdfdeec9399ede$var$workInProgress = completedWork;
            return;
        }
        $b4fdfdeec9399ede$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootExitStatus = 5);
}
function $b4fdfdeec9399ede$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $b4fdfdeec9399ede$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $b4fdfdeec9399ede$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $b4fdfdeec9399ede$var$workInProgress = unitOfWork;
            return;
        }
        $b4fdfdeec9399ede$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $b4fdfdeec9399ede$var$workInProgressRootExitStatus = 6;
    $b4fdfdeec9399ede$var$workInProgress = null;
}
function $b4fdfdeec9399ede$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $b4fdfdeec9399ede$var$flushPendingEffects();
    while (0 !== $b4fdfdeec9399ede$var$pendingEffectsStatus);
    if (0 !== ($b4fdfdeec9399ede$var$executionContext & 6)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $b4fdfdeec9399ede$var$concurrentlyUpdatedLanes;
        $b4fdfdeec9399ede$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $b4fdfdeec9399ede$var$workInProgressRoot && ($b4fdfdeec9399ede$var$workInProgress = $b4fdfdeec9399ede$var$workInProgressRoot = null, $b4fdfdeec9399ede$var$workInProgressRootRenderLanes = 0);
        $b4fdfdeec9399ede$var$pendingFinishedWork = finishedWork;
        $b4fdfdeec9399ede$var$pendingEffectsRoot = root;
        $b4fdfdeec9399ede$var$pendingEffectsLanes = lanes;
        $b4fdfdeec9399ede$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $b4fdfdeec9399ede$var$pendingPassiveTransitions = transitions;
        $b4fdfdeec9399ede$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $b4fdfdeec9399ede$var$scheduleCallback$1($b4fdfdeec9399ede$var$NormalPriority$1, function() {
            $b4fdfdeec9399ede$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
            transitions = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
            $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $b4fdfdeec9399ede$var$executionContext;
            $b4fdfdeec9399ede$var$executionContext |= 4;
            try {
                $b4fdfdeec9399ede$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $b4fdfdeec9399ede$var$executionContext = spawnedLane, $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = transitions, $b4fdfdeec9399ede$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 1;
        $b4fdfdeec9399ede$var$flushMutationEffects();
        $b4fdfdeec9399ede$var$flushLayoutEffects();
        $b4fdfdeec9399ede$var$flushSpawnedWork();
    }
}
function $b4fdfdeec9399ede$var$flushMutationEffects() {
    if (1 === $b4fdfdeec9399ede$var$pendingEffectsStatus) {
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 0;
        var root = $b4fdfdeec9399ede$var$pendingEffectsRoot, finishedWork = $b4fdfdeec9399ede$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
            var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
            $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
            $b4fdfdeec9399ede$var$executionContext |= 4;
            try {
                $b4fdfdeec9399ede$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $b4fdfdeec9399ede$var$selectionInformation, curFocusedElem = $b4fdfdeec9399ede$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $b4fdfdeec9399ede$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $b4fdfdeec9399ede$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $b4fdfdeec9399ede$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $b4fdfdeec9399ede$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $b4fdfdeec9399ede$var$_enabled = !!$b4fdfdeec9399ede$var$eventsEnabled;
                $b4fdfdeec9399ede$var$selectionInformation = $b4fdfdeec9399ede$var$eventsEnabled = null;
            } finally{
                $b4fdfdeec9399ede$var$executionContext = prevExecutionContext, $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 2;
    }
}
function $b4fdfdeec9399ede$var$flushLayoutEffects() {
    if (2 === $b4fdfdeec9399ede$var$pendingEffectsStatus) {
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 0;
        var root = $b4fdfdeec9399ede$var$pendingEffectsRoot, finishedWork = $b4fdfdeec9399ede$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
            var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
            $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
            $b4fdfdeec9399ede$var$executionContext |= 4;
            try {
                $b4fdfdeec9399ede$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $b4fdfdeec9399ede$var$executionContext = prevExecutionContext, $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 3;
    }
}
function $b4fdfdeec9399ede$var$flushSpawnedWork() {
    if (4 === $b4fdfdeec9399ede$var$pendingEffectsStatus || 3 === $b4fdfdeec9399ede$var$pendingEffectsStatus) {
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 0;
        $b4fdfdeec9399ede$var$requestPaint();
        var root = $b4fdfdeec9399ede$var$pendingEffectsRoot, finishedWork = $b4fdfdeec9399ede$var$pendingFinishedWork, lanes = $b4fdfdeec9399ede$var$pendingEffectsLanes, recoverableErrors = $b4fdfdeec9399ede$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $b4fdfdeec9399ede$var$pendingEffectsStatus = 5 : ($b4fdfdeec9399ede$var$pendingEffectsStatus = 0, $b4fdfdeec9399ede$var$pendingFinishedWork = $b4fdfdeec9399ede$var$pendingEffectsRoot = null, $b4fdfdeec9399ede$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $b4fdfdeec9399ede$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($b4fdfdeec9399ede$var$injectedHook && "function" === typeof $b4fdfdeec9399ede$var$injectedHook.onCommitFiberRoot) try {
            $b4fdfdeec9399ede$var$injectedHook.onCommitFiberRoot($b4fdfdeec9399ede$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
            remainingLanes = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
            $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2;
            $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $b4fdfdeec9399ede$var$ReactSharedInternals.T = finishedWork, $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($b4fdfdeec9399ede$var$pendingEffectsLanes & 3) && $b4fdfdeec9399ede$var$flushPendingEffects();
        $b4fdfdeec9399ede$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $b4fdfdeec9399ede$var$rootWithNestedUpdates ? $b4fdfdeec9399ede$var$nestedUpdateCount++ : ($b4fdfdeec9399ede$var$nestedUpdateCount = 0, $b4fdfdeec9399ede$var$rootWithNestedUpdates = root) : $b4fdfdeec9399ede$var$nestedUpdateCount = 0;
        $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $b4fdfdeec9399ede$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $b4fdfdeec9399ede$var$releaseCache(remainingLanes)));
}
function $b4fdfdeec9399ede$var$flushPendingEffects() {
    $b4fdfdeec9399ede$var$flushMutationEffects();
    $b4fdfdeec9399ede$var$flushLayoutEffects();
    $b4fdfdeec9399ede$var$flushSpawnedWork();
    return $b4fdfdeec9399ede$var$flushPassiveEffects();
}
function $b4fdfdeec9399ede$var$flushPassiveEffects() {
    if (5 !== $b4fdfdeec9399ede$var$pendingEffectsStatus) return !1;
    var root = $b4fdfdeec9399ede$var$pendingEffectsRoot, remainingLanes = $b4fdfdeec9399ede$var$pendingEffectsRemainingLanes;
    $b4fdfdeec9399ede$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $b4fdfdeec9399ede$var$lanesToEventPriority($b4fdfdeec9399ede$var$pendingEffectsLanes), prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T, previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    try {
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
        renderPriority = $b4fdfdeec9399ede$var$pendingPassiveTransitions;
        $b4fdfdeec9399ede$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $b4fdfdeec9399ede$var$pendingEffectsRoot, lanes = $b4fdfdeec9399ede$var$pendingEffectsLanes;
        $b4fdfdeec9399ede$var$pendingEffectsStatus = 0;
        $b4fdfdeec9399ede$var$pendingFinishedWork = $b4fdfdeec9399ede$var$pendingEffectsRoot = null;
        $b4fdfdeec9399ede$var$pendingEffectsLanes = 0;
        if (0 !== ($b4fdfdeec9399ede$var$executionContext & 6)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(331));
        var prevExecutionContext = $b4fdfdeec9399ede$var$executionContext;
        $b4fdfdeec9399ede$var$executionContext |= 4;
        $b4fdfdeec9399ede$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $b4fdfdeec9399ede$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $b4fdfdeec9399ede$var$executionContext = prevExecutionContext;
        $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($b4fdfdeec9399ede$var$injectedHook && "function" === typeof $b4fdfdeec9399ede$var$injectedHook.onPostCommitFiberRoot) try {
            $b4fdfdeec9399ede$var$injectedHook.onPostCommitFiberRoot($b4fdfdeec9399ede$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition, $b4fdfdeec9399ede$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $b4fdfdeec9399ede$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $b4fdfdeec9399ede$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $b4fdfdeec9399ede$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($b4fdfdeec9399ede$var$markRootUpdated$1(rootFiber, 2), $b4fdfdeec9399ede$var$ensureRootIsScheduled(rootFiber));
}
function $b4fdfdeec9399ede$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $b4fdfdeec9399ede$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $b4fdfdeec9399ede$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed || !$b4fdfdeec9399ede$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $b4fdfdeec9399ede$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $b4fdfdeec9399ede$var$createClassErrorUpdate(2);
                instance = $b4fdfdeec9399ede$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($b4fdfdeec9399ede$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $b4fdfdeec9399ede$var$markRootUpdated$1(instance, 2), $b4fdfdeec9399ede$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $b4fdfdeec9399ede$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $b4fdfdeec9399ede$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($b4fdfdeec9399ede$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $b4fdfdeec9399ede$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $b4fdfdeec9399ede$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $b4fdfdeec9399ede$var$workInProgressRoot === root && ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus || 3 === $b4fdfdeec9399ede$var$workInProgressRootExitStatus && ($b4fdfdeec9399ede$var$workInProgressRootRenderLanes & 62914560) === $b4fdfdeec9399ede$var$workInProgressRootRenderLanes && 300 > $b4fdfdeec9399ede$var$now() - $b4fdfdeec9399ede$var$globalMostRecentFallbackTime ? 0 === ($b4fdfdeec9399ede$var$executionContext & 2) && $b4fdfdeec9399ede$var$prepareFreshStack(root, 0) : $b4fdfdeec9399ede$var$workInProgressRootPingedLanes |= pingedLanes, $b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes === $b4fdfdeec9399ede$var$workInProgressRootRenderLanes && ($b4fdfdeec9399ede$var$workInProgressSuspendedRetryLanes = 0));
    $b4fdfdeec9399ede$var$ensureRootIsScheduled(root);
}
function $b4fdfdeec9399ede$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $b4fdfdeec9399ede$var$claimNextRetryLane());
    boundaryFiber = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($b4fdfdeec9399ede$var$markRootUpdated$1(boundaryFiber, retryLane), $b4fdfdeec9399ede$var$ensureRootIsScheduled(boundaryFiber));
}
function $b4fdfdeec9399ede$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $b4fdfdeec9399ede$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b4fdfdeec9399ede$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $b4fdfdeec9399ede$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b4fdfdeec9399ede$var$scheduleCallback$1(priorityLevel, callback) {
    return $b4fdfdeec9399ede$var$scheduleCallback$3(priorityLevel, callback);
}
var $b4fdfdeec9399ede$var$firstScheduledRoot = null, $b4fdfdeec9399ede$var$lastScheduledRoot = null, $b4fdfdeec9399ede$var$didScheduleMicrotask = !1, $b4fdfdeec9399ede$var$mightHavePendingSyncWork = !1, $b4fdfdeec9399ede$var$isFlushingWork = !1, $b4fdfdeec9399ede$var$currentEventTransitionLane = 0;
function $b4fdfdeec9399ede$var$ensureRootIsScheduled(root) {
    root !== $b4fdfdeec9399ede$var$lastScheduledRoot && null === root.next && (null === $b4fdfdeec9399ede$var$lastScheduledRoot ? $b4fdfdeec9399ede$var$firstScheduledRoot = $b4fdfdeec9399ede$var$lastScheduledRoot = root : $b4fdfdeec9399ede$var$lastScheduledRoot = $b4fdfdeec9399ede$var$lastScheduledRoot.next = root);
    $b4fdfdeec9399ede$var$mightHavePendingSyncWork = !0;
    $b4fdfdeec9399ede$var$didScheduleMicrotask || ($b4fdfdeec9399ede$var$didScheduleMicrotask = !0, $b4fdfdeec9399ede$var$scheduleImmediateRootScheduleTask());
}
function $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$b4fdfdeec9399ede$var$isFlushingWork && $b4fdfdeec9399ede$var$mightHavePendingSyncWork) {
        $b4fdfdeec9399ede$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $b4fdfdeec9399ede$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $b4fdfdeec9399ede$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $b4fdfdeec9399ede$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $b4fdfdeec9399ede$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $b4fdfdeec9399ede$var$getNextLanes(root$170, root$170 === $b4fdfdeec9399ede$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $b4fdfdeec9399ede$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $b4fdfdeec9399ede$var$isFlushingWork = !1;
    }
}
function $b4fdfdeec9399ede$var$processRootScheduleInImmediateTask() {
    $b4fdfdeec9399ede$var$processRootScheduleInMicrotask();
}
function $b4fdfdeec9399ede$var$processRootScheduleInMicrotask() {
    $b4fdfdeec9399ede$var$mightHavePendingSyncWork = $b4fdfdeec9399ede$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $b4fdfdeec9399ede$var$currentEventTransitionLane && $b4fdfdeec9399ede$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $b4fdfdeec9399ede$var$currentEventTransitionLane);
    for(var currentTime = $b4fdfdeec9399ede$var$now(), prev = null, root = $b4fdfdeec9399ede$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $b4fdfdeec9399ede$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $b4fdfdeec9399ede$var$firstScheduledRoot = next : prev.next = next, null === next && ($b4fdfdeec9399ede$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $b4fdfdeec9399ede$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $b4fdfdeec9399ede$var$pendingEffectsStatus && 5 !== $b4fdfdeec9399ede$var$pendingEffectsStatus || $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $b4fdfdeec9399ede$var$currentEventTransitionLane && ($b4fdfdeec9399ede$var$currentEventTransitionLane = 0);
}
function $b4fdfdeec9399ede$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $b4fdfdeec9399ede$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $b4fdfdeec9399ede$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $b4fdfdeec9399ede$var$workInProgressRoot;
    suspendedLanes = $b4fdfdeec9399ede$var$workInProgressRootRenderLanes;
    suspendedLanes = $b4fdfdeec9399ede$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason || 9 === $b4fdfdeec9399ede$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $b4fdfdeec9399ede$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $b4fdfdeec9399ede$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $b4fdfdeec9399ede$var$cancelCallback$1(pingedLanes);
        switch($b4fdfdeec9399ede$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $b4fdfdeec9399ede$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $b4fdfdeec9399ede$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $b4fdfdeec9399ede$var$IdlePriority;
                break;
            default:
                suspendedLanes = $b4fdfdeec9399ede$var$NormalPriority$1;
        }
        pingedLanes = $b4fdfdeec9399ede$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $b4fdfdeec9399ede$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $b4fdfdeec9399ede$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $b4fdfdeec9399ede$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $b4fdfdeec9399ede$var$pendingEffectsStatus && 5 !== $b4fdfdeec9399ede$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($b4fdfdeec9399ede$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $b4fdfdeec9399ede$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $b4fdfdeec9399ede$var$getNextLanes(root, root === $b4fdfdeec9399ede$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $b4fdfdeec9399ede$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $b4fdfdeec9399ede$var$scheduleTaskForRootDuringMicrotask(root, $b4fdfdeec9399ede$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $b4fdfdeec9399ede$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $b4fdfdeec9399ede$var$performSyncWorkOnRoot(root, lanes) {
    if ($b4fdfdeec9399ede$var$flushPendingEffects()) return null;
    $b4fdfdeec9399ede$var$performWorkOnRoot(root, lanes, !0);
}
function $b4fdfdeec9399ede$var$scheduleImmediateRootScheduleTask() {
    $b4fdfdeec9399ede$var$scheduleMicrotask(function() {
        0 !== ($b4fdfdeec9399ede$var$executionContext & 6) ? $b4fdfdeec9399ede$var$scheduleCallback$3($b4fdfdeec9399ede$var$ImmediatePriority, $b4fdfdeec9399ede$var$processRootScheduleInImmediateTask) : $b4fdfdeec9399ede$var$processRootScheduleInMicrotask();
    });
}
function $b4fdfdeec9399ede$var$requestTransitionLane() {
    if (0 === $b4fdfdeec9399ede$var$currentEventTransitionLane) {
        var actionScopeLane = $b4fdfdeec9399ede$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $b4fdfdeec9399ede$var$nextTransitionUpdateLane, $b4fdfdeec9399ede$var$nextTransitionUpdateLane <<= 1, 0 === ($b4fdfdeec9399ede$var$nextTransitionUpdateLane & 261888) && ($b4fdfdeec9399ede$var$nextTransitionUpdateLane = 256));
        $b4fdfdeec9399ede$var$currentEventTransitionLane = actionScopeLane;
    }
    return $b4fdfdeec9399ede$var$currentEventTransitionLane;
}
function $b4fdfdeec9399ede$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $b4fdfdeec9399ede$var$sanitizeURL("" + actionProp);
}
function $b4fdfdeec9399ede$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $b4fdfdeec9399ede$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $b4fdfdeec9399ede$var$coerceFormActionProp((nativeEventTarget[$b4fdfdeec9399ede$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$b4fdfdeec9399ede$var$internalPropsKey] || null) ? $b4fdfdeec9399ede$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $b4fdfdeec9399ede$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $b4fdfdeec9399ede$var$currentEventTransitionLane) {
                                var formData = submitter ? $b4fdfdeec9399ede$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $b4fdfdeec9399ede$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $b4fdfdeec9399ede$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $b4fdfdeec9399ede$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $b4fdfdeec9399ede$var$i$jscomp$inline_1577 = 0; $b4fdfdeec9399ede$var$i$jscomp$inline_1577 < $b4fdfdeec9399ede$var$simpleEventPluginEvents.length; $b4fdfdeec9399ede$var$i$jscomp$inline_1577++){
    var $b4fdfdeec9399ede$var$eventName$jscomp$inline_1578 = $b4fdfdeec9399ede$var$simpleEventPluginEvents[$b4fdfdeec9399ede$var$i$jscomp$inline_1577], $b4fdfdeec9399ede$var$domEventName$jscomp$inline_1579 = $b4fdfdeec9399ede$var$eventName$jscomp$inline_1578.toLowerCase(), $b4fdfdeec9399ede$var$capitalizedEvent$jscomp$inline_1580 = $b4fdfdeec9399ede$var$eventName$jscomp$inline_1578[0].toUpperCase() + $b4fdfdeec9399ede$var$eventName$jscomp$inline_1578.slice(1);
    $b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$domEventName$jscomp$inline_1579, "on" + $b4fdfdeec9399ede$var$capitalizedEvent$jscomp$inline_1580);
}
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$ANIMATION_END, "onAnimationEnd");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$ANIMATION_ITERATION, "onAnimationIteration");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$ANIMATION_START, "onAnimationStart");
$b4fdfdeec9399ede$var$registerSimpleEvent("dblclick", "onDoubleClick");
$b4fdfdeec9399ede$var$registerSimpleEvent("focusin", "onFocus");
$b4fdfdeec9399ede$var$registerSimpleEvent("focusout", "onBlur");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$TRANSITION_RUN, "onTransitionRun");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$TRANSITION_START, "onTransitionStart");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$TRANSITION_CANCEL, "onTransitionCancel");
$b4fdfdeec9399ede$var$registerSimpleEvent($b4fdfdeec9399ede$var$TRANSITION_END, "onTransitionEnd");
$b4fdfdeec9399ede$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b4fdfdeec9399ede$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b4fdfdeec9399ede$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b4fdfdeec9399ede$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b4fdfdeec9399ede$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b4fdfdeec9399ede$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b4fdfdeec9399ede$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($b4fdfdeec9399ede$var$mediaEventTypes));
function $b4fdfdeec9399ede$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b4fdfdeec9399ede$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b4fdfdeec9399ede$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $b4fdfdeec9399ede$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$b4fdfdeec9399ede$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$b4fdfdeec9399ede$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($b4fdfdeec9399ede$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $b4fdfdeec9399ede$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $b4fdfdeec9399ede$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $b4fdfdeec9399ede$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $b4fdfdeec9399ede$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$b4fdfdeec9399ede$var$listeningMarker]) {
        rootContainerElement[$b4fdfdeec9399ede$var$listeningMarker] = !0;
        $b4fdfdeec9399ede$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($b4fdfdeec9399ede$var$nonDelegatedEvents.has(domEventName) || $b4fdfdeec9399ede$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $b4fdfdeec9399ede$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$b4fdfdeec9399ede$var$listeningMarker] || (ownerDocument[$b4fdfdeec9399ede$var$listeningMarker] = !0, $b4fdfdeec9399ede$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $b4fdfdeec9399ede$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($b4fdfdeec9399ede$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $b4fdfdeec9399ede$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $b4fdfdeec9399ede$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $b4fdfdeec9399ede$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$b4fdfdeec9399ede$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $b4fdfdeec9399ede$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $b4fdfdeec9399ede$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $b4fdfdeec9399ede$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $b4fdfdeec9399ede$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $b4fdfdeec9399ede$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $b4fdfdeec9399ede$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticTouchEvent;
                        break;
                    case $b4fdfdeec9399ede$var$ANIMATION_END:
                    case $b4fdfdeec9399ede$var$ANIMATION_ITERATION:
                    case $b4fdfdeec9399ede$var$ANIMATION_START:
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticAnimationEvent;
                        break;
                    case $b4fdfdeec9399ede$var$TRANSITION_END:
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $b4fdfdeec9399ede$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $b4fdfdeec9399ede$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($b4fdfdeec9399ede$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $b4fdfdeec9399ede$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($b4fdfdeec9399ede$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$b4fdfdeec9399ede$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $b4fdfdeec9399ede$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $b4fdfdeec9399ede$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $b4fdfdeec9399ede$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $b4fdfdeec9399ede$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $b4fdfdeec9399ede$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $b4fdfdeec9399ede$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $b4fdfdeec9399ede$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $b4fdfdeec9399ede$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $b4fdfdeec9399ede$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $b4fdfdeec9399ede$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $b4fdfdeec9399ede$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForChangeEvent;
                else if ($b4fdfdeec9399ede$var$isTextInputElement(reactName)) {
                    if ($b4fdfdeec9399ede$var$isInputEventSupported) getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $b4fdfdeec9399ede$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $b4fdfdeec9399ede$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForChangeEvent) : getTargetInstFunc = $b4fdfdeec9399ede$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $b4fdfdeec9399ede$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $b4fdfdeec9399ede$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $b4fdfdeec9399ede$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($b4fdfdeec9399ede$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $b4fdfdeec9399ede$var$activeElement = handleEventFunc, $b4fdfdeec9399ede$var$activeElementInst = targetInst, $b4fdfdeec9399ede$var$lastSelection = null;
                    break;
                case "focusout":
                    $b4fdfdeec9399ede$var$lastSelection = $b4fdfdeec9399ede$var$activeElementInst = $b4fdfdeec9399ede$var$activeElement = null;
                    break;
                case "mousedown":
                    $b4fdfdeec9399ede$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b4fdfdeec9399ede$var$mouseDown = !1;
                    $b4fdfdeec9399ede$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($b4fdfdeec9399ede$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $b4fdfdeec9399ede$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($b4fdfdeec9399ede$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $b4fdfdeec9399ede$var$isComposing ? $b4fdfdeec9399ede$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($b4fdfdeec9399ede$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($b4fdfdeec9399ede$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $b4fdfdeec9399ede$var$isComposing && (fallbackData = $b4fdfdeec9399ede$var$getData()) : ($b4fdfdeec9399ede$var$root = nativeEventTarget, $b4fdfdeec9399ede$var$startText = "value" in $b4fdfdeec9399ede$var$root ? $b4fdfdeec9399ede$var$root.value : $b4fdfdeec9399ede$var$root.textContent, $b4fdfdeec9399ede$var$isComposing = !0)), handleEventFunc = $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $b4fdfdeec9399ede$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $b4fdfdeec9399ede$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $b4fdfdeec9399ede$var$canUseTextInputEvent ? $b4fdfdeec9399ede$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $b4fdfdeec9399ede$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $b4fdfdeec9399ede$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $b4fdfdeec9399ede$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $b4fdfdeec9399ede$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $b4fdfdeec9399ede$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $b4fdfdeec9399ede$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $b4fdfdeec9399ede$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($b4fdfdeec9399ede$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $b4fdfdeec9399ede$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($b4fdfdeec9399ede$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $b4fdfdeec9399ede$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $b4fdfdeec9399ede$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $b4fdfdeec9399ede$var$getListener(target, registrationName), null != stateNode && listeners.unshift($b4fdfdeec9399ede$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $b4fdfdeec9399ede$var$getListener(target, registrationName), null != stateNode && listeners.push($b4fdfdeec9399ede$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $b4fdfdeec9399ede$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $b4fdfdeec9399ede$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $b4fdfdeec9399ede$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($b4fdfdeec9399ede$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($b4fdfdeec9399ede$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $b4fdfdeec9399ede$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $b4fdfdeec9399ede$var$normalizeMarkupForTextOrAttribute(clientText);
    return $b4fdfdeec9399ede$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $b4fdfdeec9399ede$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $b4fdfdeec9399ede$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $b4fdfdeec9399ede$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $b4fdfdeec9399ede$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $b4fdfdeec9399ede$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $b4fdfdeec9399ede$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $b4fdfdeec9399ede$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $b4fdfdeec9399ede$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b4fdfdeec9399ede$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $b4fdfdeec9399ede$var$setProp(domElement, tag, "name", props.name, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($b4fdfdeec9399ede$var$setProp(domElement, tag, "encType", props.encType, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "method", props.method, props, null), $b4fdfdeec9399ede$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b4fdfdeec9399ede$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b4fdfdeec9399ede$var$noop$1);
            break;
        case "onScroll":
            null != value && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $b4fdfdeec9399ede$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", domElement);
            $b4fdfdeec9399ede$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $b4fdfdeec9399ede$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $b4fdfdeec9399ede$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $b4fdfdeec9399ede$var$aliases.get(key) || key, $b4fdfdeec9399ede$var$setValueForAttribute(domElement, key, value);
    }
}
function $b4fdfdeec9399ede$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $b4fdfdeec9399ede$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $b4fdfdeec9399ede$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $b4fdfdeec9399ede$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b4fdfdeec9399ede$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$b4fdfdeec9399ede$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$b4fdfdeec9399ede$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $b4fdfdeec9399ede$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $b4fdfdeec9399ede$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                    default:
                        $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $b4fdfdeec9399ede$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $b4fdfdeec9399ede$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $b4fdfdeec9399ede$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $b4fdfdeec9399ede$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $b4fdfdeec9399ede$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $b4fdfdeec9399ede$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(91));
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $b4fdfdeec9399ede$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("cancel", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $b4fdfdeec9399ede$var$mediaEventTypes.length; hasSrc++)$b4fdfdeec9399ede$var$listenToNonDelegatedEvent($b4fdfdeec9399ede$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", domElement);
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("error", domElement), $b4fdfdeec9399ede$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($b4fdfdeec9399ede$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $b4fdfdeec9399ede$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $b4fdfdeec9399ede$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $b4fdfdeec9399ede$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $b4fdfdeec9399ede$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $b4fdfdeec9399ede$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $b4fdfdeec9399ede$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $b4fdfdeec9399ede$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $b4fdfdeec9399ede$var$updateOptions(domElement, !!lastProps, tag, !0) : $b4fdfdeec9399ede$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $b4fdfdeec9399ede$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $b4fdfdeec9399ede$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $b4fdfdeec9399ede$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($b4fdfdeec9399ede$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $b4fdfdeec9399ede$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $b4fdfdeec9399ede$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $b4fdfdeec9399ede$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $b4fdfdeec9399ede$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $b4fdfdeec9399ede$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $b4fdfdeec9399ede$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $b4fdfdeec9399ede$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $b4fdfdeec9399ede$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $b4fdfdeec9399ede$var$eventsEnabled = null, $b4fdfdeec9399ede$var$selectionInformation = null;
function $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $b4fdfdeec9399ede$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $b4fdfdeec9399ede$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $b4fdfdeec9399ede$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $b4fdfdeec9399ede$var$currentPopstateTransitionEvent = null;
function $b4fdfdeec9399ede$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $b4fdfdeec9399ede$var$currentPopstateTransitionEvent) return !1;
        $b4fdfdeec9399ede$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $b4fdfdeec9399ede$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $b4fdfdeec9399ede$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $b4fdfdeec9399ede$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $b4fdfdeec9399ede$var$localPromise = "function" === typeof Promise ? Promise : void 0, $b4fdfdeec9399ede$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b4fdfdeec9399ede$var$localPromise ? function(callback) {
    return $b4fdfdeec9399ede$var$localPromise.resolve(null).then(callback).catch($b4fdfdeec9399ede$var$handleErrorInNextTick);
} : $b4fdfdeec9399ede$var$scheduleTimeout;
function $b4fdfdeec9399ede$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $b4fdfdeec9399ede$var$isSingletonScope(type) {
    return "head" === type;
}
function $b4fdfdeec9399ede$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $b4fdfdeec9399ede$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $b4fdfdeec9399ede$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $b4fdfdeec9399ede$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$b4fdfdeec9399ede$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $b4fdfdeec9399ede$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $b4fdfdeec9399ede$var$retryIfBlockedOn(hydrationInstance);
}
function $b4fdfdeec9399ede$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $b4fdfdeec9399ede$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $b4fdfdeec9399ede$var$clearContainerSparingly(node);
                $b4fdfdeec9399ede$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $b4fdfdeec9399ede$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$b4fdfdeec9399ede$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $b4fdfdeec9399ede$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $b4fdfdeec9399ede$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b4fdfdeec9399ede$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b4fdfdeec9399ede$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b4fdfdeec9399ede$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b4fdfdeec9399ede$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $b4fdfdeec9399ede$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $b4fdfdeec9399ede$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $b4fdfdeec9399ede$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $b4fdfdeec9399ede$var$previousHydratableOnEnteringScopedSingleton = null;
function $b4fdfdeec9399ede$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $b4fdfdeec9399ede$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $b4fdfdeec9399ede$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $b4fdfdeec9399ede$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $b4fdfdeec9399ede$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(451));
    }
}
function $b4fdfdeec9399ede$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $b4fdfdeec9399ede$var$detachDeletedInstance(instance);
}
var $b4fdfdeec9399ede$var$preloadPropsMap = new Map(), $b4fdfdeec9399ede$var$preconnectsSet = new Set();
function $b4fdfdeec9399ede$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $b4fdfdeec9399ede$var$previousDispatcher = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.d;
$b4fdfdeec9399ede$var$ReactDOMSharedInternals.d = {
    f: $b4fdfdeec9399ede$var$flushSyncWork,
    r: $b4fdfdeec9399ede$var$requestFormReset,
    D: $b4fdfdeec9399ede$var$prefetchDNS,
    C: $b4fdfdeec9399ede$var$preconnect,
    L: $b4fdfdeec9399ede$var$preload,
    m: $b4fdfdeec9399ede$var$preloadModule,
    X: $b4fdfdeec9399ede$var$preinitScript,
    S: $b4fdfdeec9399ede$var$preinitStyle,
    M: $b4fdfdeec9399ede$var$preinitModuleScript
};
function $b4fdfdeec9399ede$var$flushSyncWork() {
    var previousWasRendering = $b4fdfdeec9399ede$var$previousDispatcher.f(), wasRendering = $b4fdfdeec9399ede$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $b4fdfdeec9399ede$var$requestFormReset(form) {
    var formInst = $b4fdfdeec9399ede$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $b4fdfdeec9399ede$var$requestFormReset$1(formInst) : $b4fdfdeec9399ede$var$previousDispatcher.r(form);
}
var $b4fdfdeec9399ede$var$globalDocument = "undefined" === typeof document ? null : document;
function $b4fdfdeec9399ede$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $b4fdfdeec9399ede$var$preconnectsSet.has(limitedEscapedHref) || ($b4fdfdeec9399ede$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $b4fdfdeec9399ede$var$setInitialProperties(href, "link", rel), $b4fdfdeec9399ede$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $b4fdfdeec9399ede$var$prefetchDNS(href) {
    $b4fdfdeec9399ede$var$previousDispatcher.D(href);
    $b4fdfdeec9399ede$var$preconnectAs("dns-prefetch", href, null);
}
function $b4fdfdeec9399ede$var$preconnect(href, crossOrigin) {
    $b4fdfdeec9399ede$var$previousDispatcher.C(href, crossOrigin);
    $b4fdfdeec9399ede$var$preconnectAs("preconnect", href, crossOrigin);
}
function $b4fdfdeec9399ede$var$preload(href, as, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $b4fdfdeec9399ede$var$getStyleKey(href);
                break;
            case "script":
                key = $b4fdfdeec9399ede$var$getScriptKey(href);
        }
        $b4fdfdeec9399ede$var$preloadPropsMap.has(key) || (href = $b4fdfdeec9399ede$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $b4fdfdeec9399ede$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $b4fdfdeec9399ede$var$setInitialProperties(as, "link", href), $b4fdfdeec9399ede$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $b4fdfdeec9399ede$var$preloadModule(href, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.m(href, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $b4fdfdeec9399ede$var$getScriptKey(href);
        }
        if (!$b4fdfdeec9399ede$var$preloadPropsMap.has(key) && (href = $b4fdfdeec9399ede$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $b4fdfdeec9399ede$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $b4fdfdeec9399ede$var$setInitialProperties(as, "link", href);
            $b4fdfdeec9399ede$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $b4fdfdeec9399ede$var$preinitStyle(href, precedence, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $b4fdfdeec9399ede$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $b4fdfdeec9399ede$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $b4fdfdeec9399ede$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $b4fdfdeec9399ede$var$preloadPropsMap.get(key)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $b4fdfdeec9399ede$var$markNodeAsHoistable(link);
                $b4fdfdeec9399ede$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $b4fdfdeec9399ede$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $b4fdfdeec9399ede$var$preinitScript(src, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.X(src, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b4fdfdeec9399ede$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b4fdfdeec9399ede$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(key)), resource || (src = $b4fdfdeec9399ede$var$assign({
            src: src,
            async: !0
        }, options), (options = $b4fdfdeec9399ede$var$preloadPropsMap.get(key)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b4fdfdeec9399ede$var$markNodeAsHoistable(resource), $b4fdfdeec9399ede$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b4fdfdeec9399ede$var$preinitModuleScript(src, options) {
    $b4fdfdeec9399ede$var$previousDispatcher.M(src, options);
    var ownerDocument = $b4fdfdeec9399ede$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b4fdfdeec9399ede$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b4fdfdeec9399ede$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(key)), resource || (src = $b4fdfdeec9399ede$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $b4fdfdeec9399ede$var$preloadPropsMap.get(key)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b4fdfdeec9399ede$var$markNodeAsHoistable(resource), $b4fdfdeec9399ede$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b4fdfdeec9399ede$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $b4fdfdeec9399ede$var$rootInstanceStackCursor.current) ? $b4fdfdeec9399ede$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $b4fdfdeec9399ede$var$getStyleKey(pendingProps.href), pendingProps = $b4fdfdeec9399ede$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $b4fdfdeec9399ede$var$getStyleKey(pendingProps.href);
                var styles$243 = $b4fdfdeec9399ede$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $b4fdfdeec9399ede$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $b4fdfdeec9399ede$var$preloadPropsMap.set(type, pendingProps), styles$243 || $b4fdfdeec9399ede$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $b4fdfdeec9399ede$var$getScriptKey(pendingProps), pendingProps = $b4fdfdeec9399ede$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(444, type));
    }
}
function $b4fdfdeec9399ede$var$getStyleKey(href) {
    return 'href="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $b4fdfdeec9399ede$var$stylesheetPropsFromRawProps(rawProps) {
    return $b4fdfdeec9399ede$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $b4fdfdeec9399ede$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $b4fdfdeec9399ede$var$setInitialProperties(key, "link", preloadProps), $b4fdfdeec9399ede$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $b4fdfdeec9399ede$var$getScriptKey(src) {
    return '[src="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $b4fdfdeec9399ede$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $b4fdfdeec9399ede$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $b4fdfdeec9399ede$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $b4fdfdeec9399ede$var$markNodeAsHoistable(instance), instance;
            var styleProps = $b4fdfdeec9399ede$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $b4fdfdeec9399ede$var$markNodeAsHoistable(instance);
            $b4fdfdeec9399ede$var$setInitialProperties(instance, "style", styleProps);
            $b4fdfdeec9399ede$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $b4fdfdeec9399ede$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $b4fdfdeec9399ede$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $b4fdfdeec9399ede$var$stylesheetPropsFromRawProps(props);
            (styleProps = $b4fdfdeec9399ede$var$preloadPropsMap.get(styleProps)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $b4fdfdeec9399ede$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b4fdfdeec9399ede$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $b4fdfdeec9399ede$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $b4fdfdeec9399ede$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($b4fdfdeec9399ede$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $b4fdfdeec9399ede$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $b4fdfdeec9399ede$var$preloadPropsMap.get(instance$249)) instance = $b4fdfdeec9399ede$var$assign({}, props), $b4fdfdeec9399ede$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $b4fdfdeec9399ede$var$markNodeAsHoistable(styleProps);
            $b4fdfdeec9399ede$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $b4fdfdeec9399ede$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $b4fdfdeec9399ede$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $b4fdfdeec9399ede$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $b4fdfdeec9399ede$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $b4fdfdeec9399ede$var$tagCaches = null;
function $b4fdfdeec9399ede$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $b4fdfdeec9399ede$var$tagCaches) {
        var cache = new Map();
        var caches = $b4fdfdeec9399ede$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $b4fdfdeec9399ede$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$b4fdfdeec9399ede$var$internalHoistableMarker] || node[$b4fdfdeec9399ede$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $b4fdfdeec9399ede$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $b4fdfdeec9399ede$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $b4fdfdeec9399ede$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $b4fdfdeec9399ede$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $b4fdfdeec9399ede$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($b4fdfdeec9399ede$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $b4fdfdeec9399ede$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $b4fdfdeec9399ede$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $b4fdfdeec9399ede$var$stylesheetPropsFromRawProps(props);
            (key = $b4fdfdeec9399ede$var$preloadPropsMap.get(key)) && $b4fdfdeec9399ede$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $b4fdfdeec9399ede$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b4fdfdeec9399ede$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $b4fdfdeec9399ede$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $b4fdfdeec9399ede$var$estimatedBytesWithinLimit = 0;
function $b4fdfdeec9399ede$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $b4fdfdeec9399ede$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $b4fdfdeec9399ede$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $b4fdfdeec9399ede$var$estimatedBytesWithinLimit && ($b4fdfdeec9399ede$var$estimatedBytesWithinLimit = 62500 * $b4fdfdeec9399ede$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $b4fdfdeec9399ede$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $b4fdfdeec9399ede$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $b4fdfdeec9399ede$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $b4fdfdeec9399ede$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $b4fdfdeec9399ede$var$precedencesByRoot = null;
function $b4fdfdeec9399ede$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $b4fdfdeec9399ede$var$precedencesByRoot = new Map(), resources.forEach($b4fdfdeec9399ede$var$insertStylesheetIntoRoot, state), $b4fdfdeec9399ede$var$precedencesByRoot = null, $b4fdfdeec9399ede$var$onUnsuspend.call(state));
}
function $b4fdfdeec9399ede$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $b4fdfdeec9399ede$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $b4fdfdeec9399ede$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $b4fdfdeec9399ede$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $b4fdfdeec9399ede$var$HostTransitionContext = {
    $$typeof: $b4fdfdeec9399ede$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $b4fdfdeec9399ede$var$sharedNotPendingObject,
    _currentValue2: $b4fdfdeec9399ede$var$sharedNotPendingObject,
    _threadCount: 0
};
function $b4fdfdeec9399ede$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $b4fdfdeec9399ede$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b4fdfdeec9399ede$var$createLaneMap(0);
    this.hiddenUpdates = $b4fdfdeec9399ede$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $b4fdfdeec9399ede$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $b4fdfdeec9399ede$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $b4fdfdeec9399ede$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $b4fdfdeec9399ede$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $b4fdfdeec9399ede$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $b4fdfdeec9399ede$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $b4fdfdeec9399ede$var$emptyContextObject;
    parentComponent = $b4fdfdeec9399ede$var$emptyContextObject;
    return parentComponent;
}
function $b4fdfdeec9399ede$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $b4fdfdeec9399ede$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $b4fdfdeec9399ede$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $b4fdfdeec9399ede$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($b4fdfdeec9399ede$var$scheduleUpdateOnFiber(element, rootFiber, lane), $b4fdfdeec9399ede$var$entangleTransitions(element, rootFiber, lane));
}
function $b4fdfdeec9399ede$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $b4fdfdeec9399ede$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $b4fdfdeec9399ede$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $b4fdfdeec9399ede$var$markRetryLaneImpl(fiber, retryLane);
}
function $b4fdfdeec9399ede$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $b4fdfdeec9399ede$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $b4fdfdeec9399ede$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $b4fdfdeec9399ede$var$requestUpdateLane();
        lane = $b4fdfdeec9399ede$var$getBumpedLaneForHydrationByLane(lane);
        var root = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, lane);
        $b4fdfdeec9399ede$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $b4fdfdeec9399ede$var$_enabled = !0;
function $b4fdfdeec9399ede$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
    $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
    var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    try {
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 2, $b4fdfdeec9399ede$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b4fdfdeec9399ede$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b4fdfdeec9399ede$var$ReactSharedInternals.T;
    $b4fdfdeec9399ede$var$ReactSharedInternals.T = null;
    var previousPriority = $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p;
    try {
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = 8, $b4fdfdeec9399ede$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b4fdfdeec9399ede$var$ReactDOMSharedInternals.p = previousPriority, $b4fdfdeec9399ede$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b4fdfdeec9399ede$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($b4fdfdeec9399ede$var$_enabled) {
        var blockedOn = $b4fdfdeec9399ede$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $b4fdfdeec9399ede$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b4fdfdeec9399ede$var$return_targetInst, targetContainer), $b4fdfdeec9399ede$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($b4fdfdeec9399ede$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($b4fdfdeec9399ede$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $b4fdfdeec9399ede$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $b4fdfdeec9399ede$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $b4fdfdeec9399ede$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $b4fdfdeec9399ede$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $b4fdfdeec9399ede$var$ensureRootIsScheduled(fiber);
                                0 === ($b4fdfdeec9399ede$var$executionContext & 6) && ($b4fdfdeec9399ede$var$workInProgressRootRenderTargetTime = $b4fdfdeec9399ede$var$now() + 500, $b4fdfdeec9399ede$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $b4fdfdeec9399ede$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $b4fdfdeec9399ede$var$scheduleUpdateOnFiber(root, fiber, 2), $b4fdfdeec9399ede$var$flushSyncWork$1(), $b4fdfdeec9399ede$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $b4fdfdeec9399ede$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $b4fdfdeec9399ede$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b4fdfdeec9399ede$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $b4fdfdeec9399ede$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $b4fdfdeec9399ede$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $b4fdfdeec9399ede$var$getEventTarget(nativeEvent);
    return $b4fdfdeec9399ede$var$findInstanceBlockingTarget(nativeEvent);
}
var $b4fdfdeec9399ede$var$return_targetInst = null;
function $b4fdfdeec9399ede$var$findInstanceBlockingTarget(targetNode) {
    $b4fdfdeec9399ede$var$return_targetInst = null;
    targetNode = $b4fdfdeec9399ede$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $b4fdfdeec9399ede$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $b4fdfdeec9399ede$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $b4fdfdeec9399ede$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $b4fdfdeec9399ede$var$return_targetInst = targetNode;
    return null;
}
function $b4fdfdeec9399ede$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($b4fdfdeec9399ede$var$getCurrentPriorityLevel()){
                case $b4fdfdeec9399ede$var$ImmediatePriority:
                    return 2;
                case $b4fdfdeec9399ede$var$UserBlockingPriority:
                    return 8;
                case $b4fdfdeec9399ede$var$NormalPriority$1:
                case $b4fdfdeec9399ede$var$LowPriority:
                    return 32;
                case $b4fdfdeec9399ede$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $b4fdfdeec9399ede$var$hasScheduledReplayAttempt = !1, $b4fdfdeec9399ede$var$queuedFocus = null, $b4fdfdeec9399ede$var$queuedDrag = null, $b4fdfdeec9399ede$var$queuedMouse = null, $b4fdfdeec9399ede$var$queuedPointers = new Map(), $b4fdfdeec9399ede$var$queuedPointerCaptures = new Map(), $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets = [], $b4fdfdeec9399ede$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $b4fdfdeec9399ede$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $b4fdfdeec9399ede$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $b4fdfdeec9399ede$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $b4fdfdeec9399ede$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $b4fdfdeec9399ede$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b4fdfdeec9399ede$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $b4fdfdeec9399ede$var$getInstanceFromNode(blockedOn), null !== blockedOn && $b4fdfdeec9399ede$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $b4fdfdeec9399ede$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $b4fdfdeec9399ede$var$queuedFocus = $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $b4fdfdeec9399ede$var$queuedDrag = $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $b4fdfdeec9399ede$var$queuedMouse = $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $b4fdfdeec9399ede$var$queuedPointers.set(pointerId, $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $b4fdfdeec9399ede$var$queuedPointerCaptures.set(pointerId, $b4fdfdeec9399ede$var$accumulateOrCreateContinuousQueuedReplayableEvent($b4fdfdeec9399ede$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $b4fdfdeec9399ede$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $b4fdfdeec9399ede$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $b4fdfdeec9399ede$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $b4fdfdeec9399ede$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b4fdfdeec9399ede$var$runWithPriority(queuedTarget.priority, function() {
                        $b4fdfdeec9399ede$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $b4fdfdeec9399ede$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b4fdfdeec9399ede$var$runWithPriority(queuedTarget.priority, function() {
                        $b4fdfdeec9399ede$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $b4fdfdeec9399ede$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $b4fdfdeec9399ede$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $b4fdfdeec9399ede$var$currentReplayingEvent = null;
        } else return targetContainers = $b4fdfdeec9399ede$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $b4fdfdeec9399ede$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $b4fdfdeec9399ede$var$replayUnblockedEvents() {
    $b4fdfdeec9399ede$var$hasScheduledReplayAttempt = !1;
    null !== $b4fdfdeec9399ede$var$queuedFocus && $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent($b4fdfdeec9399ede$var$queuedFocus) && ($b4fdfdeec9399ede$var$queuedFocus = null);
    null !== $b4fdfdeec9399ede$var$queuedDrag && $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent($b4fdfdeec9399ede$var$queuedDrag) && ($b4fdfdeec9399ede$var$queuedDrag = null);
    null !== $b4fdfdeec9399ede$var$queuedMouse && $b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEvent($b4fdfdeec9399ede$var$queuedMouse) && ($b4fdfdeec9399ede$var$queuedMouse = null);
    $b4fdfdeec9399ede$var$queuedPointers.forEach($b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEventInMap);
    $b4fdfdeec9399ede$var$queuedPointerCaptures.forEach($b4fdfdeec9399ede$var$attemptReplayContinuousQueuedEventInMap);
}
function $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $b4fdfdeec9399ede$var$hasScheduledReplayAttempt || ($b4fdfdeec9399ede$var$hasScheduledReplayAttempt = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $b4fdfdeec9399ede$var$replayUnblockedEvents)));
}
var $b4fdfdeec9399ede$var$lastScheduledReplayQueue = null;
function $b4fdfdeec9399ede$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $b4fdfdeec9399ede$var$lastScheduledReplayQueue !== formReplayingQueue && ($b4fdfdeec9399ede$var$lastScheduledReplayQueue = formReplayingQueue, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, function() {
        $b4fdfdeec9399ede$var$lastScheduledReplayQueue === formReplayingQueue && ($b4fdfdeec9399ede$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $b4fdfdeec9399ede$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $b4fdfdeec9399ede$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $b4fdfdeec9399ede$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $b4fdfdeec9399ede$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $b4fdfdeec9399ede$var$queuedFocus && $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked($b4fdfdeec9399ede$var$queuedFocus, unblocked);
    null !== $b4fdfdeec9399ede$var$queuedDrag && $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked($b4fdfdeec9399ede$var$queuedDrag, unblocked);
    null !== $b4fdfdeec9399ede$var$queuedMouse && $b4fdfdeec9399ede$var$scheduleCallbackIfUnblocked($b4fdfdeec9399ede$var$queuedMouse, unblocked);
    $b4fdfdeec9399ede$var$queuedPointers.forEach(unblock);
    $b4fdfdeec9399ede$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.length && (i = $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$b4fdfdeec9399ede$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$b4fdfdeec9399ede$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $b4fdfdeec9399ede$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$b4fdfdeec9399ede$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $b4fdfdeec9399ede$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $b4fdfdeec9399ede$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $b4fdfdeec9399ede$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $b4fdfdeec9399ede$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b4fdfdeec9399ede$var$ReactDOMHydrationRoot.prototype.render = $b4fdfdeec9399ede$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(409));
    var current = root.current, lane = $b4fdfdeec9399ede$var$requestUpdateLane();
    $b4fdfdeec9399ede$var$updateContainerImpl(current, lane, children, root, null, null);
};
$b4fdfdeec9399ede$var$ReactDOMHydrationRoot.prototype.unmount = $b4fdfdeec9399ede$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $b4fdfdeec9399ede$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $b4fdfdeec9399ede$var$flushSyncWork$1();
        container[$b4fdfdeec9399ede$var$internalContainerInstanceKey] = null;
    }
};
function $b4fdfdeec9399ede$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b4fdfdeec9399ede$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $b4fdfdeec9399ede$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets[i].priority; i++);
        $b4fdfdeec9399ede$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $b4fdfdeec9399ede$var$attemptExplicitHydrationTarget(target);
    }
};
var $b4fdfdeec9399ede$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $6cds3.version;
if ("19.2.8" !== $b4fdfdeec9399ede$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(527, $b4fdfdeec9399ede$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$b4fdfdeec9399ede$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $b4fdfdeec9399ede$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $b4fdfdeec9399ede$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $b4fdfdeec9399ede$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $b4fdfdeec9399ede$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b4fdfdeec9399ede$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b4fdfdeec9399ede$var$hook$jscomp$inline_2348.isDisabled && $b4fdfdeec9399ede$var$hook$jscomp$inline_2348.supportsFiber) try {
        $b4fdfdeec9399ede$var$rendererID = $b4fdfdeec9399ede$var$hook$jscomp$inline_2348.inject($b4fdfdeec9399ede$var$internals$jscomp$inline_2347), $b4fdfdeec9399ede$var$injectedHook = $b4fdfdeec9399ede$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$b4fdfdeec9399ede$export$882461b6382ed46c = function(container, options) {
    if (!$b4fdfdeec9399ede$var$isValidContainer(container)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b4fdfdeec9399ede$var$defaultOnUncaughtError, onCaughtError = $b4fdfdeec9399ede$var$defaultOnCaughtError, onRecoverableError = $b4fdfdeec9399ede$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $b4fdfdeec9399ede$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $b4fdfdeec9399ede$var$defaultOnDefaultTransitionIndicator);
    container[$b4fdfdeec9399ede$var$internalContainerInstanceKey] = options.current;
    $b4fdfdeec9399ede$var$listenToAllSupportedEvents(container);
    return new $b4fdfdeec9399ede$var$ReactDOMRoot(options);
};
$b4fdfdeec9399ede$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$b4fdfdeec9399ede$var$isValidContainer(container)) throw Error($b4fdfdeec9399ede$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b4fdfdeec9399ede$var$defaultOnUncaughtError, onCaughtError = $b4fdfdeec9399ede$var$defaultOnCaughtError, onRecoverableError = $b4fdfdeec9399ede$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $b4fdfdeec9399ede$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $b4fdfdeec9399ede$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $b4fdfdeec9399ede$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $b4fdfdeec9399ede$var$requestUpdateLane();
    isStrictMode = $b4fdfdeec9399ede$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $b4fdfdeec9399ede$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $b4fdfdeec9399ede$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $b4fdfdeec9399ede$var$markRootUpdated$1(initialChildren, options);
    $b4fdfdeec9399ede$var$ensureRootIsScheduled(initialChildren);
    container[$b4fdfdeec9399ede$var$internalContainerInstanceKey] = initialChildren.current;
    $b4fdfdeec9399ede$var$listenToAllSupportedEvents(container);
    return new $b4fdfdeec9399ede$var$ReactDOMHydrationRoot(initialChildren);
};
$b4fdfdeec9399ede$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("1c9zD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("87gsC"));

});
parcelRegister("87gsC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5e8bbeeced84f587$export$c4744153514ff05d; }, function (v) { return $5e8bbeeced84f587$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5e8bbeeced84f587$export$3e506c1ccc9cc1a7; }, function (v) { return $5e8bbeeced84f587$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5e8bbeeced84f587$export$e26fe2ed2fa76875; }, function (v) { return $5e8bbeeced84f587$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5e8bbeeced84f587$export$502329bbf4b505b1; }, function (v) { return $5e8bbeeced84f587$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5e8bbeeced84f587$export$6e3807111c4874c4; }, function (v) { return $5e8bbeeced84f587$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5e8bbeeced84f587$export$c27134553091fb3a; }, function (v) { return $5e8bbeeced84f587$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5e8bbeeced84f587$export$33ee1acdc04fd2a2; }, function (v) { return $5e8bbeeced84f587$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5e8bbeeced84f587$export$b00a404bbd5edef2; }, function (v) { return $5e8bbeeced84f587$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5e8bbeeced84f587$export$d66a1c1c77bd778b; }, function (v) { return $5e8bbeeced84f587$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5e8bbeeced84f587$export$d3dfb8e4810cb555; }, function (v) { return $5e8bbeeced84f587$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5e8bbeeced84f587$export$72fdf0e06517287b; }, function (v) { return $5e8bbeeced84f587$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5e8bbeeced84f587$export$816d2913ae6b83b1; }, function (v) { return $5e8bbeeced84f587$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5e8bbeeced84f587$export$61bcfe829111a1d0; }, function (v) { return $5e8bbeeced84f587$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5e8bbeeced84f587$export$7ee8c9beb337bc3f; }, function (v) { return $5e8bbeeced84f587$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5e8bbeeced84f587$export$b5836b71941fa3ed; }, function (v) { return $5e8bbeeced84f587$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5e8bbeeced84f587$export$cf845f2c119da08a; }, function (v) { return $5e8bbeeced84f587$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5e8bbeeced84f587$export$c4744153514ff05d;
var $5e8bbeeced84f587$export$3e506c1ccc9cc1a7;
var $5e8bbeeced84f587$export$e26fe2ed2fa76875;
var $5e8bbeeced84f587$export$502329bbf4b505b1;
var $5e8bbeeced84f587$export$6e3807111c4874c4;
var $5e8bbeeced84f587$export$c27134553091fb3a;
var $5e8bbeeced84f587$export$33ee1acdc04fd2a2;
var $5e8bbeeced84f587$export$b00a404bbd5edef2;
var $5e8bbeeced84f587$export$d66a1c1c77bd778b;
var $5e8bbeeced84f587$export$d3dfb8e4810cb555;
var $5e8bbeeced84f587$export$72fdf0e06517287b;
var $5e8bbeeced84f587$export$816d2913ae6b83b1;
var $5e8bbeeced84f587$export$61bcfe829111a1d0;
var $5e8bbeeced84f587$export$7ee8c9beb337bc3f;
var $5e8bbeeced84f587$export$b5836b71941fa3ed;
var $5e8bbeeced84f587$export$cf845f2c119da08a;
"use strict";
function $5e8bbeeced84f587$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $5e8bbeeced84f587$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $5e8bbeeced84f587$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $5e8bbeeced84f587$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $5e8bbeeced84f587$var$compare(left, last)) rightIndex < length && 0 > $5e8bbeeced84f587$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $5e8bbeeced84f587$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $5e8bbeeced84f587$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$5e8bbeeced84f587$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5e8bbeeced84f587$var$localPerformance = performance;
    $5e8bbeeced84f587$export$c4744153514ff05d = function() {
        return $5e8bbeeced84f587$var$localPerformance.now();
    };
} else {
    var $5e8bbeeced84f587$var$localDate = Date, $5e8bbeeced84f587$var$initialTime = $5e8bbeeced84f587$var$localDate.now();
    $5e8bbeeced84f587$export$c4744153514ff05d = function() {
        return $5e8bbeeced84f587$var$localDate.now() - $5e8bbeeced84f587$var$initialTime;
    };
}
var $5e8bbeeced84f587$var$taskQueue = [], $5e8bbeeced84f587$var$timerQueue = [], $5e8bbeeced84f587$var$taskIdCounter = 1, $5e8bbeeced84f587$var$currentTask = null, $5e8bbeeced84f587$var$currentPriorityLevel = 3, $5e8bbeeced84f587$var$isPerformingWork = !1, $5e8bbeeced84f587$var$isHostCallbackScheduled = !1, $5e8bbeeced84f587$var$isHostTimeoutScheduled = !1, $5e8bbeeced84f587$var$needsPaint = !1, $5e8bbeeced84f587$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $5e8bbeeced84f587$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $5e8bbeeced84f587$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $5e8bbeeced84f587$var$advanceTimers(currentTime) {
    for(var timer = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue); null !== timer;){
        if (null === timer.callback) $5e8bbeeced84f587$var$pop($5e8bbeeced84f587$var$timerQueue);
        else if (timer.startTime <= currentTime) $5e8bbeeced84f587$var$pop($5e8bbeeced84f587$var$timerQueue), timer.sortIndex = timer.expirationTime, $5e8bbeeced84f587$var$push($5e8bbeeced84f587$var$taskQueue, timer);
        else break;
        timer = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue);
    }
}
function $5e8bbeeced84f587$var$handleTimeout(currentTime) {
    $5e8bbeeced84f587$var$isHostTimeoutScheduled = !1;
    $5e8bbeeced84f587$var$advanceTimers(currentTime);
    if (!$5e8bbeeced84f587$var$isHostCallbackScheduled) {
        if (null !== $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue)) $5e8bbeeced84f587$var$isHostCallbackScheduled = !0, $5e8bbeeced84f587$var$isMessageLoopRunning || ($5e8bbeeced84f587$var$isMessageLoopRunning = !0, $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue);
            null !== firstTimer && $5e8bbeeced84f587$var$requestHostTimeout($5e8bbeeced84f587$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $5e8bbeeced84f587$var$isMessageLoopRunning = !1, $5e8bbeeced84f587$var$taskTimeoutID = -1, $5e8bbeeced84f587$var$frameInterval = 5, $5e8bbeeced84f587$var$startTime = -1;
function $5e8bbeeced84f587$var$shouldYieldToHost() {
    return $5e8bbeeced84f587$var$needsPaint ? !0 : $5e8bbeeced84f587$export$c4744153514ff05d() - $5e8bbeeced84f587$var$startTime < $5e8bbeeced84f587$var$frameInterval ? !1 : !0;
}
function $5e8bbeeced84f587$var$performWorkUntilDeadline() {
    $5e8bbeeced84f587$var$needsPaint = !1;
    if ($5e8bbeeced84f587$var$isMessageLoopRunning) {
        var currentTime = $5e8bbeeced84f587$export$c4744153514ff05d();
        $5e8bbeeced84f587$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $5e8bbeeced84f587$var$isHostCallbackScheduled = !1;
                $5e8bbeeced84f587$var$isHostTimeoutScheduled && ($5e8bbeeced84f587$var$isHostTimeoutScheduled = !1, $5e8bbeeced84f587$var$localClearTimeout($5e8bbeeced84f587$var$taskTimeoutID), $5e8bbeeced84f587$var$taskTimeoutID = -1);
                $5e8bbeeced84f587$var$isPerformingWork = !0;
                var previousPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
                try {
                    b: {
                        $5e8bbeeced84f587$var$advanceTimers(currentTime);
                        for($5e8bbeeced84f587$var$currentTask = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue); null !== $5e8bbeeced84f587$var$currentTask && !($5e8bbeeced84f587$var$currentTask.expirationTime > currentTime && $5e8bbeeced84f587$var$shouldYieldToHost());){
                            var callback = $5e8bbeeced84f587$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $5e8bbeeced84f587$var$currentTask.callback = null;
                                $5e8bbeeced84f587$var$currentPriorityLevel = $5e8bbeeced84f587$var$currentTask.priorityLevel;
                                var continuationCallback = callback($5e8bbeeced84f587$var$currentTask.expirationTime <= currentTime);
                                currentTime = $5e8bbeeced84f587$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $5e8bbeeced84f587$var$currentTask.callback = continuationCallback;
                                    $5e8bbeeced84f587$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $5e8bbeeced84f587$var$currentTask === $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue) && $5e8bbeeced84f587$var$pop($5e8bbeeced84f587$var$taskQueue);
                                $5e8bbeeced84f587$var$advanceTimers(currentTime);
                            } else $5e8bbeeced84f587$var$pop($5e8bbeeced84f587$var$taskQueue);
                            $5e8bbeeced84f587$var$currentTask = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue);
                        }
                        if (null !== $5e8bbeeced84f587$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue);
                            null !== firstTimer && $5e8bbeeced84f587$var$requestHostTimeout($5e8bbeeced84f587$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $5e8bbeeced84f587$var$currentTask = null, $5e8bbeeced84f587$var$currentPriorityLevel = previousPriorityLevel, $5e8bbeeced84f587$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline() : $5e8bbeeced84f587$var$isMessageLoopRunning = !1;
        }
    }
}
var $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $5e8bbeeced84f587$var$localSetImmediate) $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline = function() {
    $5e8bbeeced84f587$var$localSetImmediate($5e8bbeeced84f587$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5e8bbeeced84f587$var$channel = new MessageChannel(), $5e8bbeeced84f587$var$port = $5e8bbeeced84f587$var$channel.port2;
    $5e8bbeeced84f587$var$channel.port1.onmessage = $5e8bbeeced84f587$var$performWorkUntilDeadline;
    $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline = function() {
        $5e8bbeeced84f587$var$port.postMessage(null);
    };
} else $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline = function() {
    $5e8bbeeced84f587$var$localSetTimeout($5e8bbeeced84f587$var$performWorkUntilDeadline, 0);
};
function $5e8bbeeced84f587$var$requestHostTimeout(callback, ms) {
    $5e8bbeeced84f587$var$taskTimeoutID = $5e8bbeeced84f587$var$localSetTimeout(function() {
        callback($5e8bbeeced84f587$export$c4744153514ff05d());
    }, ms);
}
$5e8bbeeced84f587$export$3e506c1ccc9cc1a7 = 5;
$5e8bbeeced84f587$export$e26fe2ed2fa76875 = 1;
$5e8bbeeced84f587$export$502329bbf4b505b1 = 4;
$5e8bbeeced84f587$export$6e3807111c4874c4 = 3;
$5e8bbeeced84f587$export$c27134553091fb3a = null;
$5e8bbeeced84f587$export$33ee1acdc04fd2a2 = 2;
$5e8bbeeced84f587$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$5e8bbeeced84f587$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5e8bbeeced84f587$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$5e8bbeeced84f587$export$d3dfb8e4810cb555 = function() {
    return $5e8bbeeced84f587$var$currentPriorityLevel;
};
$5e8bbeeced84f587$export$72fdf0e06517287b = function(eventHandler) {
    switch($5e8bbeeced84f587$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
    $5e8bbeeced84f587$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $5e8bbeeced84f587$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$5e8bbeeced84f587$export$816d2913ae6b83b1 = function() {
    $5e8bbeeced84f587$var$needsPaint = !0;
};
$5e8bbeeced84f587$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
    $5e8bbeeced84f587$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $5e8bbeeced84f587$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$5e8bbeeced84f587$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $5e8bbeeced84f587$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $5e8bbeeced84f587$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $5e8bbeeced84f587$var$push($5e8bbeeced84f587$var$timerQueue, priorityLevel), null === $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$taskQueue) && priorityLevel === $5e8bbeeced84f587$var$peek($5e8bbeeced84f587$var$timerQueue) && ($5e8bbeeced84f587$var$isHostTimeoutScheduled ? ($5e8bbeeced84f587$var$localClearTimeout($5e8bbeeced84f587$var$taskTimeoutID), $5e8bbeeced84f587$var$taskTimeoutID = -1) : $5e8bbeeced84f587$var$isHostTimeoutScheduled = !0, $5e8bbeeced84f587$var$requestHostTimeout($5e8bbeeced84f587$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $5e8bbeeced84f587$var$push($5e8bbeeced84f587$var$taskQueue, priorityLevel), $5e8bbeeced84f587$var$isHostCallbackScheduled || $5e8bbeeced84f587$var$isPerformingWork || ($5e8bbeeced84f587$var$isHostCallbackScheduled = !0, $5e8bbeeced84f587$var$isMessageLoopRunning || ($5e8bbeeced84f587$var$isMessageLoopRunning = !0, $5e8bbeeced84f587$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$5e8bbeeced84f587$export$b5836b71941fa3ed = $5e8bbeeced84f587$var$shouldYieldToHost;
$5e8bbeeced84f587$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $5e8bbeeced84f587$var$currentPriorityLevel;
        $5e8bbeeced84f587$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $5e8bbeeced84f587$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("6cds3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1aGg9"));

});

parcelRegister("9nHRL", function(module, exports) {
'use strict';
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

module.exports = (parcelRequire("ildVp"));

});
parcelRegister("ildVp", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $d5a4fd5d9d270c0d$export$69ce8ef3fe5cead0; }, function (v) { return $d5a4fd5d9d270c0d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $d5a4fd5d9d270c0d$export$d39a5bbd09211389; }, function (v) { return $d5a4fd5d9d270c0d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $d5a4fd5d9d270c0d$export$cd75ccfd720a3cd4; }, function (v) { return $d5a4fd5d9d270c0d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $d5a4fd5d9d270c0d$export$a0816fa17a9e79be; }, function (v) { return $d5a4fd5d9d270c0d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $d5a4fd5d9d270c0d$export$7292efcadded39f3; }, function (v) { return $d5a4fd5d9d270c0d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $d5a4fd5d9d270c0d$export$da407abadb9b8f86; }, function (v) { return $d5a4fd5d9d270c0d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $d5a4fd5d9d270c0d$export$314cfea32580671c; }, function (v) { return $d5a4fd5d9d270c0d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $d5a4fd5d9d270c0d$export$513ccb98c53b8039; }, function (v) { return $d5a4fd5d9d270c0d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $d5a4fd5d9d270c0d$export$dbca993bc2d264a; }, function (v) { return $d5a4fd5d9d270c0d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $d5a4fd5d9d270c0d$export$4797a8006f0655d0; }, function (v) { return $d5a4fd5d9d270c0d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $d5a4fd5d9d270c0d$export$c78a37762a8d58e1; }, function (v) { return $d5a4fd5d9d270c0d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $d5a4fd5d9d270c0d$export$606f11b2eb45ecc6; }, function (v) { return $d5a4fd5d9d270c0d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $d5a4fd5d9d270c0d$export$f7e8a0bf92324b1e; }, function (v) { return $d5a4fd5d9d270c0d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $d5a4fd5d9d270c0d$export$83d89fbfd8236492; }, function (v) { return $d5a4fd5d9d270c0d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d5a4fd5d9d270c0d$export$69ce8ef3fe5cead0;
var $d5a4fd5d9d270c0d$export$d39a5bbd09211389;
var $d5a4fd5d9d270c0d$export$cd75ccfd720a3cd4;
var $d5a4fd5d9d270c0d$export$a0816fa17a9e79be;
var $d5a4fd5d9d270c0d$export$7292efcadded39f3;
var $d5a4fd5d9d270c0d$export$da407abadb9b8f86;
var $d5a4fd5d9d270c0d$export$314cfea32580671c;
var $d5a4fd5d9d270c0d$export$513ccb98c53b8039;
var $d5a4fd5d9d270c0d$export$dbca993bc2d264a;
var $d5a4fd5d9d270c0d$export$4797a8006f0655d0;
var $d5a4fd5d9d270c0d$export$c78a37762a8d58e1;
var $d5a4fd5d9d270c0d$export$606f11b2eb45ecc6;
var $d5a4fd5d9d270c0d$export$f7e8a0bf92324b1e;
var $d5a4fd5d9d270c0d$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");
function $d5a4fd5d9d270c0d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $d5a4fd5d9d270c0d$var$noop() {}
var $d5a4fd5d9d270c0d$var$Internals = {
    d: {
        f: $d5a4fd5d9d270c0d$var$noop,
        r: function() {
            throw Error($d5a4fd5d9d270c0d$var$formatProdErrorMessage(522));
        },
        D: $d5a4fd5d9d270c0d$var$noop,
        C: $d5a4fd5d9d270c0d$var$noop,
        L: $d5a4fd5d9d270c0d$var$noop,
        m: $d5a4fd5d9d270c0d$var$noop,
        X: $d5a4fd5d9d270c0d$var$noop,
        S: $d5a4fd5d9d270c0d$var$noop,
        M: $d5a4fd5d9d270c0d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $d5a4fd5d9d270c0d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $d5a4fd5d9d270c0d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $d5a4fd5d9d270c0d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $d5a4fd5d9d270c0d$var$ReactSharedInternals = $6cds3.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$d5a4fd5d9d270c0d$export$69ce8ef3fe5cead0 = $d5a4fd5d9d270c0d$var$Internals;
$d5a4fd5d9d270c0d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($d5a4fd5d9d270c0d$var$formatProdErrorMessage(299));
    return $d5a4fd5d9d270c0d$var$createPortal$1(children, container, null, key);
};
$d5a4fd5d9d270c0d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $d5a4fd5d9d270c0d$var$ReactSharedInternals.T, previousUpdatePriority = $d5a4fd5d9d270c0d$var$Internals.p;
    try {
        if ($d5a4fd5d9d270c0d$var$ReactSharedInternals.T = null, $d5a4fd5d9d270c0d$var$Internals.p = 2, fn) return fn();
    } finally{
        $d5a4fd5d9d270c0d$var$ReactSharedInternals.T = previousTransition, $d5a4fd5d9d270c0d$var$Internals.p = previousUpdatePriority, $d5a4fd5d9d270c0d$var$Internals.d.f();
    }
};
$d5a4fd5d9d270c0d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $d5a4fd5d9d270c0d$var$Internals.d.C(href, options));
};
$d5a4fd5d9d270c0d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $d5a4fd5d9d270c0d$var$Internals.d.D(href);
};
$d5a4fd5d9d270c0d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $d5a4fd5d9d270c0d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $d5a4fd5d9d270c0d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$d5a4fd5d9d270c0d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $d5a4fd5d9d270c0d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $d5a4fd5d9d270c0d$var$Internals.d.M(href);
    }
};
$d5a4fd5d9d270c0d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $d5a4fd5d9d270c0d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$d5a4fd5d9d270c0d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $d5a4fd5d9d270c0d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $d5a4fd5d9d270c0d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $d5a4fd5d9d270c0d$var$Internals.d.m(href);
    }
};
$d5a4fd5d9d270c0d$export$4797a8006f0655d0 = function(form) {
    $d5a4fd5d9d270c0d$var$Internals.d.r(form);
};
$d5a4fd5d9d270c0d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$d5a4fd5d9d270c0d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $d5a4fd5d9d270c0d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$d5a4fd5d9d270c0d$export$f7e8a0bf92324b1e = function() {
    return $d5a4fd5d9d270c0d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$d5a4fd5d9d270c0d$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("4jKqu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $324cf30d1a38adf8$var$_gtag = $324cf30d1a38adf8$var$_interopRequireDefault((parcelRequire("8naOK")));

var $324cf30d1a38adf8$var$_format = $324cf30d1a38adf8$var$_interopRequireDefault((parcelRequire("dD5Al")));
var $324cf30d1a38adf8$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $324cf30d1a38adf8$var$_excluded2 = [
    "title",
    "location"
], $324cf30d1a38adf8$var$_excluded3 = [
    "page",
    "hitType"
];
function $324cf30d1a38adf8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $324cf30d1a38adf8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $324cf30d1a38adf8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $324cf30d1a38adf8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $324cf30d1a38adf8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $324cf30d1a38adf8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $324cf30d1a38adf8$var$_typeof(obj);
}
function $324cf30d1a38adf8$var$_toConsumableArray(arr) {
    return $324cf30d1a38adf8$var$_arrayWithoutHoles(arr) || $324cf30d1a38adf8$var$_iterableToArray(arr) || $324cf30d1a38adf8$var$_unsupportedIterableToArray(arr) || $324cf30d1a38adf8$var$_nonIterableSpread();
}
function $324cf30d1a38adf8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $324cf30d1a38adf8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $324cf30d1a38adf8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $324cf30d1a38adf8$var$_arrayLikeToArray(arr);
}
function $324cf30d1a38adf8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $324cf30d1a38adf8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $324cf30d1a38adf8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $324cf30d1a38adf8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $324cf30d1a38adf8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $324cf30d1a38adf8$var$_slicedToArray(arr, i) {
    return $324cf30d1a38adf8$var$_arrayWithHoles(arr) || $324cf30d1a38adf8$var$_iterableToArrayLimit(arr, i) || $324cf30d1a38adf8$var$_unsupportedIterableToArray(arr, i) || $324cf30d1a38adf8$var$_nonIterableRest();
}
function $324cf30d1a38adf8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $324cf30d1a38adf8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $324cf30d1a38adf8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $324cf30d1a38adf8$var$_arrayLikeToArray(o, minLen);
}
function $324cf30d1a38adf8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $324cf30d1a38adf8$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $324cf30d1a38adf8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $324cf30d1a38adf8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $324cf30d1a38adf8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $324cf30d1a38adf8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $324cf30d1a38adf8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $324cf30d1a38adf8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $324cf30d1a38adf8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $324cf30d1a38adf8$var$_defineProperty(obj, key, value) {
    key = $324cf30d1a38adf8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $324cf30d1a38adf8$var$_toPropertyKey(arg) {
    var key = $324cf30d1a38adf8$var$_toPrimitive(arg, "string");
    return $324cf30d1a38adf8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $324cf30d1a38adf8$var$_toPrimitive(input, hint) {
    if ($324cf30d1a38adf8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($324cf30d1a38adf8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $324cf30d1a38adf8$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $324cf30d1a38adf8$var$_classCallCheck(this, GA4);
        $324cf30d1a38adf8$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $324cf30d1a38adf8$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $324cf30d1a38adf8$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $324cf30d1a38adf8$var$_objectSpread($324cf30d1a38adf8$var$_objectSpread($324cf30d1a38adf8$var$_objectSpread({}, _this._toGtagOptions($324cf30d1a38adf8$var$_objectSpread($324cf30d1a38adf8$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $324cf30d1a38adf8$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $324cf30d1a38adf8$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($324cf30d1a38adf8$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $324cf30d1a38adf8$var$_objectSpread($324cf30d1a38adf8$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $324cf30d1a38adf8$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $324cf30d1a38adf8$var$_objectWithoutProperties(_args$, $324cf30d1a38adf8$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $324cf30d1a38adf8$var$_objectWithoutProperties(_this$_toGtagOptions, $324cf30d1a38adf8$var$_excluded2);
                _this._gtag("event", "page_view", $324cf30d1a38adf8$var$_objectSpread($324cf30d1a38adf8$var$_objectSpread($324cf30d1a38adf8$var$_objectSpread($324cf30d1a38adf8$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $324cf30d1a38adf8$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $324cf30d1a38adf8$var$_objectWithoutProperties(_args$2, $324cf30d1a38adf8$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $324cf30d1a38adf8$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $324cf30d1a38adf8$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $324cf30d1a38adf8$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $324cf30d1a38adf8$var$_format["default"])(category),
                    eventAction: (0, $324cf30d1a38adf8$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $324cf30d1a38adf8$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $324cf30d1a38adf8$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $324cf30d1a38adf8$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $324cf30d1a38adf8$var$GA4;
var $324cf30d1a38adf8$var$_default = new $324cf30d1a38adf8$var$GA4();
module.exports["default"] = $324cf30d1a38adf8$var$_default;

});
parcelRegister("8naOK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $6188dcd7e71e119e$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $6188dcd7e71e119e$var$_default = $6188dcd7e71e119e$var$gtag;
module.exports["default"] = $6188dcd7e71e119e$var$_default;

});

parcelRegister("dD5Al", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9ec33ff744153075$var$format;
var $9ec33ff744153075$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $9ec33ff744153075$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($9ec33ff744153075$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $9ec33ff744153075$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $9ec33ff744153075$var$redacted = "REDACTED (Potential Email Address)";
function $9ec33ff744153075$var$redactEmail(string) {
    if ($9ec33ff744153075$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $9ec33ff744153075$var$redacted;
    }
    return string;
}
function $9ec33ff744153075$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $9ec33ff744153075$var$toTitleCase(s);
    if (redactingEmail) _str = $9ec33ff744153075$var$redactEmail(_str);
    return _str;
}

});


parcelRegister("3ILni", function(module, exports) {

module.exports = (parcelRequire("9FZDf"))($parcel$resolve("jWgoc")).then(()=>parcelRequire('cNIke'));

});
parcelRegister("9FZDf", function(module, exports) {
"use strict";

var $9jW6n = parcelRequire("9jW6n");
module.exports = $9jW6n(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("9jW6n", function(module, exports) {
"use strict";
var $6c92f53da2785287$var$cachedBundles = {};
var $6c92f53da2785287$var$cachedPreloads = {};
var $6c92f53da2785287$var$cachedPrefetches = {};
function $6c92f53da2785287$var$getCache(type) {
    switch(type){
        case 'preload':
            return $6c92f53da2785287$var$cachedPreloads;
        case 'prefetch':
            return $6c92f53da2785287$var$cachedPrefetches;
        default:
            return $6c92f53da2785287$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6c92f53da2785287$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $27ec38b5f95b606c$exports = {};
$parcel$extendImportMap({
    "3jIhc": "logo.6c1496ec.svg",
    "jWgoc": "web-vitals.ecec820e.js"
});

var $fba0f23e9e6a11bb$exports = {};
'use strict';

$fba0f23e9e6a11bb$exports = (parcelRequire("ccFxc"));



var $6cds3 = parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};
'use strict';
function $64d0b1ebdd6bcffe$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($64d0b1ebdd6bcffe$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$64d0b1ebdd6bcffe$var$checkDCE();

$64d0b1ebdd6bcffe$exports = (parcelRequire("fxpQW"));








var $6cds3 = parcelRequire("6cds3");
function $9dcc00a39e7f7954$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $66a5668b38a29be4$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $9dcc00a39e7f7954$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $64b790ae24ac5be1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64b790ae24ac5be1$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $64b790ae24ac5be1$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




var $6cds3 = parcelRequire("6cds3");

parcelRequire("6cds3");

function $f5e83fbaec6b7c47$export$c052eb0d03744912() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "quiz-body",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "quiz-question",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "skeleton-pulse",
                    style: {
                        height: "24px",
                        width: "70%",
                        borderRadius: "6px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "quiz-options",
                children: [
                    0,
                    1,
                    2,
                    3
                ].map((i)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: "quiz-option skeleton-pulse",
                        disabled: true,
                        style: {
                            background: "#f7f8fa",
                            borderColor: "transparent",
                            cursor: "default"
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "quiz-footer",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: "quiz-btn quiz-btn--primary skeleton-pulse",
                        disabled: true,
                        style: {
                            background: "#f7f8fa",
                            color: "transparent",
                            width: "140px"
                        },
                        children: "Next"
                    })
                ]
            })
        ]
    });
}
function $f5e83fbaec6b7c47$export$2e2bcd8739ae039({ index: index, question: question, selectedOption: selectedOption, onSelectOption: onSelectOption, onNext: onNext, onBack: onBack, canGoBack: canGoBack, isLastQuestion: isLastQuestion, isSubmitting: isSubmitting }) {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "quiz-body",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                className: "quiz-question",
                children: [
                    index + 1,
                    ". ",
                    question.question
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "quiz-options",
                children: question.options.map((option, i)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: `quiz-option ${selectedOption === i ? "quiz-option--selected" : ""}`,
                        onClick: ()=>onSelectOption(question.id, i),
                        disabled: isSubmitting,
                        children: option
                    }, i))
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "quiz-footer",
                children: [
                    canGoBack ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: "quiz-btn quiz-btn--ghost",
                        onClick: onBack,
                        disabled: isSubmitting,
                        children: "Go back"
                    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {}),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: "quiz-btn quiz-btn--primary",
                        onClick: onNext,
                        disabled: selectedOption === undefined || isSubmitting,
                        children: isSubmitting ? "Submitting..." : isLastQuestion ? "Find out your best match" : "Next question"
                    })
                ]
            })
        ]
    });
}



parcelRequire("6cds3");

const $58b35ae0b98d2c17$var$config = {
    calculatorUrl: "https://mxureyyrv7.execute-api.us-east-1.amazonaws.com/calculator-api/",
    mainUrl: "https://mxureyyrv7.execute-api.us-east-1.amazonaws.com"
};
var $58b35ae0b98d2c17$export$2e2bcd8739ae039 = $58b35ae0b98d2c17$var$config;


var $7554413e966985e6$exports = {};
"use strict";
function $7554413e966985e6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7554413e966985e6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7554413e966985e6$var$_typeof(obj);
}
Object.defineProperty($7554413e966985e6$exports, "__esModule", {
    value: true
});
$7554413e966985e6$exports["default"] = $7554413e966985e6$exports.ReactGAImplementation = void 0;

var $7554413e966985e6$var$_ga = $7554413e966985e6$var$_interopRequireWildcard((parcelRequire("4jKqu")));
function $7554413e966985e6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7554413e966985e6$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7554413e966985e6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $7554413e966985e6$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $7554413e966985e6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $7554413e966985e6$var$ReactGAImplementation = $7554413e966985e6$var$_ga.GA4;
$7554413e966985e6$exports.ReactGAImplementation = $7554413e966985e6$var$ReactGAImplementation;
var $7554413e966985e6$var$_default = $7554413e966985e6$var$_ga["default"];
$7554413e966985e6$exports["default"] = $7554413e966985e6$var$_default;


const $c0e12f24d6f0ca74$var$GA_MEASUREMENT_ID = "G-8SRBZQ1DBM";
let $c0e12f24d6f0ca74$var$initialized = false;
const $c0e12f24d6f0ca74$export$80cba77b5b64bcd7 = ()=>{
    if (!$c0e12f24d6f0ca74$var$GA_MEASUREMENT_ID) {
        console.warn("[analytics] REACT_APP_BBYS_QUIZ_GOOGLE_ANALYTICS_GA4_KEY is not set \u2014 GA4 tracking is disabled.");
        return;
    }
    if ($c0e12f24d6f0ca74$var$initialized) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($7554413e966985e6$exports))).initialize($c0e12f24d6f0ca74$var$GA_MEASUREMENT_ID);
    $c0e12f24d6f0ca74$var$initialized = true;
};
const $c0e12f24d6f0ca74$export$8ceb0a58cef34f32 = ({ sessionId: sessionId } = {})=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($7554413e966985e6$exports))).event("quiz_start", {
        quiz_name: "buy_before_you_sell_matchmaker",
        quiz_session_id: sessionId
    });
};
const $c0e12f24d6f0ca74$export$ca49bdb2da45d2f4 = ({ sessionId: sessionId, questionNumber: questionNumber, questionId: questionId, questionText: questionText, answerText: answerText, recommendedCompanyName: recommendedCompanyName })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($7554413e966985e6$exports))).event("question_response", {
        quiz_session_id: sessionId,
        question_number: questionNumber,
        question_id: questionId,
        question_text: questionText,
        answer_text: answerText,
        recommended_company_name: recommendedCompanyName
    });
};
const $c0e12f24d6f0ca74$export$f28f129b015dd8f1 = ({ sessionId: sessionId, company: company })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($7554413e966985e6$exports))).event("quiz_complete", {
        quiz_session_id: sessionId,
        result_company: company || "unknown"
    });
};
const $c0e12f24d6f0ca74$export$82c371523676d816 = ({ sessionId: sessionId, company: company })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($7554413e966985e6$exports))).event("cta_click", {
        quiz_session_id: sessionId,
        result_company: company || "unknown"
    });
};


function $5aaa527a9472198b$export$2e2bcd8739ae039({ resultData: resultData, sessionId: sessionId, onClose: onClose }) {
    if (!resultData) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "quiz-body quiz-result",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
            children: "Loading results..."
        })
    });
    const headerContent = resultData.result_title;
    const bodyContent = resultData.result_description;
    const checklist = resultData.benefits ? resultData.benefits.map((b)=>b.benefit) : [];
    const button = {
        content: resultData.company_name ? `Click here to learn more about ${resultData.company_name}` : "Learn More",
        url: resultData.result_url || "#"
    };
    const logoUrl = resultData.company_logo;
    const handleCtaClick = ()=>{
        if (!sessionId || !button.url || button.url === "#") return;
        fetch(`${(0, $58b35ae0b98d2c17$export$2e2bcd8739ae039).calculatorUrl}quiz/cta-click/${sessionId}/`, {
            method: "GET",
            headers: {
                Authorization: `${"467cc341-a74a-42c3-b23d-db3409df2a00"}`
            },
            keepalive: true
        }).then((res)=>{
            if (!res.ok) console.error(`Failed to track CTA click: ${res.status}`);
        }).catch((err)=>console.error("CTA click tracking error:", err));
        (0, $c0e12f24d6f0ca74$export$82c371523676d816)({
            sessionId: sessionId,
            company: resultData.company_name
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
        window.open(button.url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "quiz-body quiz-result",
        children: [
            logoUrl && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "quiz-result__logo",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    src: `${(0, $58b35ae0b98d2c17$export$2e2bcd8739ae039).mainUrl}${logoUrl}`,
                    alt: `${resultData.company_name} logo`
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                className: "quiz-result__heading",
                children: headerContent
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "quiz-result__text",
                children: bodyContent
            }),
            checklist.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("ul", {
                className: "quiz-result__checklist",
                children: checklist.map((item, i)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                        children: item
                    }, i))
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                type: "button",
                className: "quiz-cta",
                onClick: handleCtaClick,
                children: button.content
            })
        ]
    });
}





function $e6d968a76503737c$export$2e2bcd8739ae039({ isOpen: isOpen, onClose: onClose }) {
    const [stepIndex, setStepIndex] = (0, $6cds3.useState)(0);
    const [answers, setAnswers] = (0, $6cds3.useState)({});
    const [quizData, setQuizData] = (0, $6cds3.useState)(null);
    const [resultData, setResultData] = (0, $6cds3.useState)(null);
    const [loading, setLoading] = (0, $6cds3.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, $6cds3.useState)(false);
    const [error, setError] = (0, $6cds3.useState)(null);
    (0, $6cds3.useEffect)(()=>{
        if (isOpen && !quizData) fetchQuizFromAPI();
    }, [
        isOpen
    ]);
    const fetchQuizFromAPI = async ()=>{
        try {
            setLoading(true);
            setError(null);
            const response = await fetch(`${(0, $58b35ae0b98d2c17$export$2e2bcd8739ae039).calculatorUrl}quiz/start/`, {
                headers: {
                    Authorization: `${"467cc341-a74a-42c3-b23d-db3409df2a00"}`
                }
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            setQuizData(data);
            (0, $c0e12f24d6f0ca74$export$8ceb0a58cef34f32)({
                sessionId: data.session_id
            });
        } catch (err) {
            console.error("Failed to fetch quiz data:", err);
            setError(err.message);
        } finally{
            setLoading(false);
        }
    };
    if (!isOpen) return null;
    const handleSelectOption = (questionId, optionIndex)=>{
        setAnswers((prev)=>(0, $64b790ae24ac5be1$export$71511d61b312f219)((0, $66a5668b38a29be4$export$71511d61b312f219)({}, prev), {
                [questionId]: optionIndex
            }));
    };
    const handleNext = async ()=>{
        if (!currentQuestion || selectedOption === undefined) return;
        const originalQuestion = quiz.quiz_questions.find((q)=>q.question_id === currentQuestion.id);
        const selectedChoice = originalQuestion.question_choices[selectedOption];
        const singleAnswerPayload = {
            quiz_response: quizData.session_id,
            question: currentQuestion.id,
            choice: selectedChoice.choice_id,
            company: selectedChoice.recommended_company
        };
        fetch(`${(0, $58b35ae0b98d2c17$export$2e2bcd8739ae039).calculatorUrl}quiz/answer/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `${"467cc341-a74a-42c3-b23d-db3409df2a00"}`
            },
            body: JSON.stringify(singleAnswerPayload),
            keepalive: true
        }).then((res)=>{
            if (!res.ok) console.error(`Failed to submit answer: ${res.status}`);
        }).catch((err)=>console.error("Quiz answer submission error:", err));
        (0, $c0e12f24d6f0ca74$export$ca49bdb2da45d2f4)({
            questionNumber: stepIndex + 1,
            questionId: currentQuestion.id,
            questionText: currentQuestion.question,
            answerText: selectedChoice.choice,
            sessionId: quizData.session_id,
            recommendedCompanyName: selectedChoice.recommended_company_name
        });
        if (!isLastQuestion) {
            setStepIndex((prev)=>prev + 1);
            return;
        }
        try {
            setIsSubmitting(true);
            const allAnswersPayload = quiz.quiz_questions.map((q)=>{
                const optionIndex = q.question_id === currentQuestion.id ? selectedOption : answers[q.question_id];
                const choiceData = q.question_choices[optionIndex];
                return {
                    question: q.question_id,
                    choice: choiceData.choice_id,
                    company: choiceData.recommended_company
                };
            });
            const resultResponse = await fetch(`${(0, $58b35ae0b98d2c17$export$2e2bcd8739ae039).calculatorUrl}quiz/result/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${"467cc341-a74a-42c3-b23d-db3409df2a00"}`
                },
                body: JSON.stringify({
                    quiz_response: quizData.session_id,
                    answers: allAnswersPayload
                })
            });
            if (!resultResponse.ok) throw new Error(`Failed to fetch result: ${resultResponse.status}`);
            const resultJson = await resultResponse.json();
            setResultData((0, $64b790ae24ac5be1$export$71511d61b312f219)((0, $66a5668b38a29be4$export$71511d61b312f219)({}, resultJson), {
                benefits: [
                    ...resultJson.benefits || []
                ].sort((a, b)=>a.order_index - b.order_index)
            }));
            (0, $c0e12f24d6f0ca74$export$f28f129b015dd8f1)({
                sessionId: quizData.session_id,
                company: resultJson.company_name
            });
            setStepIndex((prev)=>prev + 1);
        } catch (err) {
            console.error("Quiz submission error:", err);
            setError(err.message);
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleBack = ()=>setStepIndex((prev)=>Math.max(prev - 1, 0));
    const handleClose = ()=>{
        setStepIndex(0);
        setAnswers({});
        setResultData(null);
        setQuizData(null);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    // --- LOADING STATE ---
    if (loading) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "quiz-overlay",
        role: "dialog",
        "aria-modal": "true",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "quiz-card",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "quiz-header",
                    style: {
                        backgroundColor: "#f7f8fa"
                    },
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "skeleton-pulse",
                        style: {
                            height: "24px",
                            width: "200px",
                            borderRadius: "6px"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f5e83fbaec6b7c47$export$c052eb0d03744912), {})
            ]
        })
    });
    // --- ERROR STATE ---
    if (error) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "quiz-overlay",
        role: "dialog",
        "aria-modal": "true",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: "quiz-card",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "quiz-error",
                style: {
                    padding: "48px",
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                        children: [
                            "Failed: ",
                            error
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        onClick: handleClose,
                        className: "quiz-btn quiz-btn--primary",
                        children: "Close"
                    })
                ]
            })
        })
    });
    if (!quizData || !quizData.quiz) return null;
    const { quiz: quiz } = quizData;
    const mappedQuiz = {
        headerTitle: quiz.quiz_card_title,
        headerBgColor: quiz.quiz_card_title_color || "#ffffff",
        questions: quiz.quiz_questions.map((q)=>({
                id: q.question_id,
                question: q.question,
                options: q.question_choices.map((choice)=>choice.choice)
            }))
    };
    const isLastQuestion = stepIndex === mappedQuiz.questions.length - 1;
    const isResultStep = stepIndex === mappedQuiz.questions.length;
    const currentQuestion = !isResultStep ? mappedQuiz.questions[stepIndex] : null;
    const selectedOption = currentQuestion ? answers[currentQuestion.id] : undefined;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "quiz-overlay",
        role: "dialog",
        "aria-modal": "true",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "quiz-card",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "quiz-header",
                    style: {
                        backgroundColor: mappedQuiz.headerBgColor
                    },
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                            className: "quiz-header__title",
                            children: mappedQuiz.headerTitle
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            className: "quiz-header__close",
                            onClick: handleClose,
                            "aria-label": "Close quiz",
                            children: "\u2715"
                        })
                    ]
                }),
                isResultStep ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $5aaa527a9472198b$export$2e2bcd8739ae039), {
                    resultData: resultData,
                    sessionId: quizData.session_id,
                    onClose: handleClose
                }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f5e83fbaec6b7c47$export$2e2bcd8739ae039), {
                    index: stepIndex,
                    question: currentQuestion,
                    selectedOption: selectedOption,
                    onSelectOption: handleSelectOption,
                    onNext: handleNext,
                    onBack: handleBack,
                    canGoBack: stepIndex > 0,
                    isLastQuestion: isLastQuestion,
                    isSubmitting: isSubmitting
                })
            ]
        })
    });
}



function $324c9cc1e22b15b7$export$2e2bcd8739ae039() {
    const [isQuizOpen, setIsQuizOpen] = (0, $6cds3.useState)(false);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                className: "quiz-trigger-btn",
                onClick: ()=>setIsQuizOpen(true),
                children: "Take the quiz now"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e6d968a76503737c$export$2e2bcd8739ae039), {
                isOpen: isQuizOpen,
                onClose: ()=>setIsQuizOpen(false)
            })
        ]
    });
}


function $a198c5b7f78064c1$var$App() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "App",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $324c9cc1e22b15b7$export$2e2bcd8739ae039), {})
    });
}
var $a198c5b7f78064c1$export$2e2bcd8739ae039 = $a198c5b7f78064c1$var$App;



const $ea833559f5a67bb4$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("3ILni")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $ea833559f5a67bb4$export$2e2bcd8739ae039 = $ea833559f5a67bb4$var$reportWebVitals;



(0, $c0e12f24d6f0ca74$export$80cba77b5b64bcd7)();
const $f25e85c08ff84b11$var$widgetDivs = document.querySelectorAll('.calque-bbys-quiz-widget');
// Inject our React App into each widget div
$f25e85c08ff84b11$var$widgetDivs.forEach((div)=>{
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(div); // Create a root for each div
    root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a198c5b7f78064c1$export$2e2bcd8739ae039), {})
    }));
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $ea833559f5a67bb4$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.js.map
